/* ==== common.jsx ==== */
/* global React */

// =====================================================
// Plasma — helpers compartidos entre todos los scripts
// (formato de moneda, iconos SVG)
//
// Declarados con `function` y `var` para que sean globales
// (Babel-standalone eval'd top-level → ✓).
// =====================================================

function fmt(n) {
  return new Intl.NumberFormat("es-AR", {
    style: "currency", currency: "ARS", maximumFractionDigits: 0,
  }).format(n);
}

/* eslint-disable no-var */
var I = {
  bag: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 11-8 0"/>
    </svg>
  ),
  search: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
    </svg>
  ),
  heart: (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 000-7.78z"/>
    </svg>
  ),
  heartOutline: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 000-7.78z"/>
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 5v14M5 12h14"/>
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6L9 17l-5-5"/>
    </svg>
  ),
  arrowRight: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M13 5l7 7-7 7"/>
    </svg>
  ),
  close: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 6L6 18M6 6l12 12"/>
    </svg>
  ),
  menu: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 6h18M3 12h18M3 18h18"/>
    </svg>
  ),
  truck: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 3h15v13H1zM16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.7" fill="currentColor"/>
    </svg>
  ),
  tiktok: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005.8 20.1a6.34 6.34 0 0010.86-4.43V8.42a8.16 8.16 0 005.05 1.72v-3.5a4.85 4.85 0 01-2.12-.96z"/>
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 7l-10 7L2 7"/>
    </svg>
  ),
  whatsapp: (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.5 14.4c-.3-.1-1.7-.8-2-1-.3-.1-.5-.1-.7.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.8-.8-1.4-1.7-1.5-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5 0-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.5c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4 0 1.4 1 2.8 1.2 3 .1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.7-.7 1.9-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.5-.3zm-5.4 6.6c-1.6 0-3.2-.4-4.5-1.2L4 21l1.3-3.4c-.9-1.4-1.3-3.1-1.3-4.7C4 7.5 7.6 4 12.1 4c2.2 0 4.2.8 5.7 2.3s2.4 3.5 2.4 5.7c0 4.4-3.7 8-8.1 8z"/>
    </svg>
  ),
  printer: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2h12v6H6z"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="8"/>
    </svg>
  ),
};

;
/* ==== visuals.jsx ==== */
/* global React */
// =====================================================
// Plasma Design — Product visuals (SVG)
// 3D-printed-feel lamps (glowing) and accessories (matte).
// =====================================================

const { Fragment } = React;

/* ---------- Shared SVG defs ---------- */
function PlasmaDefs({ id = "px" }) {
  return (
    <defs>
      {/* warm internal lamp light: pink/magenta core fading to violet */}
      <radialGradient id={`${id}-glow`} cx="50%" cy="60%" r="55%">
        <stop offset="0%" stopColor="#fce7f3" stopOpacity="0.95" />
        <stop offset="25%" stopColor="#f0abfc" stopOpacity="0.9" />
        <stop offset="55%" stopColor="#d946ef" stopOpacity="0.7" />
        <stop offset="100%" stopColor="#6d28d9" stopOpacity="0.4" />
      </radialGradient>
      {/* lamp body — translucent plastic-like, slight gradient */}
      <linearGradient id={`${id}-body`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#3d2856" stopOpacity="0.55" />
        <stop offset="50%" stopColor="#241636" stopOpacity="0.4" />
        <stop offset="100%" stopColor="#0e0a1a" stopOpacity="0.85" />
      </linearGradient>
      {/* matte 3D-printed plastic for accessories */}
      <linearGradient id={`${id}-matte`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#4a3a5f" />
        <stop offset="55%" stopColor="#322443" />
        <stop offset="100%" stopColor="#1a1228" />
      </linearGradient>
      <linearGradient id={`${id}-matte-hi`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#6b5784" />
        <stop offset="100%" stopColor="#2a1d3a" />
      </linearGradient>
      {/* horizontal print layer lines mask (subtle) */}
      <pattern id={`${id}-layers`} x="0" y="0" width="200" height="2.4" patternUnits="userSpaceOnUse">
        <rect width="200" height="2.4" fill="transparent" />
        <line x1="0" y1="1.2" x2="200" y2="1.2" stroke="#000" strokeOpacity="0.18" strokeWidth="0.5" />
      </pattern>
    </defs>
  );
}

/* ---------- LAMPS (glowing) ---------- */

// 1. Nebula — wavy organic blob lamp
function LampNebula() {
  return (
    <svg viewBox="0 0 200 200" className="lamp-glow" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="neb" />
      {/* base */}
      <ellipse cx="100" cy="178" rx="42" ry="4" fill="#000" opacity="0.5" />
      <rect x="80" y="166" width="40" height="10" rx="2" fill="url(#neb-matte)" />
      {/* body — organic wavy blob using path */}
      <path
        d="M 70 60
           C 55 75, 50 100, 60 125
           C 65 140, 78 158, 100 160
           C 122 158, 135 140, 140 125
           C 150 100, 145 75, 130 60
           C 122 50, 110 44, 100 44
           C 90 44, 78 50, 70 60 Z"
        fill="url(#neb-glow)"
      />
      {/* layer lines on body */}
      <path
        d="M 70 60
           C 55 75, 50 100, 60 125
           C 65 140, 78 158, 100 160
           C 122 158, 135 140, 140 125
           C 150 100, 145 75, 130 60
           C 122 50, 110 44, 100 44
           C 90 44, 78 50, 70 60 Z"
        fill="url(#neb-layers)"
      />
      {/* highlight rim */}
      <path
        d="M 70 60 C 78 50, 90 44, 100 44 C 110 44, 122 50, 130 60"
        stroke="rgba(255,255,255,0.35)" strokeWidth="0.8" fill="none"
      />
    </svg>
  );
}

// 2. Hex — hexagonal honeycomb cylinder lamp
function LampHex() {
  // Generate hex grid coords
  const hexes = [];
  for (let row = 0; row < 7; row++) {
    for (let col = 0; col < 5; col++) {
      const x = 64 + col * 18 + (row % 2 ? 9 : 0);
      const y = 56 + row * 14;
      if (x > 60 && x < 144) hexes.push({ x, y });
    }
  }
  return (
    <svg viewBox="0 0 200 200" className="lamp-glow" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="hex" />
      <ellipse cx="100" cy="180" rx="44" ry="4" fill="#000" opacity="0.5" />
      <rect x="78" y="166" width="44" height="12" rx="2" fill="url(#hex-matte)" />
      {/* cylinder body */}
      <rect x="58" y="44" width="84" height="124" rx="6" fill="url(#hex-glow)" />
      {/* darker overlay creating cut-outs effect */}
      <rect x="58" y="44" width="84" height="124" rx="6" fill="url(#hex-body)" opacity="0.55" />
      {/* hex cutouts (filled with glow) */}
      <g>
        {hexes.map((h, i) => (
          <polygon
            key={i}
            points={`${h.x},${h.y-5} ${h.x+5},${h.y-2.5} ${h.x+5},${h.y+2.5} ${h.x},${h.y+5} ${h.x-5},${h.y+2.5} ${h.x-5},${h.y-2.5}`}
            fill="url(#hex-glow)"
            opacity="0.95"
          />
        ))}
      </g>
      {/* top cap */}
      <ellipse cx="100" cy="44" rx="42" ry="6" fill="#2a1c3f" stroke="rgba(255,255,255,0.18)" strokeWidth="0.5" />
      {/* layer lines */}
      <rect x="58" y="44" width="84" height="124" rx="6" fill="url(#hex-layers)" />
      {/* rim highlight */}
      <rect x="58" y="44" width="84" height="124" rx="6" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="0.6" />
    </svg>
  );
}

// 3. Helix — twisted spiral column
function LampHelix() {
  // build a vertical sequence of rotated ellipses
  const layers = [];
  for (let i = 0; i < 22; i++) {
    const y = 50 + i * 5.5;
    const rot = i * 8;
    layers.push({ y, rot });
  }
  return (
    <svg viewBox="0 0 200 200" className="lamp-glow" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="hel" />
      <ellipse cx="100" cy="180" rx="42" ry="4" fill="#000" opacity="0.5" />
      <rect x="80" y="166" width="40" height="12" rx="2" fill="url(#hel-matte)" />
      {/* core column glow */}
      <rect x="74" y="46" width="52" height="124" rx="26" fill="url(#hel-glow)" />
      {/* twisted slats */}
      <g>
        {layers.map((l, i) => (
          <g key={i} transform={`rotate(${l.rot} 100 ${l.y})`}>
            <ellipse cx="100" cy={l.y} rx="32" ry="3.4" fill="#1c1230" opacity="0.92" stroke="rgba(139,92,246,0.55)" strokeWidth="0.4" />
            <ellipse cx="100" cy={l.y - 0.7} rx="32" ry="0.8" fill="rgba(255,255,255,0.18)" />
          </g>
        ))}
      </g>
      <rect x="74" y="46" width="52" height="124" rx="26" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="0.6" />
    </svg>
  );
}

// 4. Wave — stacked undulating rings
function LampWave() {
  const rings = [];
  for (let i = 0; i < 16; i++) {
    const y = 50 + i * 7.4;
    const offset = Math.sin(i * 0.6) * 6;
    rings.push({ y, offset });
  }
  return (
    <svg viewBox="0 0 200 200" className="lamp-glow" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="wav" />
      <ellipse cx="100" cy="180" rx="42" ry="4" fill="#000" opacity="0.5" />
      <rect x="80" y="166" width="40" height="12" rx="2" fill="url(#wav-matte)" />
      {/* central glow column */}
      <ellipse cx="100" cy="110" rx="34" ry="62" fill="url(#wav-glow)" />
      {/* undulating rings */}
      <g>
        {rings.map((r, i) => (
          <g key={i}>
            <ellipse cx={100 + r.offset} cy={r.y} rx="36" ry="5" fill="#1d1330" opacity="0.85" />
            <ellipse cx={100 + r.offset} cy={r.y - 1.2} rx="36" ry="1" fill="rgba(255,255,255,0.16)" />
            <ellipse cx={100 + r.offset} cy={r.y + 1.6} rx="36" ry="0.8" fill="rgba(217,70,239,0.4)" />
          </g>
        ))}
      </g>
    </svg>
  );
}

// 5. Mesh — lattice sphere
function LampMesh() {
  const meridians = [-40, -20, 0, 20, 40];
  const parallels = [-30, -10, 10, 30];
  return (
    <svg viewBox="0 0 200 200" className="lamp-glow" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="msh" />
      <ellipse cx="100" cy="182" rx="40" ry="3.5" fill="#000" opacity="0.5" />
      <rect x="86" y="160" width="28" height="14" rx="2" fill="url(#msh-matte)" />
      {/* core sphere glow */}
      <circle cx="100" cy="100" r="60" fill="url(#msh-glow)" />
      {/* sphere lattice */}
      <g stroke="rgba(28,18,48,0.95)" strokeWidth="2.2" fill="none">
        {meridians.map((m, i) => (
          <ellipse key={`mer-${i}`} cx="100" cy="100" rx={Math.abs(m * 1.4) || 60} ry="60"
                   transform={`rotate(${m * 1.4} 100 100)`}
                   opacity={m === 0 ? 0.7 : 0.55} />
        ))}
        {parallels.map((p, i) => {
          const ry = 60 * Math.cos((p * Math.PI) / 90);
          return (
            <ellipse key={`par-${i}`} cx="100" cy={100 + p * 0.95} rx="60" ry={Math.abs(ry) * 0.3 + 2} opacity="0.6" />
          );
        })}
      </g>
      {/* highlight specular */}
      <ellipse cx="78" cy="78" rx="10" ry="6" fill="rgba(255,255,255,0.18)" transform="rotate(-30 78 78)" />
      <circle cx="100" cy="100" r="60" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="0.8" />
    </svg>
  );
}

// 6. Pulse — concentric rings pillar
function LampPulse() {
  const rings = [];
  for (let i = 0; i < 28; i++) {
    rings.push({ y: 48 + i * 4.4 });
  }
  return (
    <svg viewBox="0 0 200 200" className="lamp-glow" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="pul" />
      <ellipse cx="100" cy="180" rx="42" ry="4" fill="#000" opacity="0.5" />
      <rect x="78" y="166" width="44" height="12" rx="2" fill="url(#pul-matte)" />
      {/* tapered column */}
      <path d="M 68 48 L 132 48 L 138 170 L 62 170 Z" fill="url(#pul-glow)" />
      <path d="M 68 48 L 132 48 L 138 170 L 62 170 Z" fill="url(#pul-body)" opacity="0.4" />
      {/* slat lines */}
      <g>
        {rings.map((r, i) => {
          // expand width along taper
          const t = i / rings.length;
          const halfW = 32 + t * 6;
          return (
            <g key={i}>
              <rect x={100 - halfW} y={r.y} width={halfW * 2} height="2" fill="#1c1230" opacity="0.95" />
              <rect x={100 - halfW} y={r.y - 0.4} width={halfW * 2} height="0.6" fill="rgba(255,255,255,0.18)" />
            </g>
          );
        })}
      </g>
      <path d="M 68 48 L 132 48 L 138 170 L 62 170 Z" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="0.6" />
      <ellipse cx="100" cy="48" rx="32" ry="5" fill="#2a1c3f" stroke="rgba(255,255,255,0.18)" strokeWidth="0.4" />
    </svg>
  );
}

/* ---------- ACCESSORIES (matte, non-glowing) ---------- */

// 1. Helix vase
function AccVase() {
  const slats = [];
  for (let i = 0; i < 24; i++) {
    slats.push({ y: 40 + i * 5.6, rot: i * 9 });
  }
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="vas" />
      <ellipse cx="100" cy="178" rx="40" ry="3" fill="#000" opacity="0.5" />
      {/* vase silhouette: narrow neck, wide bottom */}
      <path d="M 78 40 L 122 40 L 130 80 C 142 110, 142 140, 130 170 L 70 170 C 58 140, 58 110, 70 80 Z"
            fill="url(#vas-matte)" />
      {/* slats */}
      <g>
        {slats.map((s, i) => {
          const t = (s.y - 40) / 130;
          // width varies along profile: narrow at top, wider middle
          const w = 22 + Math.sin(t * Math.PI) * 18 + (s.y > 130 ? -2 : 0);
          return (
            <g key={i} transform={`rotate(${s.rot} 100 ${s.y})`}>
              <ellipse cx="100" cy={s.y} rx={w} ry="2.4" fill="#1d142e" opacity="0.9" />
              <ellipse cx="100" cy={s.y - 0.6} rx={w} ry="0.6" fill="rgba(255,255,255,0.1)" />
            </g>
          );
        })}
      </g>
      {/* rim highlight */}
      <ellipse cx="100" cy="40" rx="22" ry="3" fill="#3a2a55" stroke="rgba(255,255,255,0.18)" strokeWidth="0.4" />
      <path d="M 78 40 L 122 40 L 130 80 C 142 110, 142 140, 130 170 L 70 170 C 58 140, 58 110, 70 80 Z"
            fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="0.6" />
    </svg>
  );
}

// 2. Geo bowl (faceted)
function AccBowl() {
  // Faceted bowl from above-ish 3/4 view
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="bwl" />
      <ellipse cx="100" cy="170" rx="60" ry="6" fill="#000" opacity="0.5" />
      {/* outer faceted bowl */}
      <g>
        {/* generate triangular facets along the bottom half */}
        <path d="M 30 110 L 60 150 L 100 168 L 140 150 L 170 110 L 145 80 L 100 70 L 55 80 Z"
              fill="url(#bwl-matte)" />
        {/* facet lines */}
        <g stroke="#0a0612" strokeWidth="1" fill="none" opacity="0.7">
          <line x1="60" y1="150" x2="100" y2="70" />
          <line x1="140" y1="150" x2="100" y2="70" />
          <line x1="100" y1="168" x2="55" y2="80" />
          <line x1="100" y1="168" x2="145" y2="80" />
          <line x1="30" y1="110" x2="100" y2="70" />
          <line x1="170" y1="110" x2="100" y2="70" />
        </g>
        {/* highlights on left facets */}
        <path d="M 30 110 L 55 80 L 100 70 L 100 168 L 60 150 Z"
              fill="rgba(255,255,255,0.06)" />
      </g>
      {/* opening (ellipse top inside) */}
      <ellipse cx="100" cy="72" rx="56" ry="14" fill="#0a0814" stroke="rgba(255,255,255,0.15)" strokeWidth="0.6" />
      <ellipse cx="100" cy="68" rx="56" ry="14" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="0.5" />
    </svg>
  );
}

// 3. Coaster set (stack of 4)
function AccCoasters() {
  const layers = [
    { y: 100, dx: 0,  dy: 0 },
    { y: 90,  dx: -6, dy: -6 },
    { y: 80,  dx: -12, dy: -12 },
    { y: 70,  dx: -18, dy: -18 },
  ];
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="cst" />
      <ellipse cx="100" cy="170" rx="60" ry="5" fill="#000" opacity="0.5" />
      {layers.map((l, i) => (
        <g key={i} transform={`translate(${l.dx} ${l.dy})`}>
          {/* coaster body (thick disc): two ellipses stacked */}
          <ellipse cx="100" cy={l.y + 7} rx="48" ry="14" fill="#150c24" />
          <rect x="52" y={l.y} width="96" height="7" fill="url(#cst-matte-hi)" />
          <ellipse cx="100" cy={l.y} rx="48" ry="14" fill="url(#cst-matte)" />
          {/* concentric ring pattern */}
          <g fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="0.6">
            <ellipse cx="100" cy={l.y} rx="40" ry="11.5" />
            <ellipse cx="100" cy={l.y} rx="30" ry="8.5" />
            <ellipse cx="100" cy={l.y} rx="18" ry="5" />
          </g>
          <ellipse cx="100" cy={l.y} rx="48" ry="14" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="0.5" />
        </g>
      ))}
    </svg>
  );
}

// 4. Plant pot (geometric)
function AccPot() {
  // Truncated octagonal prism
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <PlasmaDefs id="pot" />
      <ellipse cx="100" cy="178" rx="48" ry="4" fill="#000" opacity="0.5" />
      {/* side faces */}
      <path d="M 56 70 L 144 70 L 152 170 L 48 170 Z" fill="url(#pot-matte)" />
      {/* facet center seams */}
      <line x1="100" y1="70" x2="100" y2="170" stroke="rgba(0,0,0,0.4)" strokeWidth="1" />
      <line x1="76" y1="70" x2="72" y2="170" stroke="rgba(255,255,255,0.06)" strokeWidth="0.6" />
      <line x1="124" y1="70" x2="128" y2="170" stroke="rgba(0,0,0,0.3)" strokeWidth="0.6" />
      {/* top opening */}
      <ellipse cx="100" cy="70" rx="44" ry="10" fill="#0c0818" stroke="rgba(255,255,255,0.18)" strokeWidth="0.5" />
      <ellipse cx="100" cy="68" rx="44" ry="10" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="0.4" />
      {/* horizontal print layer lines */}
      <path d="M 56 70 L 144 70 L 152 170 L 48 170 Z" fill="url(#pot-layers)" />
      <path d="M 56 70 L 144 70 L 152 170 L 48 170 Z" fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="0.6" />
      {/* foliage hint inside */}
      <g opacity="0.6">
        <ellipse cx="92" cy="64" rx="6" ry="2" fill="#4a3a5f" />
        <ellipse cx="106" cy="62" rx="7" ry="2" fill="#4a3a5f" />
      </g>
    </svg>
  );
}

/* ---------- Export to window ---------- */
Object.assign(window, {
  LampNebula, LampHex, LampHelix, LampWave, LampMesh, LampPulse,
  AccVase, AccBowl, AccCoasters, AccPot,
});

;
/* ==== tweaks-panel.jsx ==== */

// tweaks-panel.jsx
// Reusable Tweaks shell + form-control helpers.
//
// Owns the host protocol (listens for __activate_edit_mode / __deactivate_edit_mode,
// posts __edit_mode_available / __edit_mode_set_keys / __edit_mode_dismissed) so
// individual prototypes don't re-roll it. Ships a consistent set of controls so you
// don't hand-draw <input type="range">, segmented radios, steppers, etc.
//
// Usage (in an HTML file that loads React + Babel):
//
//   const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
//     "primaryColor": "#D97757",
//     "palette": ["#D97757", "#29261b", "#f6f4ef"],
//     "fontSize": 16,
//     "density": "regular",
//     "dark": false
//   }/*EDITMODE-END*/;
//
//   function App() {
//     const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);
//     return (
//       <div style={{ fontSize: t.fontSize, color: t.primaryColor }}>
//         Hello
//         <TweaksPanel>
//           <TweakSection label="Typography" />
//           <TweakSlider label="Font size" value={t.fontSize} min={10} max={32} unit="px"
//                        onChange={(v) => setTweak('fontSize', v)} />
//           <TweakRadio  label="Density" value={t.density}
//                        options={['compact', 'regular', 'comfy']}
//                        onChange={(v) => setTweak('density', v)} />
//           <TweakSection label="Theme" />
//           <TweakColor  label="Primary" value={t.primaryColor}
//                        options={['#D97757', '#2A6FDB', '#1F8A5B', '#7A5AE0']}
//                        onChange={(v) => setTweak('primaryColor', v)} />
//           <TweakColor  label="Palette" value={t.palette}
//                        options={[['#D97757', '#29261b', '#f6f4ef'],
//                                  ['#475569', '#0f172a', '#f1f5f9']]}
//                        onChange={(v) => setTweak('palette', v)} />
//           <TweakToggle label="Dark mode" value={t.dark}
//                        onChange={(v) => setTweak('dark', v)} />
//         </TweaksPanel>
//       </div>
//     );
//   }
//
// ─────────────────────────────────────────────────────────────────────────────

const __TWEAKS_STYLE = `
  .twk-panel{position:fixed;right:16px;bottom:16px;z-index:2147483646;width:280px;
    max-height:calc(100vh - 32px);display:flex;flex-direction:column;
    transform:scale(var(--dc-inv-zoom,1));transform-origin:bottom right;
    background:rgba(250,249,247,.78);color:#29261b;
    -webkit-backdrop-filter:blur(24px) saturate(160%);backdrop-filter:blur(24px) saturate(160%);
    border:.5px solid rgba(255,255,255,.6);border-radius:14px;
    box-shadow:0 1px 0 rgba(255,255,255,.5) inset,0 12px 40px rgba(0,0,0,.18);
    font:11.5px/1.4 ui-sans-serif,system-ui,-apple-system,sans-serif;overflow:hidden}
  .twk-hd{display:flex;align-items:center;justify-content:space-between;
    padding:10px 8px 10px 14px;cursor:move;user-select:none}
  .twk-hd b{font-size:12px;font-weight:600;letter-spacing:.01em}
  .twk-x{appearance:none;border:0;background:transparent;color:rgba(41,38,27,.55);
    width:22px;height:22px;border-radius:6px;cursor:default;font-size:13px;line-height:1}
  .twk-x:hover{background:rgba(0,0,0,.06);color:#29261b}
  .twk-body{padding:2px 14px 14px;display:flex;flex-direction:column;gap:10px;
    overflow-y:auto;overflow-x:hidden;min-height:0;
    scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.15) transparent}
  .twk-body::-webkit-scrollbar{width:8px}
  .twk-body::-webkit-scrollbar-track{background:transparent;margin:2px}
  .twk-body::-webkit-scrollbar-thumb{background:rgba(0,0,0,.15);border-radius:4px;
    border:2px solid transparent;background-clip:content-box}
  .twk-body::-webkit-scrollbar-thumb:hover{background:rgba(0,0,0,.25);
    border:2px solid transparent;background-clip:content-box}
  .twk-row{display:flex;flex-direction:column;gap:5px}
  .twk-row-h{flex-direction:row;align-items:center;justify-content:space-between;gap:10px}
  .twk-lbl{display:flex;justify-content:space-between;align-items:baseline;
    color:rgba(41,38,27,.72)}
  .twk-lbl>span:first-child{font-weight:500}
  .twk-val{color:rgba(41,38,27,.5);font-variant-numeric:tabular-nums}

  .twk-sect{font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;
    color:rgba(41,38,27,.45);padding:10px 0 0}
  .twk-sect:first-child{padding-top:0}

  .twk-field{appearance:none;box-sizing:border-box;width:100%;min-width:0;height:26px;padding:0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;
    background:rgba(255,255,255,.6);color:inherit;font:inherit;outline:none}
  .twk-field:focus{border-color:rgba(0,0,0,.25);background:rgba(255,255,255,.85)}
  select.twk-field{padding-right:22px;
    background-image:url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path fill='rgba(0,0,0,.5)' d='M0 0h10L5 6z'/></svg>");
    background-repeat:no-repeat;background-position:right 8px center}

  .twk-slider{appearance:none;-webkit-appearance:none;width:100%;height:4px;margin:6px 0;
    border-radius:999px;background:rgba(0,0,0,.12);outline:none}
  .twk-slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;
    width:14px;height:14px;border-radius:50%;background:#fff;
    border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}
  .twk-slider::-moz-range-thumb{width:14px;height:14px;border-radius:50%;
    background:#fff;border:.5px solid rgba(0,0,0,.12);box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:default}

  .twk-seg{position:relative;display:flex;padding:2px;border-radius:8px;
    background:rgba(0,0,0,.06);user-select:none}
  .twk-seg-thumb{position:absolute;top:2px;bottom:2px;border-radius:6px;
    background:rgba(255,255,255,.9);box-shadow:0 1px 2px rgba(0,0,0,.12);
    transition:left .15s cubic-bezier(.3,.7,.4,1),width .15s}
  .twk-seg.dragging .twk-seg-thumb{transition:none}
  .twk-seg button{appearance:none;position:relative;z-index:1;flex:1;border:0;
    background:transparent;color:inherit;font:inherit;font-weight:500;min-height:22px;
    border-radius:6px;cursor:default;padding:4px 6px;line-height:1.2;
    overflow-wrap:anywhere}

  .twk-toggle{position:relative;width:32px;height:18px;border:0;border-radius:999px;
    background:rgba(0,0,0,.15);transition:background .15s;cursor:default;padding:0}
  .twk-toggle[data-on="1"]{background:#34c759}
  .twk-toggle i{position:absolute;top:2px;left:2px;width:14px;height:14px;border-radius:50%;
    background:#fff;box-shadow:0 1px 2px rgba(0,0,0,.25);transition:transform .15s}
  .twk-toggle[data-on="1"] i{transform:translateX(14px)}

  .twk-num{display:flex;align-items:center;box-sizing:border-box;min-width:0;height:26px;padding:0 0 0 8px;
    border:.5px solid rgba(0,0,0,.1);border-radius:7px;background:rgba(255,255,255,.6)}
  .twk-num-lbl{font-weight:500;color:rgba(41,38,27,.6);cursor:ew-resize;
    user-select:none;padding-right:8px}
  .twk-num input{flex:1;min-width:0;height:100%;border:0;background:transparent;
    font:inherit;font-variant-numeric:tabular-nums;text-align:right;padding:0 8px 0 0;
    outline:none;color:inherit;-moz-appearance:textfield}
  .twk-num input::-webkit-inner-spin-button,.twk-num input::-webkit-outer-spin-button{
    -webkit-appearance:none;margin:0}
  .twk-num-unit{padding-right:8px;color:rgba(41,38,27,.45)}

  .twk-btn{appearance:none;height:26px;padding:0 12px;border:0;border-radius:7px;
    background:rgba(0,0,0,.78);color:#fff;font:inherit;font-weight:500;cursor:default}
  .twk-btn:hover{background:rgba(0,0,0,.88)}
  .twk-btn.secondary{background:rgba(0,0,0,.06);color:inherit}
  .twk-btn.secondary:hover{background:rgba(0,0,0,.1)}

  .twk-swatch{appearance:none;-webkit-appearance:none;width:56px;height:22px;
    border:.5px solid rgba(0,0,0,.1);border-radius:6px;padding:0;cursor:default;
    background:transparent;flex-shrink:0}
  .twk-swatch::-webkit-color-swatch-wrapper{padding:0}
  .twk-swatch::-webkit-color-swatch{border:0;border-radius:5.5px}
  .twk-swatch::-moz-color-swatch{border:0;border-radius:5.5px}

  .twk-chips{display:flex;gap:6px}
  .twk-chip{position:relative;appearance:none;flex:1;min-width:0;height:46px;
    padding:0;border:0;border-radius:6px;overflow:hidden;cursor:default;
    box-shadow:0 0 0 .5px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.06);
    transition:transform .12s cubic-bezier(.3,.7,.4,1),box-shadow .12s}
  .twk-chip:hover{transform:translateY(-1px);
    box-shadow:0 0 0 .5px rgba(0,0,0,.18),0 4px 10px rgba(0,0,0,.12)}
  .twk-chip[data-on="1"]{box-shadow:0 0 0 1.5px rgba(0,0,0,.85),
    0 2px 6px rgba(0,0,0,.15)}
  .twk-chip>span{position:absolute;top:0;bottom:0;right:0;width:34%;
    display:flex;flex-direction:column;box-shadow:-1px 0 0 rgba(0,0,0,.1)}
  .twk-chip>span>i{flex:1;box-shadow:0 -1px 0 rgba(0,0,0,.1)}
  .twk-chip>span>i:first-child{box-shadow:none}
  .twk-chip svg{position:absolute;top:6px;left:6px;width:13px;height:13px;
    filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}
`;

// ── useTweaks ───────────────────────────────────────────────────────────────
// Single source of truth for tweak values. setTweak persists via the host
// (__edit_mode_set_keys → host rewrites the EDITMODE block on disk).
function useTweaks(defaults) {
  const [values, setValues] = React.useState(defaults);
  // Accepts either setTweak('key', value) or setTweak({ key: value, ... }) so a
  // useState-style call doesn't write a "[object Object]" key into the persisted
  // JSON block.
  const setTweak = React.useCallback((keyOrEdits, val) => {
    const edits = typeof keyOrEdits === 'object' && keyOrEdits !== null
      ? keyOrEdits : { [keyOrEdits]: val };
    setValues((prev) => ({ ...prev, ...edits }));
    window.parent.postMessage({ type: '__edit_mode_set_keys', edits }, '*');
    // Same-window signal so in-page listeners (deck-stage rail thumbnails)
    // can react — the parent message only reaches the host, not peers.
    window.dispatchEvent(new CustomEvent('tweakchange', { detail: edits }));
  }, []);
  return [values, setTweak];
}

// ── TweaksPanel ─────────────────────────────────────────────────────────────
// Floating shell. Registers the protocol listener BEFORE announcing
// availability — if the announce ran first, the host's activate could land
// before our handler exists and the toolbar toggle would silently no-op.
// The close button posts __edit_mode_dismissed so the host's toolbar toggle
// flips off in lockstep; the host echoes __deactivate_edit_mode back which
// is what actually hides the panel.
function TweaksPanel({ title = 'Tweaks', children }) {
  const [open, setOpen] = React.useState(false);
  const dragRef = React.useRef(null);
  const offsetRef = React.useRef({ x: 16, y: 16 });
  const PAD = 16;

  const clampToViewport = React.useCallback(() => {
    const panel = dragRef.current;
    if (!panel) return;
    const w = panel.offsetWidth, h = panel.offsetHeight;
    const maxRight = Math.max(PAD, window.innerWidth - w - PAD);
    const maxBottom = Math.max(PAD, window.innerHeight - h - PAD);
    offsetRef.current = {
      x: Math.min(maxRight, Math.max(PAD, offsetRef.current.x)),
      y: Math.min(maxBottom, Math.max(PAD, offsetRef.current.y)),
    };
    panel.style.right = offsetRef.current.x + 'px';
    panel.style.bottom = offsetRef.current.y + 'px';
  }, []);

  React.useEffect(() => {
    if (!open) return;
    clampToViewport();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', clampToViewport);
      return () => window.removeEventListener('resize', clampToViewport);
    }
    const ro = new ResizeObserver(clampToViewport);
    ro.observe(document.documentElement);
    return () => ro.disconnect();
  }, [open, clampToViewport]);

  React.useEffect(() => {
    const onMsg = (e) => {
      const t = e?.data?.type;
      if (t === '__activate_edit_mode') setOpen(true);
      else if (t === '__deactivate_edit_mode') setOpen(false);
    };
    window.addEventListener('message', onMsg);
    window.parent.postMessage({ type: '__edit_mode_available' }, '*');
    return () => window.removeEventListener('message', onMsg);
  }, []);

  const dismiss = () => {
    setOpen(false);
    window.parent.postMessage({ type: '__edit_mode_dismissed' }, '*');
  };

  const onDragStart = (e) => {
    const panel = dragRef.current;
    if (!panel) return;
    const r = panel.getBoundingClientRect();
    const sx = e.clientX, sy = e.clientY;
    const startRight = window.innerWidth - r.right;
    const startBottom = window.innerHeight - r.bottom;
    const move = (ev) => {
      offsetRef.current = {
        x: startRight - (ev.clientX - sx),
        y: startBottom - (ev.clientY - sy),
      };
      clampToViewport();
    };
    const up = () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  };

  if (!open) return null;
  return (
    <>
      <style>{__TWEAKS_STYLE}</style>
      <div ref={dragRef} className="twk-panel" data-omelette-chrome=""
           style={{ right: offsetRef.current.x, bottom: offsetRef.current.y }}>
        <div className="twk-hd" onMouseDown={onDragStart}>
          <b>{title}</b>
          <button className="twk-x" aria-label="Close tweaks"
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={dismiss}>✕</button>
        </div>
        <div className="twk-body">
          {children}
        </div>
      </div>
    </>
  );
}

// ── Layout helpers ──────────────────────────────────────────────────────────

function TweakSection({ label, children }) {
  return (
    <>
      <div className="twk-sect">{label}</div>
      {children}
    </>
  );
}

function TweakRow({ label, value, children, inline = false }) {
  return (
    <div className={inline ? 'twk-row twk-row-h' : 'twk-row'}>
      <div className="twk-lbl">
        <span>{label}</span>
        {value != null && <span className="twk-val">{value}</span>}
      </div>
      {children}
    </div>
  );
}

// ── Controls ────────────────────────────────────────────────────────────────

function TweakSlider({ label, value, min = 0, max = 100, step = 1, unit = '', onChange }) {
  return (
    <TweakRow label={label} value={`${value}${unit}`}>
      <input type="range" className="twk-slider" min={min} max={max} step={step}
             value={value} onChange={(e) => onChange(Number(e.target.value))} />
    </TweakRow>
  );
}

function TweakToggle({ label, value, onChange }) {
  return (
    <div className="twk-row twk-row-h">
      <div className="twk-lbl"><span>{label}</span></div>
      <button type="button" className="twk-toggle" data-on={value ? '1' : '0'}
              role="switch" aria-checked={!!value}
              onClick={() => onChange(!value)}><i /></button>
    </div>
  );
}

function TweakRadio({ label, value, options, onChange }) {
  const trackRef = React.useRef(null);
  const [dragging, setDragging] = React.useState(false);
  // The active value is read by pointer-move handlers attached for the lifetime
  // of a drag — ref it so a stale closure doesn't fire onChange for every move.
  const valueRef = React.useRef(value);
  valueRef.current = value;

  // Segments wrap mid-word once per-segment width runs out. The track is
  // ~248px (280 panel − 28 body pad − 4 seg pad), each button loses 12px
  // to its own padding, and 11.5px system-ui averages ~6.3px/char — so 2
  // options fit ~16 chars each, 3 fit ~10. Past that (or >3 options), fall
  // back to a dropdown rather than wrap.
  const labelLen = (o) => String(typeof o === 'object' ? o.label : o).length;
  const maxLen = options.reduce((m, o) => Math.max(m, labelLen(o)), 0);
  const fitsAsSegments = maxLen <= ({ 2: 16, 3: 10 }[options.length] ?? 0);
  if (!fitsAsSegments) {
    // <select> emits strings — map back to the original option value so the
    // fallback stays type-preserving (numbers, booleans) like the segment path.
    const resolve = (s) => {
      const m = options.find((o) => String(typeof o === 'object' ? o.value : o) === s);
      return m === undefined ? s : typeof m === 'object' ? m.value : m;
    };
    return <TweakSelect label={label} value={value} options={options}
                        onChange={(s) => onChange(resolve(s))} />;
  }
  const opts = options.map((o) => (typeof o === 'object' ? o : { value: o, label: o }));
  const idx = Math.max(0, opts.findIndex((o) => o.value === value));
  const n = opts.length;

  const segAt = (clientX) => {
    const r = trackRef.current.getBoundingClientRect();
    const inner = r.width - 4;
    const i = Math.floor(((clientX - r.left - 2) / inner) * n);
    return opts[Math.max(0, Math.min(n - 1, i))].value;
  };

  const onPointerDown = (e) => {
    setDragging(true);
    const v0 = segAt(e.clientX);
    if (v0 !== valueRef.current) onChange(v0);
    const move = (ev) => {
      if (!trackRef.current) return;
      const v = segAt(ev.clientX);
      if (v !== valueRef.current) onChange(v);
    };
    const up = () => {
      setDragging(false);
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };

  return (
    <TweakRow label={label}>
      <div ref={trackRef} role="radiogroup" onPointerDown={onPointerDown}
           className={dragging ? 'twk-seg dragging' : 'twk-seg'}>
        <div className="twk-seg-thumb"
             style={{ left: `calc(2px + ${idx} * (100% - 4px) / ${n})`,
                      width: `calc((100% - 4px) / ${n})` }} />
        {opts.map((o) => (
          <button key={o.value} type="button" role="radio" aria-checked={o.value === value}>
            {o.label}
          </button>
        ))}
      </div>
    </TweakRow>
  );
}

function TweakSelect({ label, value, options, onChange }) {
  return (
    <TweakRow label={label}>
      <select className="twk-field" value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((o) => {
          const v = typeof o === 'object' ? o.value : o;
          const l = typeof o === 'object' ? o.label : o;
          return <option key={v} value={v}>{l}</option>;
        })}
      </select>
    </TweakRow>
  );
}

function TweakText({ label, value, placeholder, onChange }) {
  return (
    <TweakRow label={label}>
      <input className="twk-field" type="text" value={value} placeholder={placeholder}
             onChange={(e) => onChange(e.target.value)} />
    </TweakRow>
  );
}

function TweakNumber({ label, value, min, max, step = 1, unit = '', onChange }) {
  const clamp = (n) => {
    if (min != null && n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };
  const startRef = React.useRef({ x: 0, val: 0 });
  const onScrubStart = (e) => {
    e.preventDefault();
    startRef.current = { x: e.clientX, val: value };
    const decimals = (String(step).split('.')[1] || '').length;
    const move = (ev) => {
      const dx = ev.clientX - startRef.current.x;
      const raw = startRef.current.val + dx * step;
      const snapped = Math.round(raw / step) * step;
      onChange(clamp(Number(snapped.toFixed(decimals))));
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };
  return (
    <div className="twk-num">
      <span className="twk-num-lbl" onPointerDown={onScrubStart}>{label}</span>
      <input type="number" value={value} min={min} max={max} step={step}
             onChange={(e) => onChange(clamp(Number(e.target.value)))} />
      {unit && <span className="twk-num-unit">{unit}</span>}
    </div>
  );
}

// Relative-luminance contrast pick — checkmarks drawn over a swatch need to
// read on both #111 and #fafafa without per-option configuration. Hex input
// only (#rgb / #rrggbb); named or rgb()/hsl() colors fall through to "light".
function __twkIsLight(hex) {
  const h = String(hex).replace('#', '');
  const x = h.length === 3 ? h.replace(/./g, (c) => c + c) : h.padEnd(6, '0');
  const n = parseInt(x.slice(0, 6), 16);
  if (Number.isNaN(n)) return true;
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  return r * 299 + g * 587 + b * 114 > 148000;
}

const __TwkCheck = ({ light }) => (
  <svg viewBox="0 0 14 14" aria-hidden="true">
    <path d="M3 7.2 5.8 10 11 4.2" fill="none" strokeWidth="2.2"
          strokeLinecap="round" strokeLinejoin="round"
          stroke={light ? 'rgba(0,0,0,.78)' : '#fff'} />
  </svg>
);

// TweakColor — curated color/palette picker. Each option is either a single
// hex string or an array of 1-5 hex strings; the card adapts — a lone color
// renders solid, a palette renders colors[0] as the hero (left ~2/3) with the
// rest stacked in a sharp column on the right. onChange emits the
// option in the shape it was passed (string stays string, array stays array).
// Without options it falls back to the native color input for back-compat.
function TweakColor({ label, value, options, onChange }) {
  if (!options || !options.length) {
    return (
      <div className="twk-row twk-row-h">
        <div className="twk-lbl"><span>{label}</span></div>
        <input type="color" className="twk-swatch" value={value}
               onChange={(e) => onChange(e.target.value)} />
      </div>
    );
  }
  // Native <input type=color> emits lowercase hex per the HTML spec, so
  // compare case-insensitively. String() guards JSON.stringify(undefined),
  // which returns the primitive undefined (no .toLowerCase).
  const key = (o) => String(JSON.stringify(o)).toLowerCase();
  const cur = key(value);
  return (
    <TweakRow label={label}>
      <div className="twk-chips" role="radiogroup">
        {options.map((o, i) => {
          const colors = Array.isArray(o) ? o : [o];
          const [hero, ...rest] = colors;
          const sup = rest.slice(0, 4);
          const on = key(o) === cur;
          return (
            <button key={i} type="button" className="twk-chip" role="radio"
                    aria-checked={on} data-on={on ? '1' : '0'}
                    aria-label={colors.join(', ')} title={colors.join(' · ')}
                    style={{ background: hero }}
                    onClick={() => onChange(o)}>
              {sup.length > 0 && (
                <span>
                  {sup.map((c, j) => <i key={j} style={{ background: c }} />)}
                </span>
              )}
              {on && <__TwkCheck light={__twkIsLight(hero)} />}
            </button>
          );
        })}
      </div>
    </TweakRow>
  );
}

function TweakButton({ label, onClick, secondary = false }) {
  return (
    <button type="button" className={secondary ? 'twk-btn secondary' : 'twk-btn'}
            onClick={onClick}>{label}</button>
  );
}

Object.assign(window, {
  useTweaks, TweaksPanel, TweakSection, TweakRow,
  TweakSlider, TweakToggle, TweakRadio, TweakSelect,
  TweakText, TweakNumber, TweakColor, TweakButton,
});

;
/* ==== hooks.jsx ==== */
/* global React,
   LampNebula, LampHex, LampHelix, LampWave, LampMesh, LampPulse,
   AccVase, AccBowl, AccCoasters, AccPot */

// =====================================================
// Plasma — Custom hooks compartidos (Firebase, products, cart, order)
// =====================================================

const { useState, useEffect, useMemo, useCallback } = React;

// -----------------------------------------------------
// useFirebaseReady — espera a que window.PlasmaFB esté listo
// -----------------------------------------------------
function useFirebaseReady() {
  const [ready, setReady] = useState(!!window.PlasmaFB);
  useEffect(() => {
    if (window.PlasmaFB) return;
    const on = () => setReady(true);
    window.addEventListener("plasma-fb-ready", on);
    return () => window.removeEventListener("plasma-fb-ready", on);
  }, []);
  return ready;
}

// -----------------------------------------------------
// useAuth — estado del usuario y helpers de login
// -----------------------------------------------------
function useAuth() {
  const fbReady = useFirebaseReady();
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const evalClaims = useCallback(async (u, forceRefresh = false) => {
    if (!u) { setIsAdmin(false); return false; }
    try {
      const tok = await u.getIdTokenResult(forceRefresh);
      const isA = tok.claims.admin === true;
      setIsAdmin(isA);
      return isA;
    } catch {
      setIsAdmin(false);
      return false;
    }
  }, []);

  useEffect(() => {
    if (!fbReady) return;
    // Si la URL es un magic link, completarlo antes de suscribirse.
    window.PlasmaAuth.completeMagicLinkIfPresent().catch((e) => console.warn("[Auth]", e));
    const unsub = window.PlasmaAuth.onChange(async (u) => {
      setUser(u);
      setLoading(false);
      await evalClaims(u, false);
    });
    return unsub;
  }, [fbReady, evalClaims]);

  // Fuerza un refresh del ID token y re-evalúa el claim admin. Usado luego de
  // bootstrapAdmin para que el front vea el claim sin tener que re-loguear.
  const refreshClaims = useCallback(() => evalClaims(user, true), [user, evalClaims]);

  return {
    user,
    loading,
    isAdmin,
    refreshClaims,
    signInWithGoogle: () => window.PlasmaAuth.signInWithGoogle(),
    sendMagicLink: (email) => window.PlasmaAuth.sendMagicLink(email),
    signOut: () => window.PlasmaAuth.signOut(),
  };
}

// -----------------------------------------------------
// useProductUpload — sube una imagen a Storage products/{productId}/{file}.
//
// Antes de subir, redimensionamos client-side a max 1400px del lado mayor y
// re-encodeamos como JPEG calidad 0.85. Esto normaliza el peso de todas las
// fotos (los originales pueden ser 5MB, esto los baja a ~150-300 KB) y elimina
// el efecto "una imagen tarda más que otra" en la home rotativa.
// Requiere claim admin del usuario logueado.
// -----------------------------------------------------
// Compresión client-side antes de subir a Storage.
// 2000px y 0.92 calidad → fotos nítidas en pantallas grandes / retina sin
// hacer que pesen 5MB cada una. Si necesitás más, subí estos números.
const IMG_MAX_DIM = 2000;
const IMG_QUALITY = 0.92;
// Si la imagen original ya es chica Y liviana (< 600KB), no la re-encodeamos.
const IMG_SKIP_RECODE_BYTES = 600 * 1024;

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
}

async function compressImage(file) {
  // PNG con transparencia → lo dejamos como PNG. Otros formatos → JPEG.
  const preserveAlpha = file.type === "image/png";

  const img = await loadImage(file);
  const ratio = Math.min(1, IMG_MAX_DIM / Math.max(img.naturalWidth, img.naturalHeight));
  const w = Math.round(img.naturalWidth * ratio);
  const h = Math.round(img.naturalHeight * ratio);

  // Si la imagen original ya entra en los límites Y no es enorme, la subimos
  // tal cual (sin re-encodear que siempre degrada un poco).
  if (ratio === 1 && file.size <= IMG_SKIP_RECODE_BYTES) {
    return { blob: file, contentType: file.type, ext: (file.name.split(".").pop() || "jpg").toLowerCase().replace(/[^a-z0-9]/g, "") };
  }

  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d", { alpha: preserveAlpha });
  if (!preserveAlpha) {
    ctx.fillStyle = "#0a0a0f";  // match el bg de las cards para evitar bordes blancos al "aplanar" transparencias
    ctx.fillRect(0, 0, w, h);
  }
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(img, 0, 0, w, h);

  const targetType = preserveAlpha ? "image/png" : "image/jpeg";
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, targetType, IMG_QUALITY));
  return { blob, contentType: targetType, ext: preserveAlpha ? "png" : "jpg" };
}

function useProductUpload() {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const upload = useCallback(async (productId, file) => {
    if (!window.PlasmaFB) throw new Error("Firebase no está listo");
    if (!file) throw new Error("No hay archivo");
    if (!file.type?.startsWith("image/")) throw new Error("Tiene que ser una imagen");
    if (file.size > 15 * 1024 * 1024) throw new Error("La imagen original no puede pesar más de 15MB");

    setUploading(true); setProgress(0);
    try {
      const { storage, storageRef, uploadBytes, getDownloadURL } = window.PlasmaFB;
      const { blob, contentType, ext } = await compressImage(file);
      const safeId = String(productId || "tmp").replace(/[^a-z0-9-]/gi, "");
      const path = `products/${safeId}/${Date.now()}.${ext}`;
      const r = storageRef(storage, path);
      await uploadBytes(r, blob, { contentType });
      setProgress(1);
      const url = await getDownloadURL(r);
      return { url, path, originalSize: file.size, finalSize: blob.size };
    } finally {
      setUploading(false);
    }
  }, []);

  return { upload, uploading, progress };
}

// -----------------------------------------------------
// Mapeo id → visual procedural (productos sin foto)
// -----------------------------------------------------
const VISUALS = {
  neb: LampNebula, hex: LampHex, hel: LampHelix, wav: LampWave,
  msh: LampMesh, pul: LampPulse,
  vas: AccVase, bwl: AccBowl, cst: AccCoasters, pot: AccPot,
};

function attachVisual(p) {
  return p.image ? p : { ...p, visual: VISUALS[p.id] };
}

// -----------------------------------------------------
// Cache local del catálogo (stale-while-revalidate)
//
// Guardamos el último catálogo conocido (datos crudos, sin el componente
// `visual` que no es serializable) en localStorage. Al volver a entrar, lo
// mostramos AL INSTANTE y refrescamos en segundo plano cuando Firestore
// responde. Así no hay flash de "Cargando catálogo…" en visitas repetidas.
// -----------------------------------------------------
const CATALOG_CACHE_KEY = "plasma_catalog_v1";

function readCachedCatalog() {
  try {
    const raw = localStorage.getItem(CATALOG_CACHE_KEY);
    if (!raw) return [];
    const docs = JSON.parse(raw);
    return Array.isArray(docs) ? docs.map(attachVisual) : [];
  } catch (e) {
    return [];
  }
}

function writeCachedCatalog(rawDocs) {
  try {
    localStorage.setItem(CATALOG_CACHE_KEY, JSON.stringify(rawDocs));
  } catch (e) {
    /* localStorage lleno o no disponible → ignoramos, no es crítico */
  }
}

// -----------------------------------------------------
// useProducts — suscripción al catálogo en Firestore
// -----------------------------------------------------
function useProducts() {
  const fbReady = useFirebaseReady();
  // Arrancamos con el catálogo cacheado (si hay) → render instantáneo.
  const [products, setProducts] = useState(readCachedCatalog);
  const [loading, setLoading] = useState(() => products.length === 0);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fbReady) return;
    const { db, collection, query, where, onSnapshot } = window.PlasmaFB;
    const q = query(collection(db, "products"), where("active", "==", true));
    const unsub = onSnapshot(
      q,
      (snap) => {
        // Datos crudos (serializables) para cachear, ordenados igual que la UI.
        const raw = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        raw.sort((a, b) => {
          if (a.line !== b.line) return a.line === "lamps" ? -1 : 1;
          return (a.name || "").localeCompare(b.name || "");
        });
        writeCachedCatalog(raw);
        setProducts(raw.map(attachVisual));
        setLoading(false);
      },
      (err) => { setError(err); setLoading(false); },
    );
    return unsub;
  }, [fbReady]);

  return { products, loading, error };
}

// -----------------------------------------------------
// Session ID anónimo (cookie) para carrito sin login
// -----------------------------------------------------
function getOrCreateSessionId() {
  const KEY = "plasma_sid";
  let sid = localStorage.getItem(KEY);
  if (!sid) {
    sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(KEY, sid);
  }
  return sid;
}

// -----------------------------------------------------
// useCart — carrito persistido en Firestore
//
// Si hay usuario logueado: doc carts/{uid}
// Si no: doc carts/{sessionId} (sessionId guardado en localStorage)
// -----------------------------------------------------
function useCart(user) {
  const fbReady = useFirebaseReady();
  const cartId = user ? user.uid : getOrCreateSessionId();
  const [items, setItems] = useState([]);            // [{ productId, qty, swatch }]
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!fbReady) return;
    const { db, doc, onSnapshot } = window.PlasmaFB;
    const ref = doc(db, "carts", cartId);
    const unsub = onSnapshot(ref, (snap) => {
      setItems(snap.exists() ? (snap.data().items || []) : []);
      setLoading(false);
    });
    return unsub;
  }, [fbReady, cartId]);

  const persist = useCallback(async (next) => {
    if (!fbReady) return;
    const { db, doc, setDoc, serverTimestamp } = window.PlasmaFB;
    await setDoc(
      doc(db, "carts", cartId),
      { items: next, updatedAt: serverTimestamp(), uid: user?.uid ?? null, sessionId: user ? null : cartId },
      { merge: true },
    );
  }, [fbReady, cartId, user]);

  // Una "línea" del carrito se identifica por productId + selección de variantes.
  // Producto con 2 colores distintos = 2 líneas separadas (cada una con su qty).
  function variantsKey(v) {
    if (!v || typeof v !== "object") return "";
    const keys = Object.keys(v).sort();
    return keys.map((k) => k + "=" + v[k]).join("|");
  }

  const add = useCallback(async (productId, variants, produce = false) => {
    // `variants` puede ser un objeto { color: "white" } o null (legacy)
    // `produce` = el cliente acepta producirlo a pedido aunque no haya stock.
    const key = variantsKey(variants);
    const idx = items.findIndex((it) => it.productId === productId && variantsKey(it.variants) === key);
    const next = idx >= 0
      ? items.map((it, i) => i === idx ? { ...it, qty: it.qty + 1, produce: !!(it.produce || produce) } : it)
      : [...items, { productId, qty: 1, variants: variants && Object.keys(variants).length ? variants : null, swatch: null, produce: !!produce }];
    setItems(next);
    await persist(next);
  }, [items, persist]);

  const changeQty = useCallback(async (productId, delta, variants) => {
    const key = variantsKey(variants);
    const next = items
      .map((it) => (it.productId === productId && variantsKey(it.variants) === key) ? { ...it, qty: it.qty + delta } : it)
      .filter((it) => it.qty > 0);
    setItems(next);
    await persist(next);
  }, [items, persist]);

  const clear = useCallback(async () => {
    setItems([]);
    await persist([]);
  }, [persist]);

  return { items, loading, add, changeQty, clear, cartId };
}

// -----------------------------------------------------
// useShippingQuote — llama a la callable quoteShipping
// -----------------------------------------------------
function useShippingQuote() {
  const fbReady = useFirebaseReady();
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchQuote = useCallback(async ({ cp, items }) => {
    if (!fbReady) throw new Error("Firebase no está listo");
    setLoading(true); setError(null);
    try {
      const res = await window.PlasmaAPI.quoteShipping({ cp, items });
      setQuotes(res.quotes || []);
      return res.quotes;
    } catch (e) {
      setError(e); throw e;
    } finally {
      setLoading(false);
    }
  }, [fbReady]);

  return { quotes, loading, error, fetchQuote, setQuotes };
}

// -----------------------------------------------------
// useOrder — suscripción en tiempo real a una orden
// -----------------------------------------------------
// -----------------------------------------------------
// useBankSettings — lee settings/bank_transfer (público) y se suscribe live.
// Si el admin edita los datos desde el panel, todos los OrderView abiertos
// los ven cambiar al toque.
// -----------------------------------------------------
function useBankSettings() {
  const fbReady = useFirebaseReady();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!fbReady) return;
    const { db, doc, onSnapshot } = window.PlasmaFB;
    const unsub = onSnapshot(
      doc(db, "settings", "bank_transfer"),
      (snap) => { setData(snap.exists() ? snap.data() : null); setLoading(false); },
      () => { setData(null); setLoading(false); },
    );
    return unsub;
  }, [fbReady]);

  return { data, loading };
}

// -----------------------------------------------------
// useMyOrders — pedidos del usuario logueado, ordenados por fecha desc.
// Las firestore.rules permiten `read if isOwner(resource.data.uid) || isAdmin()`.
// -----------------------------------------------------
function useMyOrders(uid) {
  const fbReady = useFirebaseReady();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fbReady) return;
    if (!uid) { setOrders([]); setLoading(false); return; }
    const { db, collection, query, where, orderBy, onSnapshot } = window.PlasmaFB;
    const q = query(
      collection(db, "orders"),
      where("uid", "==", uid),
      orderBy("createdAt", "desc"),
    );
    const unsub = onSnapshot(
      q,
      (snap) => {
        setOrders(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => { setError(err); setLoading(false); },
    );
    return unsub;
  }, [fbReady, uid]);

  return { orders, loading, error };
}

function useOrder(orderId) {
  const fbReady = useFirebaseReady();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!fbReady || !orderId) return;
    const { db, doc, onSnapshot } = window.PlasmaFB;
    const unsub = onSnapshot(
      doc(db, "orders", orderId),
      (snap) => {
        if (!snap.exists()) { setError(new Error("Orden no encontrada")); setLoading(false); return; }
        setOrder({ id: snap.id, ...snap.data() });
        setLoading(false);
      },
      (err) => { setError(err); setLoading(false); },
    );
    return unsub;
  }, [fbReady, orderId]);

  return { order, loading, error };
}

// -----------------------------------------------------
// useHashRoute — routing minimalista basado en location.hash
//
// "#/"               → { name: "home" }
// "#/checkout"       → { name: "checkout" }
// "#/orden/abc123"   → { name: "order", orderId: "abc123" }
// -----------------------------------------------------
function parseHash() {
  const h = location.hash.slice(1) || "/";
  if (h === "/" || h === "") return { name: "home" };
  if (h === "/checkout") return { name: "checkout" };
  if (h === "/admin" || h.startsWith("/admin/")) return { name: "admin", sub: h.slice("/admin".length).replace(/^\//, "") };
  if (h === "/perfil") return { name: "profile" };
  if (h === "/mis-pedidos") return { name: "myOrders" };
  const m = h.match(/^\/orden\/([a-zA-Z0-9_-]+)/);
  if (m) return { name: "order", orderId: m[1] };
  return { name: "home" };
}

function useHashRoute() {
  const [route, setRoute] = useState(parseHash());
  useEffect(() => {
    const on = () => setRoute(parseHash());
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  return route;
}

function navigate(hash) {
  if (location.hash === hash) {
    // dispara hashchange manualmente para forzar refresh del route
    window.dispatchEvent(new HashChangeEvent("hashchange"));
  } else {
    location.hash = hash;
  }
  window.scrollTo({ top: 0, behavior: "smooth" });
}

;
/* ==== views.jsx ==== */
/* global React, fmt, I,
   useFirebaseReady, useAuth, useProducts, useCart, useShippingQuote, useOrder, useMyOrders, useBankSettings, navigate */

// =====================================================
// Plasma — Vistas: LoginModal, CheckoutView, OrderView
// =====================================================

const { useState: _useState, useEffect: _useEffect, useRef: _useRef, useMemo: _useMemo, memo: _memo, useCallback: _useCallback } = React;

/* Resumen lateral del checkout — memoizado para que no se re-renderice
   con cada keystroke en los inputs del form. */
const CheckoutSummary = _memo(function CheckoutSummary({ lineItems, subtotal, selectedQuote, total }) {
  return (
    <aside className="checkout__summary">
      <h3>Tu pedido</h3>
      <ul className="checkout__items">
        {lineItems.map((it) => (
          <li key={it.productId} className="checkout__item">
            <div className="checkout__item-thumb">
              {it.product.image
                ? <img src={it.product.image} alt={it.product.name} />
                : (it.product.visual ? React.createElement(it.product.visual) : null)}
            </div>
            <div>
              <p className="checkout__item-name">{it.product.name}</p>
              <p className="checkout__item-qty">× {it.qty}</p>
            </div>
            <span className="checkout__item-price">{fmt(it.lineTotal)}</span>
          </li>
        ))}
      </ul>
      <div className="checkout__totals">
        <div className="checkout__totals-row"><span>Subtotal</span><span>{fmt(subtotal)}</span></div>
        <div className="checkout__totals-row">
          <span>Envío</span>
          <span>{selectedQuote ? fmt(selectedQuote.cost) : "—"}</span>
        </div>
        <div className="checkout__totals-row checkout__totals-row--total">
          <span>Total</span><span>{fmt(total)}</span>
        </div>
      </div>
      <p className="checkout__legal">
        Hecho en Buenos Aires. Lead time típico: 5–7 días hábiles antes del despacho.
      </p>
    </aside>
  );
});

/* Field input memoizado — evita re-renderizar inputs hermanos cuando uno cambia. */
const Field = _memo(function Field({ label, name, value, onChange, error, type = "text", placeholder, className = "form__field", children }) {
  return (
    <div className={className}>
      <label className="form__label">{label}</label>
      {children || (
        <input
          type={type}
          className="form__input"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(name, e.target.value)}
        />
      )}
      {error && <p className="form__error">{error}</p>}
    </div>
  );
});

/* ===================== LoginModal ===================== */
function LoginModal({ open, onClose }) {
  const auth = useAuth();
  const [email, setEmail] = _useState("");
  const [sent, setSent] = _useState(false);
  const [busy, setBusy] = _useState(false);
  const [err, setErr] = _useState("");

  if (!open) return null;

  async function withGoogle() {
    setBusy(true); setErr("");
    try { await auth.signInWithGoogle(); onClose(); }
    catch (e) { setErr(e.message || "No se pudo iniciar sesión"); }
    finally { setBusy(false); }
  }

  async function withEmail(e) {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await auth.sendMagicLink(email);
      setSent(true);
    } catch (e) {
      setErr(e.message || "No se pudo enviar el mail");
    } finally { setBusy(false); }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="Iniciar sesión">
        <button className="modal__close icon-btn" onClick={onClose} aria-label="Cerrar">{I.close}</button>
        <h2 className="modal__title">Ingresá a Plasma</h2>
        <p className="modal__sub">Para ver tus pedidos y guardar tus datos para la próxima compra.</p>

        {sent ? (
          <div className="modal__success">
            <div className="modal__success-icon">{I.check}</div>
            <h3>Te mandamos un link a tu mail</h3>
            <p>Abrí <strong>{email}</strong> y hacé click en el botón para ingresar. El link sirve por 1 hora.</p>
          </div>
        ) : (
          <>
            <button className="btn-google btn--block" onClick={withGoogle} disabled={busy}>
              {/* "G" oficial de Google (los 4 colores) — sin red de terceros, SVG embebido. */}
              <svg className="btn-google__icon" viewBox="0 0 18 18" aria-hidden="true">
                <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4"/>
                <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.836.86-3.048.86-2.344 0-4.328-1.584-5.036-3.71H.957v2.332A8.997 8.997 0 009 18z" fill="#34A853"/>
                <path d="M3.964 10.71A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.997 8.997 0 000 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
                <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
              </svg>
              Continuar con Google
            </button>
            <div className="modal__divider"><span>o</span></div>
            <form onSubmit={withEmail} className="login-form">
              <label className="form__label">Tu email</label>
              <input
                type="email" required
                className="form__input"
                placeholder="vos@email.com"
                value={email} onChange={(e) => setEmail(e.target.value)}
                disabled={busy}
              />
              <button type="submit" className="btn btn--primary btn--block login-form__submit" disabled={busy || !email}>
                {busy ? "Enviando…" : "Enviarme un link mágico"}
              </button>
            </form>
            {err && <p className="form__error">{err}</p>}
          </>
        )}
      </div>
    </div>
  );
}

/* ===================== Helpers ===================== */
function validatePayer(p) {
  const errors = {};
  const name = (p.name || "").trim();
  if (name.length < 2 || name.length > 80) errors.name = "Ingresá tu nombre (2-80 caracteres)";
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((p.email || "").trim())) errors.email = "Email inválido";
  const phoneDigits = (p.phone || "").replace(/\D/g, "");
  if (phoneDigits.length < 8 || phoneDigits.length > 20) errors.phone = "Teléfono inválido (8-20 dígitos)";
  if (!/^\d{7,9}$/.test((p.dni || "").replace(/\D/g, ""))) errors.dni = "DNI inválido (7-9 dígitos)";
  return errors;
}
function validateAddress(a) {
  const errors = {};
  if (!a.street || a.street.trim().length < 2) errors.street = "Calle requerida (mín. 2 caracteres)";
  if (!a.number || !a.number.trim()) errors.number = "Número requerido";
  if (!a.city || a.city.trim().length < 2) errors.city = "Ciudad requerida (mín. 2 caracteres)";
  if (!a.province || a.province.trim().length < 2) errors.province = "Provincia requerida";
  if (!/^\d{4}$/.test((a.cp || "").trim())) errors.cp = "Código postal: 4 dígitos";
  return errors;
}

/* Convierte un HttpsError (callable) en un mensaje legible para el usuario. */
function formatCreateOrderError(err) {
  const base = err?.message || "Error creando la orden";
  const details = err?.details;
  if (!details || typeof details !== "object") return base;

  // Zod flatten() devuelve { formErrors: [], fieldErrors: { campo: [msg, ...] } }
  const fieldErrors = details.fieldErrors || {};
  const formErrors  = details.formErrors  || [];

  const labels = {
    items: "Carrito",
    payer: "Tus datos",
    "payer.name": "Nombre",
    "payer.email": "Email",
    "payer.phone": "Teléfono",
    "payer.dni": "DNI",
    shipping: "Envío",
    "shipping.address.street": "Calle",
    "shipping.address.number": "Número",
    "shipping.address.city": "Ciudad",
    "shipping.address.province": "Provincia",
    "shipping.address.cp": "CP",
  };

  const parts = [];
  for (const [key, msgs] of Object.entries(fieldErrors)) {
    if (!msgs || !msgs.length) continue;
    const label = labels[key] || key;
    parts.push(`${label}: ${msgs.join(", ")}`);
  }
  for (const m of formErrors) parts.push(m);

  return parts.length ? `${base} — ${parts.join(" · ")}` : base;
}

const PROVINCIAS = [
  "Buenos Aires","CABA","Catamarca","Chaco","Chubut","Córdoba","Corrientes","Entre Ríos","Formosa",
  "Jujuy","La Pampa","La Rioja","Mendoza","Misiones","Neuquén","Río Negro","Salta","San Juan",
  "San Luis","Santa Cruz","Santa Fe","Santiago del Estero","Tierra del Fuego","Tucumán",
];

/* ===================== CheckoutView ===================== */
function CheckoutView({ products, cart, user }) {
  // Hidrato los items del carrito con datos del producto (precio, peso, etc.)
  const lineItems = _useMemo(
    () => cart.items
      .map((it) => {
        const p = products.find((x) => x.id === it.productId);
        return p ? { ...it, product: p, lineTotal: p.price * it.qty } : null;
      })
      .filter(Boolean),
    [cart.items, products],
  );
  const subtotal = lineItems.reduce((s, it) => s + it.lineTotal, 0);

  const [payer, setPayer] = _useState({
    name: user?.displayName || "", email: user?.email || "",
    phone: "", dni: "",
  });
  const [address, setAddress] = _useState({
    street: "", number: "", apt: "", city: "", province: "Buenos Aires", cp: "", notes: "",
  });
  const [errors, setErrors] = _useState({});
  const ship = useShippingQuote();
  const [selectedQuote, setSelectedQuote] = _useState(null);

  const [creating, setCreating] = _useState(false);
  const [orderId, setOrderId] = _useState(null);
  const [preferenceId, setPreferenceId] = _useState(null);
  const [createError, setCreateError] = _useState("");
  const [paymentMethod, setPaymentMethod] = _useState("mercadopago");  // "mercadopago" | "transfer"

  const total = subtotal + (selectedQuote?.cost || 0);

  function setPayerField(k, v) { setPayer((p) => ({ ...p, [k]: v })); }
  function setAddressField(k, v) { setAddress((p) => ({ ...p, [k]: v })); }

  async function handleQuote() {
    const e = { ...validateAddress(address) };
    setErrors(e);
    if (Object.keys(e).length) return;
    try {
      await ship.fetchQuote({
        cp: address.cp.trim(),
        items: cart.items.map((it) => ({ productId: it.productId, qty: it.qty })),
      });
      setSelectedQuote(null);
    } catch (err) {
      setErrors({ ...e, _shipping: err.message || "No se pudo cotizar el envío" });
    }
  }

  async function handleCreateOrder() {
    const ePayer = validatePayer(payer);
    const eAddr = validateAddress(address);
    const all = { ...ePayer, ...eAddr };
    if (!selectedQuote) all._shipping = "Elegí una opción de envío";

    // Sanitizo los items del carrito por si Firestore guardó qty como string
    // o algún item quedó sin productId (datos viejos antes de migrar el schema).
    const cleanItems = cart.items
      .map((it) => {
        const productId = String(it.productId || "").trim();
        const qty = Number(it.qty);
        if (!productId || !Number.isInteger(qty) || qty < 1 || qty > 20) return null;
        const item = { productId, qty };
        if (typeof it.swatch === "string" && it.swatch.trim()) {
          item.swatch = it.swatch.trim();
        }
        // Selección de variantes (color, bombilla, etc) → backend la usa para
        // calcular el priceDelta y guardar el label en la orden.
        if (it.variants && typeof it.variants === "object" && Object.keys(it.variants).length) {
          const variants = {};
          for (const [k, v] of Object.entries(it.variants)) {
            if (typeof k === "string" && typeof v === "string" && k && v) variants[k] = v;
          }
          if (Object.keys(variants).length) item.variants = variants;
        }
        if (it.produce) item.produce = true;
        return item;
      })
      .filter(Boolean);

    if (cleanItems.length === 0) all._shipping = "Tu carrito no tiene items válidos";

    setErrors(all);
    if (Object.keys(all).length) return;

    // Sanitizo el address: trim global + opcionales sólo si tienen contenido.
    const shippingAddress = {
      street: address.street.trim(),
      number: address.number.trim(),
      city: address.city.trim(),
      province: address.province.trim(),
      cp: address.cp.trim(),
    };
    const apt   = address.apt.trim();
    const notes = address.notes.trim();
    if (apt)   shippingAddress.apt   = apt;
    if (notes) shippingAddress.notes = notes.slice(0, 280);

    setCreating(true); setCreateError("");
    try {
      const res = await window.PlasmaAPI.createOrder({
        items: cleanItems,
        payer: {
          name: payer.name.trim().slice(0, 80),
          email: payer.email.trim(),
          phone: payer.phone.replace(/\D/g, "").slice(0, 20),
          dni: payer.dni.replace(/\D/g, ""),
        },
        shipping: {
          carrier: selectedQuote.carrier,
          service: selectedQuote.service,
          cost: Number(selectedQuote.cost) || 0,
          address: shippingAddress,
        },
        paymentMethod,
      });
      setOrderId(res.orderId);
      if (res.paymentMethod === "transfer") {
        // PRIMERO navego (cambio de vista instantáneo), DESPUÉS limpio el carrito
        // en background. Si lo hiciéramos al revés, el cart.clear() vacía los items
        // mientras seguimos en /checkout → la vista parpadea "Tu carrito está vacío"
        // por unos ms antes de que la URL cambie a /orden.
        navigate("#/orden/" + res.orderId);
        cart.clear().catch(() => {});
      } else if (res.initPoint) {
        // Mercado Pago: redirigimos a Checkout Pro. El Brick embebido sigue
        // disponible (setPreferenceId mounting más abajo) pero hoy MP rechaza
        // CORS en /v1/card_tokens para esta cuenta, así que el flow embebido
        // no llega a tokenizar la tarjeta. Checkout Pro corre dentro del
        // dominio mercadopago.com.ar, no tiene problema, y al finalizar
        // redirige a back_urls.success → /orden/{orderId}?status=success.
        // Limpio el carrito antes para que la pestaña que vuelva (o si el
        // user vuelve al sitio) no muestre los mismos items.
        cart.clear().catch(() => {});
        window.location.href = res.initPoint;
        return;
      } else {
        // Fallback: si el backend no devolvió initPoint (legacy), montamos el
        // Brick embebido. Hoy requiere que MP habilite CORS para el dominio.
        setPreferenceId(res.preferenceId);
      }
    } catch (err) {
      console.error("[createOrder] error", err);
      setCreateError(formatCreateOrderError(err));
    } finally { setCreating(false); }
  }

  // Mount Bricks cuando hay preferenceId
  _useEffect(() => {
    if (!preferenceId) return;
    let cancelled = false;
    (async () => {
      try {
        window.PlasmaCheckout.init(window.PlasmaMP.publicKey);
        await window.PlasmaCheckout.mountPaymentBrick("plasma-payment-brick", {
          preferenceId,
          amount: total,
          payer: { email: payer.email },
          onSubmit: async ({ formData, selectedPaymentMethod } = {}) => {
            console.log("[Brick submit]", { selectedPaymentMethod, formData });
            navigate(`#/orden/${orderId}`);
          },
          onError: (e) => {
            console.error("[Brick error]", e);
            console.error("[Brick error detail]", JSON.stringify(e, Object.getOwnPropertyNames(e || {}), 2));
          },
        });
      } catch (e) {
        if (!cancelled) setCreateError(e.message || "No se pudo cargar el formulario de pago");
      }
    })();
    return () => { cancelled = true; window.PlasmaCheckout.unmount(); };
  }, [preferenceId, total, orderId, payer.email]);

  if (lineItems.length === 0) {
    return (
      <div className="checkout shell">
        <div className="checkout__empty">
          <h1>Tu carrito está vacío</h1>
          <p>Agregá algo lindo antes de pagar.</p>
          <button className="btn btn--primary" onClick={() => navigate("#/")}>Volver a la tienda</button>
        </div>
      </div>
    );
  }

  return (
    <div className="checkout shell">
      <div className="checkout__head">
        <button className="checkout__back" onClick={() => navigate("#/")}>← Seguir comprando</button>
        <h1 className="checkout__title">Finalizar compra</h1>
      </div>

      <div className="checkout__grid">
        <div className="checkout__main">

          {/* === 1. Contacto === */}
          <section className="checkout__section">
            <header className="checkout__section-head">
              <span className="checkout__step">1</span>
              <h2>Tus datos</h2>
            </header>
            <div className="form__row">
              <div className="form__field">
                <label className="form__label">Nombre y apellido *</label>
                <input className="form__input" value={payer.name} onChange={(e) => setPayerField("name", e.target.value)} />
                {errors.name && <p className="form__error">{errors.name}</p>}
              </div>
              <div className="form__field">
                <label className="form__label">Email *</label>
                <input type="email" className="form__input" value={payer.email} onChange={(e) => setPayerField("email", e.target.value)} />
                {errors.email && <p className="form__error">{errors.email}</p>}
              </div>
            </div>
            <div className="form__row">
              <div className="form__field">
                <label className="form__label">Celular *</label>
                <input className="form__input" placeholder="11 4040 4040" value={payer.phone} onChange={(e) => setPayerField("phone", e.target.value)} />
                {errors.phone && <p className="form__error">{errors.phone}</p>}
              </div>
              <div className="form__field">
                <label className="form__label">DNI *</label>
                <input className="form__input" placeholder="30123456" value={payer.dni} onChange={(e) => setPayerField("dni", e.target.value)} />
                {errors.dni && <p className="form__error">{errors.dni}</p>}
              </div>
            </div>
          </section>

          {/* === 2. Envío === */}
          <section className="checkout__section">
            <header className="checkout__section-head">
              <span className="checkout__step">2</span>
              <h2>Envío</h2>
            </header>
            <div className="form__row">
              <div className="form__field form__field--grow">
                <label className="form__label">Calle *</label>
                <input className="form__input" value={address.street} onChange={(e) => setAddressField("street", e.target.value)} />
                {errors.street && <p className="form__error">{errors.street}</p>}
              </div>
              <div className="form__field form__field--narrow">
                <label className="form__label">Número *</label>
                <input className="form__input" value={address.number} onChange={(e) => setAddressField("number", e.target.value)} />
                {errors.number && <p className="form__error">{errors.number}</p>}
              </div>
              <div className="form__field form__field--narrow">
                <label className="form__label">Depto</label>
                <input className="form__input" value={address.apt} onChange={(e) => setAddressField("apt", e.target.value)} />
              </div>
            </div>
            <div className="form__row">
              <div className="form__field form__field--grow">
                <label className="form__label">Ciudad *</label>
                <input className="form__input" value={address.city} onChange={(e) => setAddressField("city", e.target.value)} />
                {errors.city && <p className="form__error">{errors.city}</p>}
              </div>
              <div className="form__field">
                <label className="form__label">Provincia *</label>
                <select className="form__input" value={address.province} onChange={(e) => setAddressField("province", e.target.value)}>
                  {PROVINCIAS.map((p) => <option key={p} value={p}>{p}</option>)}
                </select>
              </div>
              <div className="form__field form__field--narrow">
                <label className="form__label">CP *</label>
                <input className="form__input" placeholder="1414" value={address.cp} onChange={(e) => setAddressField("cp", e.target.value)} />
                {errors.cp && <p className="form__error">{errors.cp}</p>}
              </div>
            </div>

            <button
              className="btn btn--ghost btn--block"
              onClick={handleQuote}
              disabled={ship.loading}
            >
              {ship.loading ? "Cotizando…" : (ship.quotes.length ? "Recotizar envío" : "Cotizar envío")}
            </button>

            {errors._shipping && <p className="form__error">{errors._shipping}</p>}

            {ship.quotes.length > 0 && (
              <ul className="quotes">
                {ship.quotes.map((q, i) => (
                  <li key={i}>
                    <label className={"quote " + (selectedQuote === q ? "quote--selected" : "")}>
                      <input type="radio" name="shipping" checked={selectedQuote === q} onChange={() => setSelectedQuote(q)} />
                      <div className="quote__body">
                        <p className="quote__name">
                          {q.carrier === "pickup"
                            ? <>Retiro en taller · {q.meta?.location || "Caseros, Zona Oeste"}</>
                            : <>
                                {q.carrier === "correo_argentino" ? "Correo Argentino" : "Mercado Envíos"}
                                {" · "}
                                {q.service === "domicilio" ? "A domicilio" : "A sucursal"}
                              </>}
                        </p>
                        <p className="quote__eta">
                          {q.carrier === "pickup"
                            ? "Coordinamos el retiro por WhatsApp"
                            : `${q.eta_days.min}–${q.eta_days.max} días hábiles`}
                        </p>
                      </div>
                      <span className="quote__price">{q.cost > 0 ? fmt(q.cost) : "Gratis"}</span>
                    </label>
                  </li>
                ))}
              </ul>
            )}
          </section>

          {/* === 3. Pago === */}
          <section className="checkout__section">
            <header className="checkout__section-head">
              <span className="checkout__step">3</span>
              <h2>Pago</h2>
            </header>

            {!preferenceId ? (
              <>
                <p className="checkout__help">Completá los datos y elegí un envío para habilitar el pago.</p>

                <ul className="paymethods">
                  <li>
                    <label className={"paymethod " + (paymentMethod === "mercadopago" ? "paymethod--selected" : "")}>
                      <input
                        type="radio" name="paymethod" value="mercadopago"
                        checked={paymentMethod === "mercadopago"}
                        onChange={() => setPaymentMethod("mercadopago")}
                      />
                      <div className="paymethod__body">
                        <div className="paymethod__head">
                          {/* Logo OFICIAL de Mercado Pago — Brand Guide 2025, versión
                              digital/RGB color horizontal. Incluye el wordmark, así
                              que el title de al lado dice solo "Pago seguro" (no duplica). */}
                          <img
                            src="img/brands/mercado-pago.png"
                            alt="Mercado Pago"
                            className="paymethod__logo paymethod__logo--mp"
                            width="100"
                            height="40"
                          />
                          <span className="paymethod__title">Pago seguro online</span>
                        </div>
                        <p className="paymethod__sub">Todos los medios de pago: tarjetas de crédito, débito, dinero en cuenta, Pago Fácil, Rapipago y transferencias por CVU.</p>
                      </div>
                    </label>
                  </li>
                  <li>
                    <label className={"paymethod " + (paymentMethod === "transfer" ? "paymethod--selected" : "")}>
                      <input
                        type="radio" name="paymethod" value="transfer"
                        checked={paymentMethod === "transfer"}
                        onChange={() => setPaymentMethod("transfer")}
                      />
                      <div className="paymethod__body">
                        <div className="paymethod__head">
                          <span className="paymethod__icon" aria-hidden="true">🏦</span>
                          <span className="paymethod__title">Transferencia bancaria</span>
                        </div>
                        <p className="paymethod__sub">Te enviamos los datos por mail. El pedido se envía una vez confirmado el ingreso.</p>
                      </div>
                    </label>
                  </li>
                </ul>

                <button
                  className="btn btn--primary btn--block"
                  onClick={handleCreateOrder}
                  disabled={creating || !selectedQuote}
                >
                  {creating
                    ? "Creando orden…"
                    : (paymentMethod === "transfer" ? "Confirmar pedido" : "Continuar al pago")}
                </button>
                {createError && <p className="form__error">{createError}</p>}
              </>
            ) : (
              <div id="plasma-payment-brick" />
            )}
          </section>
        </div>

        <CheckoutSummary
          lineItems={lineItems}
          subtotal={subtotal}
          selectedQuote={selectedQuote}
          total={total}
        />
      </div>
    </div>
  );
}

/* ===================== OrderView ===================== */
function OrderView({ orderId }) {
  const { order, loading, error } = useOrder(orderId);

  if (loading) return <div className="order shell"><p>Cargando…</p></div>;
  if (error) return (
    <div className="order shell">
      <h1>No encontramos tu orden</h1>
      <p>{error.message}</p>
      <button className="btn btn--ghost" onClick={() => navigate("#/")}>Volver al inicio</button>
    </div>
  );

  const statusLabel = {
    pending: "Esperando pago",
    paid: "Pago confirmado",
    in_production: "En producción",
    shipped: "Despachado",
    delivered: "Entregado",
    cancelled: "Cancelado",
  }[order.status] || order.status;

  const steps = ["pending", "paid", "in_production", "shipped", "delivered"];
  const stepIdx = steps.indexOf(order.status);

  return (
    <div className="order shell">
      <div className="order__head">
        <p className="order__eyebrow">Pedido #{order.id.slice(0, 8).toUpperCase()}</p>
        <h1 className="order__status">{statusLabel}</h1>
      </div>

      <div className="order__progress" aria-label="Estado del pedido">
        {steps.map((s, i) => (
          <div key={s} className={"order__step " + (i <= stepIdx ? "order__step--done" : "")}>
            <span className="order__step-dot">{i < stepIdx ? I.check : i + 1}</span>
            <span className="order__step-label">{({
              pending: "Pago",
              paid: "Confirmado",
              in_production: "Imprimiendo",
              shipped: "En camino",
              delivered: "Entregado",
            })[s]}</span>
          </div>
        ))}
      </div>

      {order.shipping?.tracking && (
        <div className="order__tracking">
          <p><strong>Seguimiento:</strong> {order.shipping.tracking}</p>
          {order.shipping.label_url && (
            <a className="btn btn--ghost btn--small" href={order.shipping.label_url} target="_blank" rel="noopener">
              Ver etiqueta
            </a>
          )}
        </div>
      )}

      {order.payment?.provider === "transfer" && order.payment.status === "awaiting_transfer" && (
        <TransferInstructions total={order.total} orderId={order.id} />
      )}

      <div className="order__detail">
        <h3>Detalle</h3>
        <ul className="order__items">
          {order.items.map((it, i) => (
            <li key={i}>
              <span>{it.name} × {it.qty}</span>
              <span>{fmt(it.unit_price * it.qty)}</span>
            </li>
          ))}
        </ul>
        <div className="order__totals">
          <div><span>Subtotal</span><span>{fmt(order.subtotal)}</span></div>
          <div><span>Envío ({order.shipping?.carrier === "correo_argentino" ? "Correo Argentino" : "Mercado Envíos"})</span><span>{fmt(order.shipping_cost)}</span></div>
          <div className="order__totals-total"><span>Total</span><span>{fmt(order.total)}</span></div>
        </div>
        <div className="order__shipping">
          <h4>Enviamos a</h4>
          <p>
            {order.shipping.address.street} {order.shipping.address.number}
            {order.shipping.address.apt ? `, ${order.shipping.address.apt}` : ""}
            <br />
            {order.shipping.address.city}, {order.shipping.address.province} ({order.shipping.address.cp})
          </p>
        </div>
      </div>

      <button className="btn btn--ghost" onClick={() => navigate("#/")}>Volver al inicio</button>
    </div>
  );
}

/* ===================== TransferInstructions =====================
   Bloque con los datos bancarios. Lee `settings/bank_transfer` desde Firestore
   vía useBankSettings (suscripción live, refresca solo si el admin edita).
   Cada campo es copiable con un click. Tiene un fallback hardcodeado para que
   los datos se vean aunque todavía no exista el doc en Firestore. */
const BANK_FALLBACK = {
  bank:   "Mercado Pago",
  holder: "Nia Sanchez Huck",
  cuit:   "20-42587652-0",
  cbu:    "0000003100055059457628",
  alias:  "plasma.design",
  email:  "info@plasma-design.com",
};

function TransferInstructions({ total, orderId }) {
  const { data, loading } = useBankSettings();
  const [copiedKey, setCopiedKey] = _useState(null);

  function copy(key, value) {
    if (!value) return;
    navigator.clipboard?.writeText(value).then(() => {
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(null), 1400);
    });
  }

  // Merge: Firestore manda, BANK_FALLBACK rellena los campos vacíos. Si los
  // datos guardados en Firestore son los emails viejos (gmail), los aplastamos
  // con el fallback nuevo (info@plasma-design.com).
  const eff = { ...BANK_FALLBACK, ...(data || {}) };
  if (eff.email === "plasma.design.3d@gmail.com") eff.email = BANK_FALLBACK.email;

  const shortId = orderId.slice(0, 8).toUpperCase();
  const emailTo = eff.email || BANK_FALLBACK.email;

  // Auto-detección CVU vs CBU: los CVU de billeteras virtuales (Mercado Pago,
  // Ualá, Brubank, etc) empiezan con `0000` (los CBU bancarios reales no).
  const cbuVal = (eff.cbu || "").trim();
  const isCVU = /^0000/.test(cbuVal);
  const cbuLabel = !cbuVal ? "CBU / CVU" : isCVU ? "CVU" : "CBU";

  const rows = [
    { key: "bank",   label: "Banco",     value: eff.bank   || "—" },
    { key: "holder", label: "Titular",   value: eff.holder || "—" },
    { key: "cuit",   label: "CUIT/CUIL", value: eff.cuit   || "—" },
    { key: "cbu",    label: cbuLabel,    value: cbuVal     || "—" },
    { key: "alias",  label: "Alias",     value: eff.alias  || "—" },
  ];

  return (
    <div className="order__transfer">
      <div className="order__transfer-head">
        <h3>Datos para transferir</h3>
        <div className="order__transfer-amount">
          <span>Monto</span>
          <strong>{fmt(total)}</strong>
        </div>
      </div>

      <p className="order__transfer-intro">
        Transferí a la cuenta de abajo y mandanos el comprobante a{" "}
        <a className="order__transfer-mail" href={"mailto:" + emailTo}>{emailTo}</a>{" "}
        con tu número de pedido <strong>#{shortId}</strong>.
      </p>

      <div className="order__transfer-card">
        {rows.map((r, i) => (
          <button
            key={r.key}
            type="button"
            className="order__transfer-line"
            onClick={() => copy(r.key, r.value !== "—" ? r.value : "")}
            disabled={r.value === "—"}
            aria-label={`Copiar ${r.label}`}
            title={r.value !== "—" ? "Click para copiar" : ""}
            data-last={i === rows.length - 1 ? "true" : undefined}
          >
            <span className="order__transfer-line-label">{r.label}</span>
            <strong className="order__transfer-line-value">{r.value}</strong>
            <span className="order__transfer-line-icon" aria-hidden="true">
              {copiedKey === r.key ? "✓" : "⧉"}
            </span>
          </button>
        ))}
      </div>

      {eff.notes && (
        <p className="order__transfer-notes">{eff.notes}</p>
      )}
      <p className="order__transfer-footer">
        En cuanto confirmemos el ingreso pasamos el pedido a <strong>Pago confirmado</strong> y se envía.
      </p>
    </div>
  );
}

/* ===================== ProfileView =====================
   Placeholder. El día que armemos perfil real (cambiar nombre, direcciones
   guardadas, métodos de pago tokenizados) reemplazamos el cuerpo. */
function ProfileView({ user }) {
  if (!user) {
    return (
      <div className="account shell">
        <h1>Mi perfil</h1>
        <p>Necesitás iniciar sesión para ver tu perfil.</p>
        <button className="btn btn--primary" onClick={() => navigate("#/")}>Volver al inicio</button>
      </div>
    );
  }
  return (
    <div className="account shell">
      <h1>Mi perfil</h1>
      <p style={{ color: "var(--fg-3)" }}>Sesión iniciada como <strong>{user.email}</strong>.</p>
      <div className="account__card">
        <div className="account__row"><span>Nombre</span><strong>{user.displayName || "—"}</strong></div>
        <div className="account__row"><span>Email</span><strong>{user.email}</strong></div>
        <div className="account__row"><span>UID</span><code style={{ fontSize: 12 }}>{user.uid}</code></div>
      </div>
      <p style={{ color: "var(--fg-3)", fontSize: 13, marginTop: 16 }}>
        Editar perfil viene pronto. Por ahora podés ver tu historial de pedidos.
      </p>
      <div style={{ display: "flex", gap: 12, marginTop: 16 }}>
        <button className="btn btn--primary" onClick={() => navigate("#/mis-pedidos")}>Mis pedidos</button>
        <button className="btn btn--ghost" onClick={() => navigate("#/")}>Volver al inicio</button>
      </div>
    </div>
  );
}

/* ===================== MyOrdersView =====================
   Lista de pedidos del usuario logueado, live-suscrita vía useMyOrders. */
function MyOrdersView({ user }) {
  if (!user) {
    return (
      <div className="account shell">
        <h1>Mis pedidos</h1>
        <p>Necesitás iniciar sesión para ver tus pedidos.</p>
        <button className="btn btn--primary" onClick={() => navigate("#/")}>Volver al inicio</button>
      </div>
    );
  }
  const { orders, loading, error } = useMyOrders(user.uid);

  const statusLabel = {
    pending: "Esperando pago",
    paid: "Pago confirmado",
    in_production: "En producción",
    shipped: "Despachado",
    delivered: "Entregado",
    cancelled: "Cancelado",
  };

  return (
    <div className="account shell">
      <h1>Mis pedidos</h1>
      {loading && <p>Cargando…</p>}
      {error && <p className="form__error">{error.message || "No se pudieron cargar"}</p>}
      {!loading && !error && orders.length === 0 && (
        <>
          <p style={{ color: "var(--fg-3)" }}>Todavía no tenés pedidos.</p>
          <button className="btn btn--primary" onClick={() => navigate("#/")}>Explorar la colección</button>
        </>
      )}
      <ul className="myorders">
        {orders.map((o) => (
          <li key={o.id} className="myorders__item" onClick={() => navigate("#/orden/" + o.id)}>
            <div>
              <p className="myorders__id">#{o.id.slice(0, 8).toUpperCase()}</p>
              <p className="myorders__date">{o.createdAt?.toDate ? o.createdAt.toDate().toLocaleString("es-AR", { dateStyle: "short", timeStyle: "short" }) : "—"}</p>
            </div>
            <div className="myorders__items">
              {(o.items || []).map((it, i) => <div key={i}>{it.qty}× {it.name}</div>)}
            </div>
            <div className="myorders__total"><strong>{fmt(o.total || 0)}</strong></div>
            <div><span className={"admin-status admin-status--" + o.status}>{statusLabel[o.status] || o.status}</span></div>
          </li>
        ))}
      </ul>
    </div>
  );
}

;
/* ==== admin.jsx ==== */
/* global React, fmt, I, navigate, useProductUpload */

// =====================================================
// Plasma — Panel admin (dashboard dark / liquid glass)
//
// Ruta: #/admin (requiere user con custom claim admin=true)
//
// El panel está construido sobre un único fetch de pedidos (PlasmaAPI.admin
// .listOrders, que ahora devuelve campos ricos) del que se derivan todas las
// vistas: Inicio, Pedidos, Envíos, Clientes y Reportes. Productos y Ajustes
// usan los callables de catálogo / settings de siempre.
//
// Todo lo del dashboard va prefijado Adm* / ADM_ para no chocar con los
// globals de la tienda (I, fmt, Card, etc.) — el bundle concatena todos los
// .jsx en un solo scope.
// =====================================================

const { useState: _aUseState, useEffect: _aUseEffect, useMemo: _aUseMemo, useCallback: _aUseCallback } = React;

const EMPTY_PRODUCT = {
  id: "",
  line: "lamps",
  name: "",
  artist: "",
  subtitle: "",
  price: 0,
  desc: "",
  image: "",
  badge: "",
  swatches: [],
  variants: [],   // [{ id, label, kind: 'color'|'option', options: [{id, label, hex?, images?, priceDelta?}] }]
  weight_g: 0,
  dims_cm: { l: 0, w: 0, h: 0 },
  stock_mode: "on_demand",
  stock: {},  // { "color=white|bombilla=rgb-ir": 5 }
  lead_days: 7,
  active: true,
  promo_active: false,
  promo_price: 0,
  promo_label: "",
};

/** Slugify simple para generar IDs de grupos/opciones desde labels. */
function slugify(s) {
  return String(s || "")
    .toLowerCase()
    .normalize("NFD").replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 40);
}

/* =====================================================================
   DASHBOARD — design system (status, helpers, icons)
   ===================================================================== */

// Estados reales del backend, con etiqueta en español y colores del diseño.
const ADM_STATUS = {
  pending:       { label: "Pendiente",      dot: "#CDC7DC", text: "#E8E2F5", bg: "rgba(255,255,255,.06)", order: 0,  glow: "rgba(255,255,255,.25)" },
  paid:          { label: "Pagado",         dot: "#FBBF24", text: "#FCD96A", bg: "rgba(251,191,36,.10)",  order: 1,  glow: "rgba(251,191,36,.45)" },
  in_production: { label: "En preparación", dot: "#38BDF8", text: "#7DD3FC", bg: "rgba(56,189,248,.10)",  order: 2,  glow: "rgba(56,189,248,.45)" },
  shipped:       { label: "Enviado",        dot: "#C084FC", text: "#DDB6FF", bg: "rgba(192,132,252,.13)", order: 3,  glow: "rgba(192,132,252,.5)" },
  delivered:     { label: "Entregado",      dot: "#4ADE80", text: "#86EFAC", bg: "rgba(74,222,128,.10)",  order: 4,  glow: "rgba(74,222,128,.4)" },
  cancelled:     { label: "Cancelado",      dot: "#F87171", text: "#FCA5A5", bg: "rgba(248,113,113,.10)", order: -1, glow: "rgba(248,113,113,.4)" },
};

const ADM_STATUS_FLOW = ["pending", "paid", "in_production", "shipped", "delivered"];

const ADM_NEXT_STATUS = {
  pending: "paid",
  paid: "in_production",
  in_production: "shipped",
  shipped: "delivered",
};

const ADM_NEXT_LABEL = {
  pending: "Marcar como pagado",
  paid: "Pasar a preparación",
  in_production: "Marcar como enviado",
  shipped: "Marcar como entregado",
};

const ADM_SECTION_LABELS = {
  inicio: "Inicio", pedidos: "Pedidos", envios: "Envíos",
  productos: "Productos", clientes: "Clientes", reportes: "Reportes", ajustes: "Ajustes",
};

function fmtARS(n) { return "$" + Number(n || 0).toLocaleString("es-AR"); }

function admFmtDate(ms, opts = {}) {
  if (!ms) return "—";
  const d = new Date(ms);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  const diff = Math.floor((now - d) / 86400000);
  if (opts.relative) {
    if (sameDay) return "Hoy · " + d.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" });
    if (diff === 1) return "Ayer · " + d.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" });
    if (diff >= 0 && diff < 7) return `Hace ${diff} d`;
  }
  return d.toLocaleDateString("es-AR", { day: "2-digit", month: "short" }) +
    " · " + d.toLocaleTimeString("es-AR", { hour: "2-digit", minute: "2-digit" });
}

function admIsToday(ms) {
  if (!ms) return false;
  return new Date(ms).toDateString() === new Date().toDateString();
}

const ADM_PAID_LIKE = ["paid", "in_production", "shipped", "delivered"];

/** Normaliza el pedido crudo del backend a la forma que consume el dashboard. */
function admNormalizeOrder(o) {
  const sh = o.shipping || {};
  const addr = sh.address || {};
  const carrierLabel = sh.carrier === "correo_argentino" ? "Correo Argentino"
    : sh.carrier === "mercado_envios" ? "Mercado Envíos"
    : sh.carrier === "pickup" ? "Retiro en taller" : (sh.carrier || "—");
  const serviceLabel = sh.service === "domicilio" ? "a domicilio"
    : sh.service === "sucursal" ? "a sucursal"
    : sh.service === "retiro" ? "Caseros, Zona Oeste" : "";
  const method = serviceLabel ? `${carrierLabel} — ${serviceLabel}` : carrierLabel;
  const pay = o.payment || {};
  const payMethod = pay.provider === "mercadopago" ? "Mercado Pago"
    : pay.provider === "transfer" ? "Transferencia" : (pay.provider || "—");
  const paidLike = ADM_PAID_LIKE.includes(o.status);
  const payPaid = paidLike || pay.status === "approved";
  const street = [addr.street, addr.number].filter(Boolean).join(" ");
  const addressLine = [street, addr.apt].filter(Boolean).join(", ");
  return {
    id: o.id,
    status: o.status,
    date: o.createdAt || null,
    total: o.total || 0,
    subtotal: o.subtotal || 0,
    shipping_cost: o.shipping_cost || 0,
    customer: { name: o.guest?.name || "Sin nombre", email: o.guest?.email || "", phone: o.guest?.phone || "" },
    payment: { method: payMethod, paid: payPaid, rawStatus: pay.status || "" },
    items: (o.items || []).map((it) => ({
      name: it.name || "Producto",
      qty: it.qty || 1,
      unit_price: it.unit_price || 0,
      variant: it.variant_label || "",
      productId: it.productId || "",
      produce: !!it.produce,
    })),
    shipping: {
      method, carrierLabel, carrier: sh.carrier || "", service: sh.service || "",
      tracking: sh.tracking || "", label_url: sh.label_url || "",
      address: addressLine, city: addr.city || "", province: addr.province || "", postal: addr.cp || "",
    },
    notes: o.notes || "",
  };
}

function admOrderTotal(o) { return o.total || 0; }
function admItemCount(o) { return o.items.reduce((s, it) => s + it.qty, 0); }

// ── Iconos (24×24, currentColor) ───────────────────────────────────
const AdmIcons = {
  search:  (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4-4"/></svg>),
  bell:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><path d="M6 16V11a6 6 0 1 1 12 0v5l1.5 2H4.5L6 16Z"/><path d="M10 20.5a2 2 0 0 0 4 0"/></svg>),
  inbox:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><path d="M3.5 12 6 5h12l2.5 7M3.5 12v6.5h17V12M3.5 12h5l1.5 2.5h4L15.5 12h5"/></svg>),
  box:     (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><path d="M3.5 7 12 3l8.5 4v10L12 21l-8.5-4V7Z"/><path d="m3.5 7 8.5 4 8.5-4M12 11v10"/></svg>),
  users:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><circle cx="9" cy="8.5" r="3.5"/><path d="M3 19.5c.5-3 3-5 6-5s5.5 2 6 5"/><circle cx="17" cy="9" r="2.5"/><path d="M15.5 14c2.5.3 4.5 1.8 5 4.5"/></svg>),
  chart:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><path d="M4 20V4M4 20h16M8 16V11M12 16V7M16 16v-3"/></svg>),
  cog:     (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><circle cx="12" cy="12" r="3"/><path d="M19.4 14.5a2 2 0 0 0 .4 2.2l.1.1a2.4 2.4 0 1 1-3.4 3.4l-.1-.1a2 2 0 0 0-2.2-.4 2 2 0 0 0-1.2 1.8V21a2.4 2.4 0 0 1-4.8 0v-.1a2 2 0 0 0-1.3-1.8 2 2 0 0 0-2.2.4l-.1.1a2.4 2.4 0 1 1-3.4-3.4l.1-.1a2 2 0 0 0 .4-2.2 2 2 0 0 0-1.8-1.2H3a2.4 2.4 0 0 1 0-4.8h.1A2 2 0 0 0 4.9 6.5a2 2 0 0 0-.4-2.2l-.1-.1a2.4 2.4 0 1 1 3.4-3.4l.1.1a2 2 0 0 0 2.2.4 2 2 0 0 0 1.2-1.8V3a2.4 2.4 0 0 1 4.8 0v.1a2 2 0 0 0 1.2 1.8 2 2 0 0 0 2.2-.4l.1-.1a2.4 2.4 0 1 1 3.4 3.4l-.1.1a2 2 0 0 0-.4 2.2v0a2 2 0 0 0 1.8 1.2H21a2.4 2.4 0 0 1 0 4.8h-.1a2 2 0 0 0-1.5 1.2Z"/></svg>),
  truck:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><path d="M2.5 6.5h11v9h-11zM13.5 9h4l3 3v3.5h-7"/><circle cx="6.5" cy="17" r="1.7"/><circle cx="17" cy="17" r="1.7"/></svg>),
  printer: (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><path d="M7 8V3.5h10V8M5 8h14a2 2 0 0 1 2 2v6h-4v4.5H7V16H3v-6a2 2 0 0 1 2-2Z"/></svg>),
  copy:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M4 16V6a2 2 0 0 1 2-2h10"/></svg>),
  wa:      (p) => (<svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M12 2.2a9.8 9.8 0 0 0-8.4 14.9L2 22l5-1.5A9.8 9.8 0 1 0 12 2.2Zm5.7 13.9c-.2.7-1.4 1.4-2 1.5-.5.1-1.2.2-3.9-.8a13 13 0 0 1-5.4-4.7c-.4-.6-1.1-1.7-1.1-3.2 0-1.5.8-2.2 1-2.5.3-.3.6-.4.8-.4h.6c.2 0 .5-.1.7.5.3.7 1 2.4 1.1 2.5.1.2.1.4 0 .6-.1.2-.2.3-.4.5-.2.2-.4.5-.5.6l-.3.4c-.2.2-.3.4-.1.7.2.4 1 1.7 2.2 2.7 1.5 1.3 2.7 1.7 3.1 1.9.4.2.6.2.8-.1l.9-1.2c.2-.3.5-.2.8-.1l2.4 1.1c.3.2.5.2.6.3.1.2.1.9-.1 1.7Z"/></svg>),
  mail:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><rect x="3" y="5.5" width="18" height="13" rx="2"/><path d="m3.5 7 8.5 6 8.5-6"/></svg>),
  phone:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><path d="M5 4h4l1.5 4-2 1.5a11 11 0 0 0 6 6L16 13.5 20 15v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2Z"/></svg>),
  pin:     (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" {...p}><path d="M12 21s-7-6.5-7-12a7 7 0 1 1 14 0c0 5.5-7 12-7 12Z"/><circle cx="12" cy="9.5" r="2.5"/></svg>),
  arrow:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M5 12h14M13 6l6 6-6 6"/></svg>),
  check:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...p}><path d="m5 12.5 4.5 4.5L19 7" strokeLinecap="round" strokeLinejoin="round"/></svg>),
  close:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" {...p}><path d="m6 6 12 12M18 6 6 18"/></svg>),
  dots:    (p) => (<svg viewBox="0 0 24 24" fill="currentColor" {...p}><circle cx="6" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="18" cy="12" r="1.5"/></svg>),
  filter:  (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" {...p}><path d="M4 6h16M7 12h10M10 18h4"/></svg>),
  external:(p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" {...p}><path d="M14 5h5v5M19 5l-8 8M19 13v6H5V5h6"/></svg>),
  plus:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" {...p}><path d="M12 5v14M5 12h14"/></svg>),
  spark:   (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M12 3v3M12 18v3M3 12h3M18 12h3M6 6l2 2M16 16l2 2M6 18l2-2M16 8l2-2"/><circle cx="12" cy="12" r="3"/></svg>),
  chev:    (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="m9 6 6 6-6 6"/></svg>),
  logout:  (p) => (<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}><path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 17l-5-5 5-5M5 12h11"/></svg>),
};

// ── Glyph genérico de lámpara (con imagen real opcional) ────────────
function AdmGlyph({ image, size = 56 }) {
  const uid = React.useId().replace(/:/g, "");
  if (image) {
    return (
      <img src={image} alt="" style={{
        width: size, height: size, objectFit: "cover", borderRadius: 9, display: "block",
      }}/>
    );
  }
  const stroke = "rgba(245,240,255,.85)";
  return (
    <svg viewBox="0 0 56 56" width={size} height={size} style={{ display: "block" }}>
      <defs>
        <radialGradient id={`adm-g-${uid}`} cx="50%" cy="38%" r="55%">
          <stop offset="0%" stopColor="#E879F9" stopOpacity=".25"/>
          <stop offset="100%" stopColor="#A855F7" stopOpacity="0"/>
        </radialGradient>
      </defs>
      <ellipse cx="28" cy="50" rx="13" ry="1.8" fill="rgba(168,85,247,.15)"/>
      <path d="M 14 38 Q 14 17, 28 15 Q 42 17, 42 38 Z" fill={`url(#adm-g-${uid})`} stroke={stroke} strokeWidth=".7"/>
      <path d="M 17 22 Q 28 18 39 22" fill="none" stroke={stroke} strokeWidth=".4" opacity=".55"/>
      <path d="M 16 28 Q 28 24 40 28" fill="none" stroke={stroke} strokeWidth=".4" opacity=".55"/>
      <path d="M 15 34 Q 28 30 41 34" fill="none" stroke={stroke} strokeWidth=".4" opacity=".55"/>
      <rect x="26" y="38" width="4" height="8" fill="none" stroke={stroke} strokeWidth=".7"/>
      <ellipse cx="28" cy="47" rx="6" ry="1.4" fill="none" stroke={stroke} strokeWidth=".7"/>
    </svg>
  );
}

function AdmStatusPill({ status, size = "sm" }) {
  const s = ADM_STATUS[status];
  if (!s) return null;
  const pad = size === "lg" ? "5px 12px 5px 10px" : "3px 10px 3px 8px";
  const fs = size === "lg" ? 12.5 : 11.5;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 7, padding: pad, borderRadius: 999,
      background: s.bg, color: s.text, border: ".5px solid rgba(255,255,255,.08)",
      fontSize: fs, fontWeight: 500, whiteSpace: "nowrap", lineHeight: 1, backdropFilter: "blur(12px)",
    }}>
      <span style={{ width: 6, height: 6, borderRadius: 999, background: s.dot, flex: "none", boxShadow: `0 0 8px ${s.glow}` }}/>
      {s.label}
    </span>
  );
}

function AdmPlasmaMark({ size = 28 }) {
  return (
    <div style={{
      width: size, height: size, borderRadius: size * .38,
      background: "radial-gradient(circle at 30% 25%, #FCDDFF 0%, #E879F9 30%, #A855F7 65%, #6D28D9 100%)",
      boxShadow: "0 0 18px rgba(217,70,239,.55), 0 0 36px rgba(168,85,247,.35), inset 0 1px 0 rgba(255,255,255,.4), inset 0 0 0 .5px rgba(255,255,255,.2)",
      flex: "none",
    }}/>
  );
}

// ── Sidebar ─────────────────────────────────────────────────────────
function AdmSidebar({ active, onNavigate, pendingCount, userName, userInitials, onLogout }) {
  const items = [
    { id: "inicio",    label: "Inicio",    icon: "inbox" },
    { id: "pedidos",   label: "Pedidos",   icon: "box", badge: pendingCount || null },
    { id: "envios",    label: "Envíos",    icon: "truck" },
    { id: "productos", label: "Productos", icon: "spark" },
    { id: "clientes",  label: "Clientes",  icon: "users" },
    { id: "reportes",  label: "Reportes",  icon: "chart" },
    { id: "ajustes",   label: "Ajustes",   icon: "cog" },
  ];
  return (
    <aside style={{
      width: 236, flex: "none", display: "flex", flexDirection: "column",
      padding: "22px 14px 18px", borderRight: ".5px solid rgba(255,255,255,.06)",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "4px 6px 26px" }}>
        <AdmPlasmaMark size={28}/>
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1, gap: 3 }}>
          <span style={{ fontSize: 16, fontWeight: 600, color: "#F5F0FF" }}>plasma <span style={{ fontWeight: 400, color: "rgba(245,240,255,.5)", letterSpacing: ".06em" }}>DESIGN</span></span>
          <span style={{ fontSize: 10, color: "rgba(245,240,255,.4)", letterSpacing: ".08em", textTransform: "uppercase" }}>Estudio · Admin</span>
        </div>
      </div>

      <nav style={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {items.map((it) => {
          const Icon = AdmIcons[it.icon];
          const isActive = it.id === active;
          return (
            <a key={it.id} href="#" onClick={(e) => { e.preventDefault(); onNavigate(it.id); }}
              className={isActive ? "glass-soft" : ""}
              style={{
                display: "flex", alignItems: "center", gap: 11, padding: "8px 10px", borderRadius: 10,
                textDecoration: "none", fontSize: 13.5, fontWeight: isActive ? 500 : 400,
                color: isActive ? "#F5F0FF" : "rgba(245,240,255,.6)",
              }}>
              <Icon width="17" height="17" style={{ opacity: isActive ? .95 : .6 }}/>
              <span style={{ flex: 1 }}>{it.label}</span>
              {it.badge != null && (
                <span style={{
                  fontSize: 10.5, fontWeight: 500, fontVariantNumeric: "tabular-nums",
                  padding: "1px 7px", borderRadius: 999,
                  background: "linear-gradient(135deg, #E879F9 0%, #A855F7 100%)",
                  color: "#fff", minWidth: 16, textAlign: "center", boxShadow: "0 0 10px rgba(168,85,247,.45)",
                }}>{it.badge}</span>
              )}
            </a>
          );
        })}
      </nav>

      <div style={{ marginTop: 28, padding: "0 6px" }}>
        <div style={{ fontSize: 10, color: "rgba(245,240,255,.35)", letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 10 }}>Atajos</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <a href="#" onClick={(e) => { e.preventDefault(); onNavigate("pedidos"); }} style={{ fontSize: 13, color: "rgba(245,240,255,.55)", textDecoration: "none", padding: "4px 0" }}>Lista del día</a>
          <a href="#" onClick={(e) => { e.preventDefault(); onNavigate("envios"); }} style={{ fontSize: 13, color: "rgba(245,240,255,.55)", textDecoration: "none", padding: "4px 0" }}>Sin tracking</a>
          <a href="#" onClick={(e) => { e.preventDefault(); onNavigate("reportes"); }} style={{ fontSize: 13, color: "rgba(245,240,255,.55)", textDecoration: "none", padding: "4px 0" }}>Ver reportes</a>
        </div>
      </div>

      <div style={{ flex: 1 }}/>

      <div className="glass-soft" style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 10px", borderRadius: 12 }}>
        <div style={{
          width: 28, height: 28, borderRadius: 999, background: "linear-gradient(135deg, #C084FC, #6D28D9)",
          color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 11.5, fontWeight: 600, boxShadow: "inset 0 1px 0 rgba(255,255,255,.25)", flex: "none",
        }}>{userInitials}</div>
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.25, flex: 1, minWidth: 0 }}>
          <span style={{ fontSize: 12.5, fontWeight: 500, color: "#F5F0FF", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{userName}</span>
          <span style={{ fontSize: 11, color: "rgba(245,240,255,.45)" }}>Taller — Plasma</span>
        </div>
        <button title="Salir" onClick={onLogout} style={{
          width: 26, height: 26, border: 0, background: "transparent", color: "rgba(245,240,255,.5)",
          cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flex: "none",
        }}><AdmIcons.logout width="15" height="15"/></button>
      </div>
    </aside>
  );
}

// ── Top bar ─────────────────────────────────────────────────────────
function AdmTopBar({ query, setQuery, pendingCount, sectionLabel, greeting, userName, onPrimary }) {
  const now = new Date();
  const dateStr = now.toLocaleDateString("es-AR", { weekday: "long", day: "numeric", month: "long" });
  const dateCap = dateStr.charAt(0).toUpperCase() + dateStr.slice(1);
  const hour = now.getHours();
  const saludo = hour < 13 ? "Buen día" : hour < 20 ? "Buenas tardes" : "Buenas noches";
  return (
    <header style={{ padding: "22px 32px 0" }}>
      <div className="glass" style={{ display: "flex", alignItems: "center", gap: 14, padding: "8px 8px 8px 18px", borderRadius: 999 }}>
        <span style={{ fontSize: 12.5, fontWeight: 500, color: "rgba(245,240,255,.9)", flex: "none" }}>{sectionLabel}</span>
        <div style={{ height: 16, width: 1, background: "rgba(255,255,255,.1)" }}/>
        <div style={{ display: "flex", alignItems: "center", gap: 9, flex: 1, minWidth: 0 }}>
          <AdmIcons.search width="14" height="14" style={{ color: "rgba(245,240,255,.4)", flex: "none" }}/>
          <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Buscar pedido, cliente, tracking…"
            style={{ flex: 1, minWidth: 0, border: 0, outline: "none", background: "transparent", fontSize: 13, color: "#F5F0FF" }}/>
        </div>
        <div style={{ height: 16, width: 1, background: "rgba(255,255,255,.1)" }}/>
        <button title="Notificaciones" style={{
          height: 32, width: 32, border: 0, background: "rgba(255,255,255,.04)", borderRadius: 999, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center", position: "relative", color: "rgba(245,240,255,.8)", flex: "none",
        }}>
          <AdmIcons.bell width="15" height="15"/>
          {pendingCount > 0 && <span style={{ position: "absolute", top: 6, right: 6, width: 7, height: 7, borderRadius: 999, background: "#E879F9", boxShadow: "0 0 8px rgba(232,121,249,.7)" }}/>}
        </button>
        <button onClick={onPrimary} className="grad-btn" style={{
          height: 34, padding: "0 16px 0 13px", color: "#fff", border: 0, borderRadius: 999, cursor: "pointer",
          display: "flex", alignItems: "center", gap: 7, fontSize: 13, fontWeight: 600, flex: "none",
        }}>
          <AdmIcons.plus width="14" height="14"/>
          Nuevo producto
        </button>
      </div>

      {greeting && (
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", padding: "32px 4px 0", gap: 24, flexWrap: "wrap" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 0 }}>
            <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.45)", letterSpacing: ".08em", textTransform: "uppercase", fontWeight: 500 }}>{dateCap}</span>
            <div style={{ display: "flex", alignItems: "baseline", gap: 14, flexWrap: "wrap" }}>
              <span style={{ fontSize: 30, fontWeight: 600, color: "#F5F0FF", letterSpacing: "-.02em", lineHeight: 1.05, textShadow: "0 1px 24px rgba(168,85,247,.25)" }}>{saludo}, {userName}.</span>
              <span style={{
                display: "inline-flex", alignItems: "center", gap: 8, padding: "5px 12px 5px 10px", borderRadius: 999,
                background: "rgba(232,121,249,.12)", border: ".5px solid rgba(232,121,249,.25)", fontSize: 13, color: "#F5D5FE", fontWeight: 500,
              }}>
                <span style={{ width: 6, height: 6, borderRadius: 999, background: "#E879F9", boxShadow: "0 0 8px rgba(232,121,249,.7)", animation: "adm-pulse 2s ease-in-out infinite" }}/>
                {pendingCount} pedidos esperando
              </span>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

// ── Metrics row ─────────────────────────────────────────────────────
function AdmMetric({ label, value, valueSize = 34, delta, foot, accent, glow }) {
  return (
    <div className="glass" style={{ flex: 1, padding: "18px 20px", borderRadius: 18, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column", gap: 8 }}>
      {glow && <div style={{ position: "absolute", top: -30, right: -30, width: 90, height: 90, borderRadius: "50%", background: glow, filter: "blur(28px)", pointerEvents: "none", opacity: .55 }}/>}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", zIndex: 1 }}>
        <span style={{ fontSize: 12, color: "rgba(245,240,255,.55)" }}>{label}</span>
        {delta && (
          <span style={{
            fontSize: 11, fontWeight: 500, color: delta.startsWith("-") ? "#FCA5A5" : "#86EFAC", fontVariantNumeric: "tabular-nums",
            padding: "2px 7px", borderRadius: 999, background: delta.startsWith("-") ? "rgba(248,113,113,.1)" : "rgba(74,222,128,.1)", border: ".5px solid rgba(255,255,255,.08)",
          }}>{delta}</span>
        )}
      </div>
      <div style={{ fontWeight: 700, fontSize: valueSize, color: "#F5F0FF", letterSpacing: "-.025em", lineHeight: 1.02, fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap", display: "flex", alignItems: "baseline", gap: 8, zIndex: 1 }}>
        {value}
        {accent && <span style={{ width: 7, height: 7, borderRadius: 999, background: accent, boxShadow: `0 0 10px ${accent}`, alignSelf: "center" }}/>}
      </div>
      <div style={{ fontSize: 11.5, color: "rgba(245,240,255,.45)", zIndex: 1 }}>{foot}</div>
    </div>
  );
}

function AdmMetricsRow({ orders }) {
  const now = Date.now();
  const day = 86400000;
  const today = orders.filter((o) => admIsToday(o.date));
  const yesterday = orders.filter((o) => o.date && new Date(o.date).toDateString() === new Date(now - day).toDateString());
  const paid = orders.filter((o) => o.status === "paid");
  const inProd = orders.filter((o) => o.status === "in_production");
  const enCamino = orders.filter((o) => o.status === "shipped");
  const rev7 = orders.filter((o) => ADM_PAID_LIKE.includes(o.status) && o.date && now - o.date < 7 * day).reduce((s, o) => s + admOrderTotal(o), 0);
  const revPrev7 = orders.filter((o) => ADM_PAID_LIKE.includes(o.status) && o.date && now - o.date >= 7 * day && now - o.date < 14 * day).reduce((s, o) => s + admOrderTotal(o), 0);
  const revDelta = revPrev7 > 0 ? Math.round(((rev7 - revPrev7) / revPrev7) * 100) : null;
  const todayDelta = today.length - yesterday.length;

  return (
    <div style={{ margin: "24px 32px 0", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14 }}>
      <AdmMetric label="Pedidos · hoy" value={today.length}
        delta={todayDelta !== 0 ? (todayDelta > 0 ? `+${todayDelta}` : `${todayDelta}`) : null}
        foot={`vs. ayer (${yesterday.length})`} accent="#E879F9"
        glow="radial-gradient(circle, rgba(232,121,249,.5), transparent 70%)"/>
      <AdmMetric label="Para preparar" value={paid.length + inProd.length}
        foot={`${paid.length} sin empezar · ${inProd.length} en producción`} accent="#FBBF24"
        glow="radial-gradient(circle, rgba(251,191,36,.35), transparent 70%)"/>
      <AdmMetric label="En camino" value={enCamino.length} foot="enviados, esperando entrega" accent="#C084FC"
        glow="radial-gradient(circle, rgba(192,132,252,.4), transparent 70%)"/>
      <AdmMetric label="Ingresos · 7 días" value={fmtARS(rev7)} valueSize={26}
        delta={revDelta != null ? (revDelta >= 0 ? `+${revDelta}%` : `${revDelta}%`) : null}
        foot="vs. semana anterior"
        glow="radial-gradient(circle, rgba(168,85,247,.4), transparent 70%)"/>
    </div>
  );
}

// ── Tabs ────────────────────────────────────────────────────────────
function AdmTabs({ value, setValue, orders, selectedCount = 0, onCancelSelected, onClearSelected, busy }) {
  const counts = {
    todos: orders.length,
    pending: orders.filter((o) => o.status === "pending").length,
    paid: orders.filter((o) => o.status === "paid").length,
    in_production: orders.filter((o) => o.status === "in_production").length,
    shipped: orders.filter((o) => o.status === "shipped").length,
    delivered: orders.filter((o) => o.status === "delivered").length,
  };
  const tabs = [
    { id: "todos", label: "Todos" },
    { id: "pending", label: "Pendientes" },
    { id: "paid", label: "Pagados" },
    { id: "in_production", label: "Preparación" },
    { id: "shipped", label: "Enviados" },
    { id: "delivered", label: "Entregados" },
  ];
  return (
    <div style={{ margin: "28px 32px 0", display: "flex", alignItems: "center", gap: 10 }}>
      <div className="glass" style={{ display: "inline-flex", padding: 4, borderRadius: 999, gap: 2, flexWrap: "wrap" }}>
        {tabs.map((t) => {
          const active = t.id === value;
          return (
            <button key={t.id} onClick={() => setValue(t.id)} style={{
              border: 0, padding: "7px 13px", borderRadius: 999, cursor: "pointer",
              display: "inline-flex", alignItems: "center", gap: 6, whiteSpace: "nowrap",
              fontSize: 12.5, fontWeight: active ? 600 : 500,
              color: active ? "#0B0613" : "rgba(245,240,255,.65)",
              background: active ? "rgba(245,240,255,.95)" : "transparent", transition: "all .15s", fontFamily: "inherit",
            }}>
              {t.label}
              <span style={{
                fontSize: 10.5, fontWeight: 500, padding: "1px 6px", borderRadius: 999,
                background: active ? "rgba(11,6,19,.1)" : "rgba(255,255,255,.06)",
                color: active ? "#0B0613" : "rgba(245,240,255,.5)",
                fontVariantNumeric: "tabular-nums", minWidth: 16, textAlign: "center",
              }}>{counts[t.id]}</span>
            </button>
          );
        })}
      </div>

      <div style={{ flex: 1 }}/>

      {selectedCount > 0 && (
        <div style={{ display: "inline-flex", alignItems: "center", gap: 10, animation: "adm-fadein .15s ease" }}>
          <span style={{ fontSize: 12.5, color: "rgba(245,240,255,.6)", fontVariantNumeric: "tabular-nums" }}>
            {selectedCount} seleccionado{selectedCount > 1 ? "s" : ""}
          </span>
          <button onClick={onClearSelected} style={{
            height: 34, padding: "0 12px", borderRadius: 999, cursor: "pointer", fontFamily: "inherit",
            fontSize: 12.5, fontWeight: 500, color: "rgba(245,240,255,.7)",
            background: "rgba(255,255,255,.05)", border: ".5px solid rgba(255,255,255,.1)",
          }}>Limpiar</button>
          <button onClick={onCancelSelected} disabled={busy} style={{
            height: 34, padding: "0 14px", borderRadius: 999, cursor: busy ? "default" : "pointer", opacity: busy ? .6 : 1,
            display: "inline-flex", alignItems: "center", gap: 7, fontFamily: "inherit",
            fontSize: 12.5, fontWeight: 600, color: "#FCA5A5",
            background: "rgba(248,113,113,.1)", border: ".5px solid rgba(248,113,113,.3)",
          }}>
            <AdmIcons.close width="13" height="13"/>
            Cancelar {selectedCount > 1 ? `${selectedCount} pedidos` : "pedido"}
          </button>
        </div>
      )}
    </div>
  );
}

// ── Orders table ────────────────────────────────────────────────────
const ADM_TABLE_COLS = "28px 96px minmax(180px,1fr) minmax(220px,1.3fr) minmax(170px,1fr) 100px 130px 100px";

function AdmOrdersTable({ orders, onSelect, selectedId, selected, onToggleSelect, onToggleAll }) {
  if (orders.length === 0) {
    return <div style={{ margin: "0 32px", padding: "60px 24px", textAlign: "center", fontSize: 13.5, color: "rgba(245,240,255,.45)" }} className="glass">No hay pedidos en este estado.</div>;
  }
  const has = (id) => selected && selected.has(id);
  const allSelected = orders.length > 0 && orders.every((o) => has(o.id));
  const someSelected = orders.some((o) => has(o.id));
  return (
    <div style={{ margin: "0 32px" }}>
      <div style={{ overflowX: "auto", borderRadius: 18 }}>
        <div style={{ display: "grid", gridTemplateColumns: ADM_TABLE_COLS, gap: 16, alignItems: "center", padding: "10px 18px 8px", minWidth: 1060, fontSize: 10.5, color: "rgba(245,240,255,.4)", textTransform: "uppercase", letterSpacing: ".08em" }}>
          <input type="checkbox" checked={allSelected}
            ref={(el) => { if (el) el.indeterminate = !allSelected && someSelected; }}
            onChange={(e) => onToggleAll && onToggleAll(orders.map((o) => o.id), e.target.checked)}
            title="Seleccionar todo" style={{ width: 14, height: 14, accentColor: "#A855F7", cursor: "pointer" }}/>
          <span>Pedido</span><span>Cliente</span><span>Productos</span><span>Destino</span>
          <span style={{ textAlign: "right" }}>Total</span><span>Estado</span><span>Fecha</span>
        </div>
        <div className="glass" style={{ borderRadius: 18, overflow: "hidden", minWidth: 1060 }}>
          {orders.map((o, i) => {
            const isSelected = selectedId === o.id;
            const isChecked = has(o.id);
            const isLast = i === orders.length - 1;
            const rowBg = isSelected
              ? "linear-gradient(90deg, rgba(168,85,247,.12), rgba(168,85,247,.04))"
              : isChecked ? "rgba(168,85,247,.07)" : "transparent";
            return (
              <div key={o.id} onClick={() => onSelect(o)} style={{
                display: "grid", gridTemplateColumns: ADM_TABLE_COLS, gap: 16, alignItems: "center", padding: "14px 18px",
                borderBottom: isLast ? 0 : ".5px solid rgba(255,255,255,.05)", cursor: "pointer",
                background: rowBg,
                transition: "background .12s", position: "relative",
              }}
                onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.background = "rgba(255,255,255,.04)"; }}
                onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.background = rowBg; }}>
                {(isSelected || isChecked) && <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: 2, background: "linear-gradient(180deg, #E879F9, #A855F7)", boxShadow: "0 0 10px rgba(168,85,247,.6)" }}/>}
                <input type="checkbox" checked={isChecked} onChange={() => onToggleSelect && onToggleSelect(o.id)} onClick={(e) => e.stopPropagation()} style={{ width: 14, height: 14, accentColor: "#A855F7", cursor: "pointer" }}/>
                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <span style={{ fontSize: 13, fontWeight: 500, color: "#F5F0FF", fontVariantNumeric: "tabular-nums" }}>#{o.id.slice(0, 6).toUpperCase()}</span>
                  <span style={{ fontSize: 11, color: "rgba(245,240,255,.45)" }}>{o.payment.method}</span>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
                  <span style={{ fontSize: 13.5, color: "#F5F0FF", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{o.customer.name}</span>
                  <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.5)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{o.customer.email}</span>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                  <div style={{ display: "flex", position: "relative", flex: "none" }}>
                    {o.items.slice(0, 3).map((it, idx) => (
                      <div key={idx} style={{ width: 32, height: 32, borderRadius: 9, background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.1)", marginLeft: idx === 0 ? 0 : -10, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3 - idx, overflow: "hidden", backdropFilter: "blur(10px)" }}>
                        <AdmGlyph size={28}/>
                      </div>
                    ))}
                    {o.items.length > 3 && <div style={{ width: 32, height: 32, borderRadius: 9, background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.1)", marginLeft: -10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: "rgba(245,240,255,.55)" }}>+{o.items.length - 3}</div>}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
                    <span style={{ fontSize: 13, color: "#F5F0FF", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{o.items[0]?.name || "—"}{o.items.length > 1 ? ` +${o.items.length - 1}` : ""}</span>
                    <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.5)" }}>{admItemCount(o)} unidades</span>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
                  <span style={{ fontSize: 13, color: "#F5F0FF", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{o.shipping.city || "—"}</span>
                  <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.5)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{o.shipping.carrierLabel}</span>
                </div>
                <div style={{ fontSize: 13.5, color: "#F5F0FF", textAlign: "right", fontVariantNumeric: "tabular-nums", fontWeight: 500 }}>{fmtARS(admOrderTotal(o))}</div>
                <div><AdmStatusPill status={o.status}/></div>
                <div style={{ fontSize: 12, color: "rgba(245,240,255,.5)", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" }}>{admFmtDate(o.date, { relative: true })}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ── Status flow visual ──────────────────────────────────────────────
function AdmStatusFlow({ status }) {
  const isCanceled = status === "cancelled";
  const curIdx = ADM_STATUS[status]?.order ?? -1;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 0, padding: "4px 0" }}>
      {ADM_STATUS_FLOW.map((s, i) => {
        const passed = !isCanceled && i <= curIdx;
        const current = !isCanceled && i === curIdx;
        const dotColor = passed ? ADM_STATUS[s].dot : "rgba(255,255,255,.15)";
        return (
          <React.Fragment key={s}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, flex: "none", width: 64 }}>
              <div style={{
                width: current ? 14 : 10, height: current ? 14 : 10, borderRadius: 999, background: dotColor,
                boxShadow: current ? `0 0 0 4px ${ADM_STATUS[s].bg}, 0 0 14px ${ADM_STATUS[s].glow}` : passed ? `0 0 8px ${ADM_STATUS[s].glow}` : "none",
                transition: "all .15s",
              }}/>
              <span style={{ fontSize: 10, color: passed ? "#F5F0FF" : "rgba(245,240,255,.35)", fontWeight: current ? 500 : 400, textAlign: "center", lineHeight: 1.15, whiteSpace: "nowrap" }}>{ADM_STATUS[s].label}</span>
            </div>
            {i < ADM_STATUS_FLOW.length - 1 && (
              <div style={{ flex: 1, height: 1, marginTop: -16, background: i < curIdx && !isCanceled ? `linear-gradient(90deg, ${ADM_STATUS[s].dot}, ${ADM_STATUS[ADM_STATUS_FLOW[i + 1]].dot})` : "rgba(255,255,255,.08)", opacity: i < curIdx && !isCanceled ? .6 : 1 }}/>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

function AdmActionBtn({ icon, label, primary, gradient, danger, onClick, disabled }) {
  const Icon = icon ? AdmIcons[icon] : null;
  const cls = gradient ? "grad-btn" : "";
  const styles = gradient ? { color: "#fff", border: 0 }
    : primary ? { background: "rgba(245,240,255,.95)", color: "#0B0613", border: 0 }
    : danger ? { background: "rgba(248,113,113,.08)", color: "#FCA5A5", border: ".5px solid rgba(248,113,113,.22)" }
    : { background: "rgba(255,255,255,.05)", color: "#F5F0FF", border: ".5px solid rgba(255,255,255,.1)" };
  return (
    <button onClick={onClick} className={cls} disabled={disabled} style={{
      ...styles, height: 34, padding: label ? "0 14px" : 0, minWidth: label ? 0 : 34, borderRadius: 999,
      cursor: disabled ? "default" : "pointer", opacity: disabled ? .5 : 1,
      display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6,
      fontSize: 12.5, fontWeight: 500, fontFamily: "inherit", whiteSpace: "nowrap",
    }}>
      {Icon && <Icon width="14" height="14"/>}
      {label}
    </button>
  );
}

function AdmCopyableLine({ icon, value, onCopy }) {
  const Icon = icon ? AdmIcons[icon] : null;
  const [copied, setCopied] = React.useState(false);
  const copy = (e) => {
    e.preventDefault(); e.stopPropagation();
    navigator.clipboard?.writeText(value).catch(() => {});
    setCopied(true); onCopy?.(value);
    setTimeout(() => setCopied(false), 1400);
  };
  if (!value) return null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 4px", borderBottom: ".5px solid rgba(255,255,255,.05)" }}>
      {Icon && <Icon width="14" height="14" style={{ color: "rgba(245,240,255,.5)", flex: "none" }}/>}
      <span style={{ flex: 1, fontSize: 13, color: "#F5F0FF", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{value}</span>
      <button onClick={copy} style={{ background: "transparent", border: 0, padding: 4, cursor: "pointer", display: "flex", alignItems: "center", gap: 4, fontSize: 11.5, color: copied ? "#86EFAC" : "rgba(245,240,255,.5)", borderRadius: 5, fontFamily: "inherit" }} title="Copiar">
        {copied ? <><AdmIcons.check width="13" height="13"/> Copiado</> : <AdmIcons.copy width="13" height="13"/>}
      </button>
    </div>
  );
}

function AdmSection({ title, count, right, children }) {
  return (
    <div style={{ marginBottom: 22 }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
          <h3 style={{ margin: 0, fontSize: 11, fontWeight: 600, color: "rgba(245,240,255,.5)", letterSpacing: ".1em", textTransform: "uppercase" }}>{title}</h3>
          {count != null && <span style={{ fontSize: 11, color: "rgba(245,240,255,.35)", fontVariantNumeric: "tabular-nums" }}>{count}</span>}
        </div>
        {right}
      </div>
      {children}
    </div>
  );
}

// ── Order detail drawer ─────────────────────────────────────────────
function AdmOrderDetail({ order, onClose, onAdvance, onCancel, onSaveTracking, onToast, busy }) {
  const [trackingDraft, setTrackingDraft] = React.useState(order?.shipping.tracking || "");
  React.useEffect(() => { setTrackingDraft(order?.shipping.tracking || ""); }, [order?.id]);
  if (!order) return null;

  const total = admOrderTotal(order);
  const next = ADM_NEXT_STATUS[order.status];
  const customerWA = (order.customer.phone || "").replace(/[^\d]/g, "");

  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(8,4,13,.55)", backdropFilter: "blur(4px)", zIndex: 50, animation: "adm-fadein .15s ease" }}/>
      <div style={{
        position: "fixed", top: 14, right: 14, bottom: 14, width: 540, maxWidth: "calc(100vw - 28px)", zIndex: 51,
        display: "flex", flexDirection: "column", borderRadius: 22, overflow: "hidden",
        background: "rgba(20,12,30,.78)", backdropFilter: "blur(40px) saturate(160%)", WebkitBackdropFilter: "blur(40px) saturate(160%)",
        border: ".5px solid rgba(255,255,255,.1)",
        boxShadow: "inset 0 .5px 0 rgba(255,255,255,.12), 0 30px 80px rgba(0,0,0,.6), 0 0 60px rgba(168,85,247,.18)",
        animation: "adm-slidein .25s cubic-bezier(.2,.7,.2,1)",
      }}>
        <div style={{ position: "absolute", top: -100, right: -100, width: 280, height: 280, borderRadius: "50%", pointerEvents: "none", background: "radial-gradient(circle, rgba(217,70,239,.25), transparent 70%)", filter: "blur(20px)" }}/>

        <div style={{ padding: "22px 24px 18px", borderBottom: ".5px solid rgba(255,255,255,.07)", display: "flex", flexDirection: "column", gap: 12, position: "relative" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span style={{ fontSize: 22, fontWeight: 700, color: "#F5F0FF", letterSpacing: "-.02em", fontVariantNumeric: "tabular-nums", lineHeight: 1 }}>#{order.id.slice(0, 8).toUpperCase()}</span>
              <AdmStatusPill status={order.status} size="lg"/>
            </div>
            <button onClick={onClose} style={{ width: 32, height: 32, border: 0, background: "rgba(255,255,255,.05)", borderRadius: 999, cursor: "pointer", color: "rgba(245,240,255,.7)", display: "flex", alignItems: "center", justifyContent: "center" }}><AdmIcons.close width="15" height="15"/></button>
          </div>
          <div style={{ display: "flex", gap: 14, fontSize: 12, color: "rgba(245,240,255,.55)", fontVariantNumeric: "tabular-nums", alignItems: "center", flexWrap: "wrap" }}>
            <span>{admFmtDate(order.date)}</span>
            <span style={{ color: "rgba(255,255,255,.15)" }}>·</span>
            <span>{order.payment.method}</span>
            <span style={{ color: "rgba(255,255,255,.15)" }}>·</span>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 6, color: order.payment.paid ? "#86EFAC" : "#FCD96A" }}>
              <span style={{ width: 6, height: 6, borderRadius: 999, background: order.payment.paid ? "#4ADE80" : "#FBBF24", boxShadow: order.payment.paid ? "0 0 8px rgba(74,222,128,.6)" : "0 0 8px rgba(251,191,36,.6)" }}/>
              {order.payment.paid ? "Pagado" : "Pago pendiente"}
            </span>
          </div>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "22px 24px 28px", position: "relative" }}>
          <div style={{ marginBottom: 18 }}><AdmStatusFlow status={order.status}/></div>

          {next && order.status !== "cancelled" && (
            <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
              <button onClick={() => onAdvance(order.id)} disabled={busy} className="grad-btn" style={{ flex: 1, height: 42, color: "#fff", border: 0, borderRadius: 12, cursor: busy ? "default" : "pointer", opacity: busy ? .6 : 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, fontSize: 14, fontWeight: 600, fontFamily: "inherit" }}>
                <AdmIcons.arrow width="16" height="16"/>
                {ADM_NEXT_LABEL[order.status]}
              </button>
              {order.shipping.label_url && (
                <button title="Abrir etiqueta" onClick={() => window.open(order.shipping.label_url, "_blank")} style={{ height: 42, width: 42, border: ".5px solid rgba(255,255,255,.1)", background: "rgba(255,255,255,.04)", borderRadius: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#F5F0FF" }}><AdmIcons.printer width="15" height="15"/></button>
              )}
            </div>
          )}

          <AdmSection title="Productos" count={order.items.length}>
            <div style={{ background: "rgba(255,255,255,.025)", border: ".5px solid rgba(255,255,255,.06)", borderRadius: 14, overflow: "hidden" }}>
              {order.items.map((it, i) => (
                <div key={i} style={{ display: "grid", gridTemplateColumns: "56px 1fr auto", gap: 14, alignItems: "center", padding: "13px 14px", borderBottom: i < order.items.length - 1 ? ".5px solid rgba(255,255,255,.05)" : 0 }}>
                  <div style={{ width: 56, height: 56, borderRadius: 12, background: "rgba(255,255,255,.03)", border: ".5px solid rgba(255,255,255,.08)", display: "flex", alignItems: "center", justifyContent: "center" }}><AdmGlyph size={46}/></div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 3, minWidth: 0 }}>
                    <span style={{ fontSize: 13.5, color: "#F5F0FF", fontWeight: 500 }}>{it.name}</span>
                    {it.variant && <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.5)" }}>{it.variant}</span>}
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 2 }}>
                      <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.5)" }}>× {it.qty}</span>
                      {it.produce && (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 10.5, fontWeight: 500, color: "#FCD96A", padding: "2px 8px", borderRadius: 999, background: "rgba(245,158,11,.12)", border: ".5px solid rgba(245,158,11,.3)" }}>
                          <span style={{ width: 5, height: 5, borderRadius: 999, background: "#FBBF24", boxShadow: "0 0 6px rgba(251,191,36,.7)" }}/>
                          A producir
                        </span>
                      )}
                    </div>
                  </div>
                  <div style={{ fontSize: 13, color: "#F5F0FF", textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{fmtARS(it.unit_price * it.qty)}</div>
                </div>
              ))}
              {order.shipping_cost > 0 && (
                <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 14px", fontSize: 12, color: "rgba(245,240,255,.55)", borderTop: ".5px solid rgba(255,255,255,.05)" }}>
                  <span>Envío</span><span style={{ fontVariantNumeric: "tabular-nums" }}>{fmtARS(order.shipping_cost)}</span>
                </div>
              )}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", padding: "14px", background: "rgba(168,85,247,.06)", borderTop: ".5px solid rgba(255,255,255,.06)" }}>
                <span style={{ fontSize: 12, color: "rgba(245,240,255,.55)" }}>Total</span>
                <span className="grad-text" style={{ fontSize: 22, fontWeight: 700, letterSpacing: "-.015em", fontVariantNumeric: "tabular-nums" }}>{fmtARS(total)}</span>
              </div>
            </div>
          </AdmSection>

          <AdmSection title="Cliente">
            <div style={{ background: "rgba(255,255,255,.025)", border: ".5px solid rgba(255,255,255,.06)", borderRadius: 14, padding: "12px 14px" }}>
              <div style={{ fontSize: 15, color: "#F5F0FF", fontWeight: 500, padding: "4px 0 8px" }}>{order.customer.name}</div>
              <AdmCopyableLine icon="mail" value={order.customer.email} onCopy={() => onToast("Mail copiado")}/>
              <AdmCopyableLine icon="phone" value={order.customer.phone} onCopy={() => onToast("Teléfono copiado")}/>
              <div style={{ display: "flex", gap: 8, paddingTop: 14 }}>
                {customerWA && <AdmActionBtn icon="wa" label="WhatsApp" gradient onClick={() => { window.open(`https://wa.me/${customerWA}`, "_blank"); onToast("Abriendo WhatsApp…"); }}/>}
                {order.customer.email && <AdmActionBtn icon="mail" label="Mandar mail" onClick={() => window.open(`mailto:${order.customer.email}`, "_blank")}/>}
              </div>
            </div>
          </AdmSection>

          <AdmSection title="Envío" right={<span style={{ fontSize: 11.5, color: "rgba(245,240,255,.6)", padding: "3px 10px", borderRadius: 999, background: "rgba(255,255,255,.05)", border: ".5px solid rgba(255,255,255,.08)" }}>{order.shipping.method}</span>}>
            <div style={{ background: "rgba(255,255,255,.025)", border: ".5px solid rgba(255,255,255,.06)", borderRadius: 14, padding: "14px" }}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                <AdmIcons.pin width="15" height="15" style={{ color: "rgba(192,132,252,.85)", marginTop: 2, flex: "none" }}/>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13.5, color: "#F5F0FF", lineHeight: 1.4 }}>{order.shipping.address || "—"}</div>
                  <div style={{ fontSize: 12.5, color: "rgba(245,240,255,.6)", marginTop: 2 }}>{order.shipping.city}{order.shipping.postal ? ` · CP ${order.shipping.postal}` : ""}</div>
                  {order.shipping.province && <div style={{ fontSize: 12, color: "rgba(245,240,255,.45)" }}>{order.shipping.province}, Argentina</div>}
                </div>
                <button onClick={() => { navigator.clipboard?.writeText(`${order.shipping.address}, ${order.shipping.city} (CP ${order.shipping.postal}), ${order.shipping.province}`); onToast("Dirección copiada"); }} style={{ background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.1)", padding: "4px 9px", borderRadius: 999, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, color: "rgba(245,240,255,.75)", fontFamily: "inherit" }}><AdmIcons.copy width="11" height="11"/> Copiar</button>
              </div>
              <div style={{ marginTop: 16 }}>
                <div style={{ fontSize: 10.5, color: "rgba(245,240,255,.45)", letterSpacing: ".06em", textTransform: "uppercase", marginBottom: 8 }}>Código de seguimiento</div>
                <div style={{ display: "flex", gap: 6 }}>
                  <input value={trackingDraft} onChange={(e) => setTrackingDraft(e.target.value)} placeholder="Pegar tracking…" style={{ flex: 1, height: 34, padding: "0 12px", border: ".5px solid rgba(255,255,255,.1)", borderRadius: 10, background: "rgba(0,0,0,.2)", fontSize: 13, color: "#F5F0FF", fontFamily: "inherit", outline: "none" }}
                    onFocus={(e) => (e.target.style.border = ".5px solid rgba(192,132,252,.5)")} onBlur={(e) => (e.target.style.border = ".5px solid rgba(255,255,255,.1)")}/>
                  <AdmActionBtn label={order.shipping.tracking === trackingDraft && trackingDraft ? "Guardado" : "Guardar"} gradient={!!trackingDraft && order.shipping.tracking !== trackingDraft} primary={!trackingDraft || order.shipping.tracking === trackingDraft} disabled={busy} onClick={() => onSaveTracking(order.id, trackingDraft)}/>
                </div>
              </div>
            </div>
          </AdmSection>

          {order.notes && (
            <AdmSection title="Nota del cliente">
              <div style={{ background: "linear-gradient(135deg, rgba(217,70,239,.08), rgba(168,85,247,.04))", border: ".5px solid rgba(192,132,252,.18)", borderRadius: 12, padding: "12px 14px", fontSize: 13.5, color: "#E8E2F5", lineHeight: 1.45, fontStyle: "italic" }}>« {order.notes} »</div>
            </AdmSection>
          )}

          {order.status !== "cancelled" && order.status !== "delivered" && (
            <div style={{ marginTop: 28, paddingTop: 18, borderTop: ".5px solid rgba(255,255,255,.06)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 12, color: "rgba(245,240,255,.45)" }}>¿El pedido no se va a despachar?</span>
              <AdmActionBtn danger label="Cancelar pedido" disabled={busy} onClick={() => onCancel(order.id)}/>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

// ── Toast ───────────────────────────────────────────────────────────
function AdmToast({ msg }) {
  if (!msg) return null;
  return (
    <div style={{ position: "fixed", bottom: 28, left: "50%", transform: "translateX(-50%)", zIndex: 100, background: "rgba(20,12,30,.85)", backdropFilter: "blur(24px) saturate(160%)", color: "#F5F0FF", padding: "11px 20px", borderRadius: 999, fontSize: 13, fontWeight: 500, border: ".5px solid rgba(255,255,255,.12)", boxShadow: "0 12px 40px rgba(0,0,0,.5), inset 0 .5px 0 rgba(255,255,255,.15), 0 0 30px rgba(168,85,247,.25)", animation: "adm-toastin .2s cubic-bezier(.2,.7,.2,1)", display: "flex", alignItems: "center", gap: 9 }}>
      <span style={{ width: 6, height: 6, borderRadius: 999, background: "#4ADE80", boxShadow: "0 0 8px rgba(74,222,128,.7)" }}/>
      {msg}
    </div>
  );
}

// ── Shared pieces ───────────────────────────────────────────────────
function AdmCard({ title, subtitle, right, children }) {
  return (
    <div className="glass" style={{ borderRadius: 18, padding: "18px 20px", display: "flex", flexDirection: "column", gap: 14, position: "relative" }}>
      {(title || subtitle) && (
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
          <div>
            {title && <h3 style={{ margin: 0, fontSize: 14, fontWeight: 600, color: "#F5F0FF" }}>{title}</h3>}
            {subtitle && <div style={{ fontSize: 11.5, color: "rgba(245,240,255,.5)", marginTop: 3 }}>{subtitle}</div>}
          </div>
          {right}
        </div>
      )}
      {children}
    </div>
  );
}

function AdmTextLink({ children, onClick }) {
  return <button onClick={onClick} style={{ background: "transparent", border: 0, cursor: "pointer", padding: 0, fontSize: 12, color: "#C084FC", fontFamily: "inherit", fontWeight: 500 }}>{children}</button>;
}

function AdmEmptyState({ text }) {
  return <div style={{ padding: "32px 16px", textAlign: "center", fontSize: 13, color: "rgba(245,240,255,.45)" }}>{text}</div>;
}

function AdmViewHeader({ kicker, title, subtitle, right }) {
  return (
    <div style={{ padding: "28px 36px 0", display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 24, flexWrap: "wrap" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 6, minWidth: 0 }}>
        {kicker && <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.45)", letterSpacing: ".08em", textTransform: "uppercase", fontWeight: 500 }}>{kicker}</span>}
        <span style={{ fontSize: 30, fontWeight: 600, color: "#F5F0FF", letterSpacing: "-.02em", lineHeight: 1.05, textShadow: "0 1px 24px rgba(168,85,247,.25)" }}>{title}</span>
        {subtitle && <span style={{ fontSize: 14, color: "rgba(245,240,255,.55)", marginTop: 4, maxWidth: 640, lineHeight: 1.45 }}>{subtitle}</span>}
      </div>
      {right}
    </div>
  );
}

// ── INICIO ──────────────────────────────────────────────────────────
function AdmQuickAction({ icon, label, onClick }) {
  const Icon = AdmIcons[icon];
  return (
    <button onClick={onClick} style={{ display: "flex", alignItems: "center", gap: 9, padding: "11px 12px", borderRadius: 11, background: "rgba(255,255,255,.025)", border: ".5px solid rgba(255,255,255,.07)", color: "#F5F0FF", cursor: "pointer", fontFamily: "inherit", fontSize: 12, fontWeight: 500, textAlign: "left" }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(255,255,255,.05)")} onMouseLeave={(e) => (e.currentTarget.style.background = "rgba(255,255,255,.025)")}>
      <Icon width="14" height="14" style={{ color: "rgba(192,132,252,.85)", flex: "none" }}/>
      <span>{label}</span>
    </button>
  );
}

function AdmDispatchRow({ order, isLast, onClick, onAdvance }) {
  const next = ADM_NEXT_STATUS[order.status];
  return (
    <div style={{ display: "grid", gridTemplateColumns: "40px 1fr auto auto", gap: 12, alignItems: "center", padding: "11px 4px", borderBottom: isLast ? 0 : ".5px solid rgba(255,255,255,.05)", cursor: "pointer" }} onClick={onClick}>
      <div style={{ width: 40, height: 40, borderRadius: 10, background: "rgba(255,255,255,.03)", border: ".5px solid rgba(255,255,255,.08)", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}><AdmGlyph size={32}/></div>
      <div style={{ minWidth: 0 }}>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <span style={{ fontSize: 13, color: "#F5F0FF", fontWeight: 500 }}>{order.customer.name.split(" ")[0]} · #{order.id.slice(0, 6).toUpperCase()}</span>
          <AdmStatusPill status={order.status}/>
        </div>
        <div style={{ fontSize: 11.5, color: "rgba(245,240,255,.55)", marginTop: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{order.items[0]?.name}{order.items.length > 1 ? ` +${order.items.length - 1}` : ""} · {order.shipping.city}</div>
      </div>
      {next && <button onClick={(e) => { e.stopPropagation(); onAdvance(); }} className="grad-btn" style={{ height: 30, padding: "0 12px", border: 0, borderRadius: 999, color: "#fff", fontSize: 11.5, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>{next === "in_production" ? "Preparar" : next === "shipped" ? "Despachar" : next === "paid" ? "Cobrar" : "Entregar"}</button>}
      <AdmIcons.arrow width="14" height="14" style={{ color: "rgba(245,240,255,.4)" }}/>
    </div>
  );
}

function AdmActivityRow({ order, isLast, onClick }) {
  const s = ADM_STATUS[order.status];
  return (
    <div onClick={onClick} style={{ display: "grid", gridTemplateColumns: "24px 1fr auto", gap: 10, alignItems: "center", padding: "9px 4px", borderBottom: isLast ? 0 : ".5px solid rgba(255,255,255,.05)", cursor: "pointer" }}>
      <div style={{ width: 22, height: 22, borderRadius: 999, background: s.bg, border: ".5px solid rgba(255,255,255,.08)", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}>
        <span style={{ width: 6, height: 6, borderRadius: 999, background: s.dot, boxShadow: `0 0 6px ${s.glow}` }}/>
      </div>
      <div style={{ minWidth: 0 }}>
        <span style={{ fontSize: 12.5, color: "#F5F0FF" }}><strong style={{ fontWeight: 500 }}>#{order.id.slice(0, 6).toUpperCase()}</strong><span style={{ color: "rgba(245,240,255,.55)" }}> · {order.customer.name.split(" ")[0]}</span></span>
        <div style={{ fontSize: 11, color: "rgba(245,240,255,.45)" }}>{s.label.toLowerCase()}</div>
      </div>
      <span style={{ fontSize: 11, color: "rgba(245,240,255,.5)", fontVariantNumeric: "tabular-nums" }}>{admFmtDate(order.date, { relative: true }).split(" · ")[0]}</span>
    </div>
  );
}

function AdmInicioView({ orders, onOpenOrder, onAdvance, onGoto }) {
  const dispatchToday = orders.filter((o) => o.status === "paid" || o.status === "in_production");
  const activity = [...orders].sort((a, b) => (b.date || 0) - (a.date || 0)).slice(0, 6);

  const productCounts = {};
  orders.forEach((o) => { if (o.status === "cancelled") return; o.items.forEach((it) => { productCounts[it.name] = (productCounts[it.name] || 0) + it.qty; }); });
  const topProducts = Object.entries(productCounts).sort((a, b) => b[1] - a[1]).slice(0, 4);
  const maxTop = topProducts[0]?.[1] || 1;

  const buckets = [
    { k: "pending", count: orders.filter((o) => o.status === "pending").length },
    { k: "paid", count: orders.filter((o) => o.status === "paid").length },
    { k: "in_production", count: orders.filter((o) => o.status === "in_production").length },
    { k: "shipped", count: orders.filter((o) => o.status === "shipped").length },
  ];
  const bucketsTotal = buckets.reduce((s, b) => s + b.count, 0);

  return (
    <>
      <AdmMetricsRow orders={orders}/>
      <div style={{ margin: "20px 32px 0", display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 14 }}>
        <AdmCard title="Para despachar" subtitle={`${dispatchToday.length} pedidos en marcha`} right={<AdmTextLink onClick={() => onGoto("pedidos")}>Ver todos →</AdmTextLink>}>
          {dispatchToday.length === 0 ? <AdmEmptyState text="Nada pendiente. Buen trabajo."/> : (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {dispatchToday.map((o, i) => <AdmDispatchRow key={o.id} order={o} isLast={i === dispatchToday.length - 1} onClick={() => onOpenOrder(o.id)} onAdvance={() => onAdvance(o.id)}/>)}
            </div>
          )}
        </AdmCard>
        <AdmCard title="Actividad reciente" subtitle="Últimos movimientos">
          <div style={{ display: "flex", flexDirection: "column" }}>
            {activity.length === 0 ? <AdmEmptyState text="Sin actividad."/> : activity.map((o, i) => <AdmActivityRow key={o.id} order={o} isLast={i === activity.length - 1} onClick={() => onOpenOrder(o.id)}/>)}
          </div>
        </AdmCard>
      </div>
      <div style={{ margin: "14px 32px 40px", display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14 }}>
        <AdmCard title="Más pedidos" subtitle="Por unidades vendidas">
          {topProducts.length === 0 ? <AdmEmptyState text="Sin ventas todavía."/> : (
            <div style={{ display: "flex", flexDirection: "column", gap: 12, padding: "4px 0" }}>
              {topProducts.map(([name, qty]) => (
                <div key={name} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 38, height: 38, borderRadius: 10, background: "rgba(255,255,255,.03)", border: ".5px solid rgba(255,255,255,.08)", display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}><AdmGlyph size={32}/></div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                      <span style={{ fontSize: 13, color: "#F5F0FF", fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
                      <span style={{ fontSize: 12, color: "rgba(245,240,255,.6)", fontVariantNumeric: "tabular-nums" }}>{qty} u</span>
                    </div>
                    <div style={{ height: 4, borderRadius: 999, background: "rgba(255,255,255,.06)", overflow: "hidden" }}>
                      <div style={{ height: "100%", width: `${(qty / maxTop) * 100}%`, background: "linear-gradient(90deg, #E879F9, #A855F7)", borderRadius: 999, boxShadow: "0 0 8px rgba(168,85,247,.5)" }}/>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </AdmCard>
        <AdmCard title="Estado del pipeline" subtitle="Distribución actual">
          <div style={{ display: "flex", flexDirection: "column", gap: 9, padding: "4px 0" }}>
            {buckets.map(({ k, count }) => {
              const s = ADM_STATUS[k];
              const pct = bucketsTotal ? (count / bucketsTotal) * 100 : 0;
              return (
                <div key={k} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 8, height: 8, borderRadius: 999, background: s.dot, boxShadow: `0 0 8px ${s.glow}`, flex: "none" }}/>
                  <span style={{ fontSize: 13, color: "#F5F0FF", flex: 1 }}>{s.label}</span>
                  <span style={{ fontSize: 13, color: "rgba(245,240,255,.7)", fontVariantNumeric: "tabular-nums", fontWeight: 500 }}>{count}</span>
                  <div style={{ width: 60, height: 4, borderRadius: 999, background: "rgba(255,255,255,.06)", overflow: "hidden" }}><div style={{ height: "100%", width: `${pct}%`, background: s.dot, borderRadius: 999 }}/></div>
                </div>
              );
            })}
          </div>
        </AdmCard>
        <AdmCard title="Atajos del taller" subtitle="Acciones más usadas">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, padding: "4px 0" }}>
            <AdmQuickAction icon="box" label="Ver pedidos" onClick={() => onGoto("pedidos")}/>
            <AdmQuickAction icon="truck" label="Envíos / tracking" onClick={() => onGoto("envios")}/>
            <AdmQuickAction icon="spark" label="Productos" onClick={() => onGoto("productos")}/>
            <AdmQuickAction icon="chart" label="Reportes" onClick={() => onGoto("reportes")}/>
          </div>
        </AdmCard>
      </div>
    </>
  );
}

// ── ENVÍOS ──────────────────────────────────────────────────────────
function AdmShipmentRow({ order, isLast, onOpenOrder, onSaveTracking, busy }) {
  const [draft, setDraft] = React.useState(order.shipping.tracking || "");
  React.useEffect(() => { setDraft(order.shipping.tracking || ""); }, [order.id, order.shipping.tracking]);
  const dirty = draft !== order.shipping.tracking;
  return (
    <div style={{ display: "grid", gridTemplateColumns: "120px 1fr 1.1fr 130px", gap: 18, alignItems: "center", padding: "14px 18px", borderBottom: isLast ? 0 : ".5px solid rgba(255,255,255,.05)" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 3, cursor: "pointer" }} onClick={onOpenOrder}>
        <span style={{ fontSize: 13, color: "#F5F0FF", fontWeight: 500, fontVariantNumeric: "tabular-nums" }}>#{order.id.slice(0, 6).toUpperCase()}</span>
        <AdmStatusPill status={order.status}/>
      </div>
      <div style={{ minWidth: 0, cursor: "pointer" }} onClick={onOpenOrder}>
        <div style={{ fontSize: 13, color: "#F5F0FF" }}>{order.customer.name}</div>
        <div style={{ fontSize: 11.5, color: "rgba(245,240,255,.5)", display: "flex", alignItems: "center", gap: 4, marginTop: 2 }}><AdmIcons.pin width="11" height="11"/> {order.shipping.address}{order.shipping.city ? `, ${order.shipping.city}` : ""}</div>
      </div>
      <div style={{ display: "flex", gap: 6 }}>
        <input value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="Pegar tracking…" style={{ flex: 1, minWidth: 0, height: 30, padding: "0 11px", border: ".5px solid rgba(255,255,255,.1)", borderRadius: 8, background: "rgba(0,0,0,.2)", fontSize: 12, color: "#F5F0FF", fontFamily: "inherit", outline: "none" }}/>
        {dirty && <button onClick={() => onSaveTracking(order.id, draft)} disabled={busy} className="grad-btn" style={{ height: 30, padding: "0 12px", border: 0, borderRadius: 8, color: "#fff", fontSize: 11.5, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>OK</button>}
      </div>
      <button onClick={() => { navigator.clipboard?.writeText(`${order.shipping.address}, ${order.shipping.city} (CP ${order.shipping.postal})`); }} style={{ height: 30, padding: "0 12px", background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.1)", borderRadius: 8, color: "#F5F0FF", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6, fontSize: 11.5, fontFamily: "inherit" }}><AdmIcons.copy width="12" height="12"/> Copiar dir.</button>
    </div>
  );
}

function AdmEnviosView({ orders, onOpenOrder, onSaveTracking, busy }) {
  const inFlight = orders.filter((o) => ["paid", "in_production", "shipped"].includes(o.status));
  const groups = {};
  inFlight.forEach((o) => { const c = o.shipping.carrierLabel || "Sin transportista"; (groups[c] = groups[c] || []).push(o); });
  const carriers = Object.keys(groups);
  const sinTracking = orders.filter((o) => o.status === "shipped" && !o.shipping.tracking).length;

  return (
    <>
      <AdmViewHeader kicker="Logística" title="Envíos" subtitle="Todo lo que está saliendo del taller, agrupado por transportista. Pegá el código de seguimiento desde acá."
        right={
          <div className="glass" style={{ display: "flex", alignItems: "center", gap: 14, padding: "8px 14px", borderRadius: 999, fontSize: 12, color: "rgba(245,240,255,.7)" }}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><span style={{ width: 6, height: 6, borderRadius: 999, background: "#FBBF24", boxShadow: "0 0 6px rgba(251,191,36,.5)" }}/>{sinTracking} sin tracking</span>
            <span style={{ color: "rgba(255,255,255,.15)" }}>·</span>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><span style={{ width: 6, height: 6, borderRadius: 999, background: "#C084FC", boxShadow: "0 0 6px rgba(192,132,252,.5)" }}/>{inFlight.length} en tránsito</span>
          </div>
        }/>
      <div style={{ padding: "24px 32px 40px", display: "flex", flexDirection: "column", gap: 16 }}>
        {carriers.length === 0 && <AdmCard><AdmEmptyState text="No hay envíos activos."/></AdmCard>}
        {carriers.map((c) => (
          <div key={c} className="glass" style={{ borderRadius: 18, overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 18px", borderBottom: ".5px solid rgba(255,255,255,.06)", background: "rgba(255,255,255,.015)" }}>
              <div style={{ width: 32, height: 32, borderRadius: 9, background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.08)", display: "flex", alignItems: "center", justifyContent: "center", color: "#38BDF8" }}><AdmIcons.truck width="16" height="16"/></div>
              <span style={{ fontSize: 14, fontWeight: 600, color: "#F5F0FF" }}>{c}</span>
              <span style={{ fontSize: 11, color: "rgba(245,240,255,.6)", padding: "2px 8px", borderRadius: 999, background: "rgba(255,255,255,.05)", border: ".5px solid rgba(255,255,255,.08)", fontVariantNumeric: "tabular-nums" }}>{groups[c].length} pedidos</span>
            </div>
            <div>{groups[c].map((o, i) => <AdmShipmentRow key={o.id} order={o} isLast={i === groups[c].length - 1} onOpenOrder={() => onOpenOrder(o.id)} onSaveTracking={onSaveTracking} busy={busy}/>)}</div>
          </div>
        ))}
      </div>
    </>
  );
}

// ── CLIENTES ────────────────────────────────────────────────────────
function AdmClientesView({ orders, onOpenOrder }) {
  const byEmail = {};
  orders.forEach((o) => {
    const k = o.customer.email || o.customer.name;
    if (!byEmail[k]) byEmail[k] = { name: o.customer.name, email: o.customer.email, phone: o.customer.phone, city: o.shipping.city, orders: [], totalSpent: 0, lastOrderDate: o.date };
    byEmail[k].orders.push(o);
    if (o.status !== "cancelled") byEmail[k].totalSpent += admOrderTotal(o);
    if ((o.date || 0) > (byEmail[k].lastOrderDate || 0)) byEmail[k].lastOrderDate = o.date;
  });
  const customers = Object.values(byEmail).sort((a, b) => b.totalSpent - a.totalSpent);
  const cols = "1.4fr 1.4fr 1fr 90px 130px 110px";

  return (
    <>
      <AdmViewHeader kicker="CRM" title="Clientes" subtitle={`${customers.length} clientes con historial. Ordenados por gasto total.`}/>
      <div style={{ padding: "20px 32px 40px" }}>
        <div className="glass" style={{ borderRadius: 18, overflow: "hidden" }}>
          <div style={{ display: "grid", gridTemplateColumns: cols, gap: 16, alignItems: "center", padding: "12px 18px", fontSize: 10.5, color: "rgba(245,240,255,.4)", textTransform: "uppercase", letterSpacing: ".08em", borderBottom: ".5px solid rgba(255,255,255,.06)", background: "rgba(255,255,255,.015)" }}>
            <span>Cliente</span><span>Contacto</span><span>Ubicación</span><span style={{ textAlign: "right" }}>Pedidos</span><span style={{ textAlign: "right" }}>Total gastado</span><span>Último</span>
          </div>
          {customers.length === 0 && <AdmEmptyState text="Todavía no hay clientes."/>}
          {customers.map((c, i) => {
            const initials = (c.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
            const top = i === 0 && c.totalSpent > 0;
            return (
              <div key={c.email || i} style={{ display: "grid", gridTemplateColumns: cols, gap: 16, alignItems: "center", padding: "14px 18px", borderBottom: i === customers.length - 1 ? 0 : ".5px solid rgba(255,255,255,.05)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 32, height: 32, borderRadius: 999, background: `linear-gradient(135deg, ${["#C084FC", "#E879F9", "#67E8F9", "#FCD96A", "#86EFAC", "#F9A8D4"][i % 6]}, #6D28D9)`, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 600, flex: "none", boxShadow: "inset 0 1px 0 rgba(255,255,255,.25)" }}>{initials}</div>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 13.5, color: "#F5F0FF", fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.name}</div>
                    {top && <div style={{ fontSize: 10.5, color: "#F5D5FE", display: "flex", alignItems: "center", gap: 4 }}><span style={{ width: 4, height: 4, borderRadius: 999, background: "#E879F9", boxShadow: "0 0 6px rgba(232,121,249,.7)" }}/>Top spender</div>}
                  </div>
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 12.5, color: "rgba(245,240,255,.85)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.email || "—"}</div>
                  <div style={{ fontSize: 11.5, color: "rgba(245,240,255,.5)" }}>{c.phone}</div>
                </div>
                <div style={{ fontSize: 12.5, color: "rgba(245,240,255,.7)", display: "flex", alignItems: "center", gap: 5 }}><AdmIcons.pin width="11" height="11" style={{ color: "rgba(192,132,252,.7)", flex: "none" }}/><span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{c.city || "—"}</span></div>
                <div style={{ textAlign: "right", fontSize: 13, color: "#F5F0FF", fontVariantNumeric: "tabular-nums" }}>{c.orders.length}</div>
                <div style={{ textAlign: "right", fontSize: 13.5, fontWeight: 600, color: top ? "#E879F9" : "#F5F0FF", fontVariantNumeric: "tabular-nums" }}>{fmtARS(c.totalSpent)}</div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
                  <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.55)", fontVariantNumeric: "tabular-nums" }}>{admFmtDate(c.lastOrderDate, { relative: true }).split(" · ")[0]}</span>
                  <button onClick={() => onOpenOrder([...c.orders].sort((a, b) => (b.date || 0) - (a.date || 0))[0].id)} style={{ width: 26, height: 26, borderRadius: 999, background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.1)", color: "#F5F0FF", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center" }}><AdmIcons.arrow width="13" height="13"/></button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

// ── REPORTES ────────────────────────────────────────────────────────
function AdmRevenueLineChart({ days }) {
  const W = 600, H = 200, pad = { t: 10, r: 10, b: 24, l: 10 };
  const innerW = W - pad.l - pad.r, innerH = H - pad.t - pad.b;
  const max = Math.max(...days.map((d) => d.revenue), 1) * 1.1;
  const points = days.map((d, i) => ({ x: pad.l + (i / Math.max(days.length - 1, 1)) * innerW, y: pad.t + innerH - (d.revenue / max) * innerH, d }));
  const path = points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(" ");
  const fillPath = `${path} L ${points[points.length - 1].x} ${pad.t + innerH} L ${pad.l} ${pad.t + innerH} Z`;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} width="100%" style={{ display: "block", minHeight: 200 }}>
      <defs>
        <linearGradient id="adm-rev-line" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stopColor="#67E8F9"/><stop offset="50%" stopColor="#E879F9"/><stop offset="100%" stopColor="#A855F7"/></linearGradient>
        <linearGradient id="adm-rev-fill" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#A855F7" stopOpacity=".4"/><stop offset="100%" stopColor="#A855F7" stopOpacity="0"/></linearGradient>
        <filter id="adm-glow"><feGaussianBlur stdDeviation="3"/></filter>
      </defs>
      {[0.25, 0.5, 0.75].map((p) => <line key={p} x1={pad.l} x2={W - pad.r} y1={pad.t + innerH * p} y2={pad.t + innerH * p} stroke="rgba(255,255,255,.05)" strokeDasharray="2 3"/>)}
      <path d={fillPath} fill="url(#adm-rev-fill)"/>
      <path d={path} fill="none" stroke="url(#adm-rev-line)" strokeWidth="3" filter="url(#adm-glow)" opacity=".6"/>
      <path d={path} fill="none" stroke="url(#adm-rev-line)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      {points.map((p, i) => <circle key={i} cx={p.x} cy={p.y} r="2.5" fill="#F5F0FF" stroke="#A855F7" strokeWidth="1"/>)}
      {points.map((p, i) => ((i % 2 === 0 || i === points.length - 1) && <text key={i} x={p.x} y={H - 6} fontSize="9.5" fill="rgba(245,240,255,.45)" textAnchor="middle" fontFamily="Geist, sans-serif">{p.d.date.getDate()}/{(p.d.date.getMonth() + 1).toString().padStart(2, "0")}</text>))}
    </svg>
  );
}

function AdmPaymentBreakdown({ orders }) {
  const counts = {};
  orders.forEach((o) => { if (o.status === "cancelled") return; counts[o.payment.method] = (counts[o.payment.method] || 0) + 1; });
  const entries = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  const total = entries.reduce((s, [, n]) => s + n, 0);
  if (total === 0) return <AdmEmptyState text="Sin pagos todavía."/>;
  const colors = ["#A855F7", "#E879F9", "#67E8F9", "#FBBF24", "#86EFAC"];
  const R = 60, CR = 70;
  let acc = 0;
  const segs = entries.map(([name, n], i) => {
    const sa = (acc / total) * Math.PI * 2 - Math.PI / 2; acc += n;
    const ea = (acc / total) * Math.PI * 2 - Math.PI / 2;
    const large = ea - sa > Math.PI ? 1 : 0;
    const sx = CR + R * Math.cos(sa), sy = CR + R * Math.sin(sa), ex = CR + R * Math.cos(ea), ey = CR + R * Math.sin(ea);
    const sxi = CR + (R - 18) * Math.cos(sa), syi = CR + (R - 18) * Math.sin(sa), exi = CR + (R - 18) * Math.cos(ea), eyi = CR + (R - 18) * Math.sin(ea);
    return { name, n, color: colors[i % colors.length], d: `M ${sx} ${sy} A ${R} ${R} 0 ${large} 1 ${ex} ${ey} L ${exi} ${eyi} A ${R - 18} ${R - 18} 0 ${large} 0 ${sxi} ${syi} Z` };
  });
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "4px 0" }}>
      <svg viewBox={`0 0 ${CR * 2} ${CR * 2}`} width="140" height="140" style={{ flex: "none" }}>
        {segs.map((s, i) => <path key={i} d={s.d} fill={s.color} style={{ filter: `drop-shadow(0 0 6px ${s.color}66)` }}/>)}
        <text x={CR} y={CR - 4} textAnchor="middle" fontSize="20" fontWeight="600" fill="#F5F0FF" fontFamily="Geist">{total}</text>
        <text x={CR} y={CR + 13} textAnchor="middle" fontSize="9" fill="rgba(245,240,255,.55)" fontFamily="Geist" letterSpacing="1">PEDIDOS</text>
      </svg>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 9 }}>
        {segs.map((s) => (
          <div key={s.name} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ width: 8, height: 8, borderRadius: 999, background: s.color, boxShadow: `0 0 6px ${s.color}88`, flex: "none" }}/>
            <span style={{ fontSize: 12.5, color: "#F5F0FF", flex: 1 }}>{s.name}</span>
            <span style={{ fontSize: 12, color: "rgba(245,240,255,.55)", fontVariantNumeric: "tabular-nums" }}>{Math.round((s.n / total) * 100)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function AdmReportesView({ orders }) {
  const today = new Date();
  const days = [];
  for (let i = 13; i >= 0; i--) {
    const d = new Date(today); d.setDate(d.getDate() - i);
    const ds = new Date(d); ds.setHours(0, 0, 0, 0);
    const de = new Date(d); de.setHours(23, 59, 59, 999);
    const rev = orders.filter((o) => ADM_PAID_LIKE.includes(o.status) && o.date && o.date >= ds.getTime() && o.date <= de.getTime()).reduce((s, o) => s + admOrderTotal(o), 0);
    days.push({ date: new Date(d), revenue: rev });
  }
  const totalRevenue = days.reduce((s, d) => s + d.revenue, 0);
  const validOrders = orders.filter((o) => o.status !== "cancelled");
  const avgOrder = validOrders.length ? Math.round(validOrders.reduce((s, o) => s + admOrderTotal(o), 0) / validOrders.length) : 0;
  const cancelled = orders.filter((o) => o.status === "cancelled").length;
  const cancelRate = orders.length ? ((cancelled / orders.length) * 100).toFixed(1) : "0";

  const byProvince = {};
  orders.forEach((o) => { if (o.status === "cancelled") return; const k = o.shipping.province || "Sin provincia"; byProvince[k] = (byProvince[k] || 0) + admOrderTotal(o); });
  const provinces = Object.entries(byProvince).sort((a, b) => b[1] - a[1]).slice(0, 8);
  const maxProv = provinces[0]?.[1] || 1;

  const byCarrier = {};
  orders.forEach((o) => { if (o.status === "cancelled") return; const k = o.shipping.carrierLabel || "—"; byCarrier[k] = (byCarrier[k] || 0) + 1; });
  const carriers = Object.entries(byCarrier).sort((a, b) => b[1] - a[1]);
  const totalCarrier = carriers.reduce((s, [, n]) => s + n, 0) || 1;

  return (
    <>
      <AdmViewHeader kicker="Reportes" title="Cómo va el estudio" subtitle="Tendencia de ingresos, productos más pedidos y de dónde piden. Últimos 14 días."
        right={<div className="glass" style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 14px", borderRadius: 999, fontSize: 12.5, color: "rgba(245,240,255,.85)" }}><span style={{ color: "rgba(245,240,255,.5)" }}>Período:</span><span style={{ fontWeight: 500 }}>Últimos 14 días</span></div>}/>
      <div style={{ margin: "20px 32px 0", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14 }}>
        <AdmMetric label="Ingresos · 14 días" value={fmtARS(totalRevenue)} valueSize={24} foot="cobrado" glow="radial-gradient(circle, rgba(168,85,247,.4), transparent 70%)"/>
        <AdmMetric label="Pedidos totales" value={validOrders.length} foot={`${cancelled} cancelados`} accent="#E879F9" glow="radial-gradient(circle, rgba(232,121,249,.4), transparent 70%)"/>
        <AdmMetric label="Ticket promedio" value={fmtARS(avgOrder)} valueSize={24} foot="por pedido" accent="#67E8F9" glow="radial-gradient(circle, rgba(34,211,238,.35), transparent 70%)"/>
        <AdmMetric label="Tasa de cancelación" value={`${cancelRate}%`} foot={`${cancelled} de ${orders.length}`} accent="#FBBF24" glow="radial-gradient(circle, rgba(251,191,36,.3), transparent 70%)"/>
      </div>
      <div style={{ margin: "14px 32px 0", display: "grid", gridTemplateColumns: "1.6fr 1fr", gap: 14 }}>
        <AdmCard title="Ingresos por día" subtitle={`${fmtARS(totalRevenue)} en los últimos 14 días`}><AdmRevenueLineChart days={days}/></AdmCard>
        <AdmCard title="Transportistas" subtitle="Distribución de envíos">
          <div style={{ display: "flex", flexDirection: "column", gap: 12, padding: "4px 0" }}>
            {carriers.length === 0 ? <AdmEmptyState text="Sin envíos."/> : carriers.map(([name, n], i) => {
              const color = ["#38BDF8", "#4ADE80", "#C084FC", "#FBBF24"][i % 4];
              return (
                <div key={name} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ width: 8, height: 8, borderRadius: 999, background: color, boxShadow: `0 0 6px ${color}88`, flex: "none" }}/>
                  <span style={{ fontSize: 13, color: "#F5F0FF", flex: 1 }}>{name}</span>
                  <span style={{ fontSize: 12, color: "rgba(245,240,255,.55)", fontVariantNumeric: "tabular-nums" }}>{n} env.</span>
                  <div style={{ width: 60, height: 4, borderRadius: 999, background: "rgba(255,255,255,.06)", overflow: "hidden" }}><div style={{ height: "100%", width: `${(n / totalCarrier) * 100}%`, background: color, borderRadius: 999, boxShadow: `0 0 6px ${color}88` }}/></div>
                </div>
              );
            })}
          </div>
        </AdmCard>
      </div>
      <div style={{ margin: "14px 32px 40px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        <AdmCard title="Ingresos por provincia" subtitle="A dónde van las lámparas">
          <div style={{ display: "flex", flexDirection: "column", gap: 11, padding: "4px 0" }}>
            {provinces.length === 0 ? <AdmEmptyState text="Sin datos."/> : provinces.map(([prov, amt]) => (
              <div key={prov} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 13, color: "#F5F0FF", minWidth: 130, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{prov}</span>
                <div style={{ flex: 1, height: 8, borderRadius: 999, background: "rgba(255,255,255,.05)", overflow: "hidden" }}><div style={{ height: "100%", width: `${(amt / maxProv) * 100}%`, background: "linear-gradient(90deg, #C084FC, #E879F9)", borderRadius: 999, boxShadow: "0 0 10px rgba(192,132,252,.45)" }}/></div>
                <span style={{ fontSize: 12.5, color: "#F5F0FF", fontWeight: 500, fontVariantNumeric: "tabular-nums", minWidth: 90, textAlign: "right" }}>{fmtARS(amt)}</span>
              </div>
            ))}
          </div>
        </AdmCard>
        <AdmCard title="Métodos de pago" subtitle="Cómo nos pagan"><AdmPaymentBreakdown orders={orders}/></AdmCard>
      </div>
    </>
  );
}

// ── PRODUCTOS (catálogo real, look glass) ──────────────────────────
// Imagen de la card: rota TODAS las imágenes del producto (no solo la portada).
function AdmCardImage({ images }) {
  const list = (Array.isArray(images) ? images : []).filter(Boolean);
  const [i, setI] = React.useState(0);
  React.useEffect(() => {
    setI(0);
    if (list.length <= 1) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % list.length), 2600);
    return () => clearInterval(t);
  }, [list.length]);
  if (!list.length) return <AdmGlyph size={104}/>;
  return (
    <>
      <img src={list[i % list.length]} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
      {list.length > 1 && (
        <div style={{ position: "absolute", bottom: 8, right: 10, display: "flex", gap: 4, zIndex: 2 }}>
          {list.map((_, j) => (
            <span key={j} style={{ width: 5, height: 5, borderRadius: 999, background: j === (i % list.length) ? "#fff" : "rgba(255,255,255,.45)", boxShadow: "0 0 4px rgba(0,0,0,.5)", transition: "background .2s" }}/>
          ))}
        </div>
      )}
    </>
  );
}

function AdmProductosView({ products, orders, loading, onNew, onEdit, onToggleActive, onTogglePromo, onDelete, onDuplicate }) {
  const [filter, setFilter] = React.useState("todos");
  const sales = {};
  orders.forEach((o) => { if (o.status === "cancelled") return; o.items.forEach((it) => { if (it.productId) sales[it.productId] = (sales[it.productId] || 0) + it.qty; }); });
  const maxSales = Math.max(...Object.values(sales), 1);

  const lines = [
    { id: "todos", label: "Todos" },
    { id: "lamps", label: "Lámparas" },
    { id: "accs", label: "Accesorios" },
  ];
  const filtered = filter === "todos" ? products : products.filter((p) => p.line === filter);

  function stockTotal(p) {
    if (p.stock_mode !== "stock" || !p.stock) return null;
    return Object.values(p.stock).reduce((s, n) => s + (Number(n) || 0), 0);
  }

  return (
    <>
      <AdmViewHeader kicker="Catálogo" title="Productos" subtitle="Las lámparas y accesorios del estudio. Ventas, stock y edición rápida."
        right={<button onClick={onNew} className="grad-btn" style={{ height: 36, padding: "0 16px 0 14px", border: 0, borderRadius: 999, color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 7, fontFamily: "inherit" }}><AdmIcons.plus width="14" height="14"/>Nuevo producto</button>}/>
      <div style={{ padding: "20px 32px 0" }}>
        <div className="glass" style={{ display: "inline-flex", padding: 4, borderRadius: 999, gap: 2 }}>
          {lines.map((l) => {
            const active = l.id === filter;
            const count = l.id === "todos" ? products.length : products.filter((p) => p.line === l.id).length;
            return (
              <button key={l.id} onClick={() => setFilter(l.id)} style={{ border: 0, padding: "7px 13px", borderRadius: 999, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6, whiteSpace: "nowrap", fontSize: 12.5, fontWeight: active ? 600 : 500, color: active ? "#0B0613" : "rgba(245,240,255,.65)", background: active ? "rgba(245,240,255,.95)" : "transparent", fontFamily: "inherit" }}>
                {l.label}
                <span style={{ fontSize: 10.5, fontWeight: 500, padding: "1px 6px", borderRadius: 999, background: active ? "rgba(11,6,19,.1)" : "rgba(255,255,255,.06)", color: active ? "#0B0613" : "rgba(245,240,255,.5)", fontVariantNumeric: "tabular-nums", minWidth: 16, textAlign: "center" }}>{count}</span>
              </button>
            );
          })}
        </div>
      </div>

      {loading ? (
        <div style={{ padding: "40px 32px", color: "rgba(245,240,255,.55)" }}>Cargando catálogo…</div>
      ) : (
        <div style={{ margin: "20px 32px 40px", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 14 }}>
          {filtered.length === 0 && <AdmCard><AdmEmptyState text="No hay productos en esta línea."/></AdmCard>}
          {filtered.map((p) => {
            const sold = sales[p.id] || 0;
            const stock = stockTotal(p);
            const lowStock = stock != null && stock <= 2;
            const promoOn = p.promo_active && p.promo_price && p.promo_price < p.price;
            return (
              <div key={p.id} className="glass" style={{ borderRadius: 18, padding: 16, overflow: "hidden", display: "flex", flexDirection: "column", gap: 12, position: "relative", opacity: p.active ? 1 : .55 }}>
                <div style={{ position: "absolute", top: -50, left: -50, width: 180, height: 180, borderRadius: "50%", background: "radial-gradient(circle, rgba(168,85,247,.18), transparent 65%)", filter: "blur(20px)", pointerEvents: "none" }}/>
                <div style={{ height: 140, borderRadius: 12, background: "rgba(255,255,255,.02)", border: ".5px solid rgba(255,255,255,.06)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", zIndex: 1, overflow: "hidden" }}>
                  <AdmCardImage images={(p.images && p.images.length) ? p.images : (p.image ? [p.image] : [])}/>
                  {!p.active && <div style={{ position: "absolute", top: 10, left: 10, padding: "3px 9px", borderRadius: 999, background: "rgba(0,0,0,.5)", fontSize: 10.5, color: "rgba(245,240,255,.7)" }}>Oculto</div>}
                  {lowStock && <div style={{ position: "absolute", top: 10, right: 10, padding: "3px 9px 3px 7px", borderRadius: 999, background: "rgba(248,113,113,.15)", border: ".5px solid rgba(248,113,113,.3)", fontSize: 10.5, color: "#FCA5A5", fontWeight: 500, display: "inline-flex", alignItems: "center", gap: 5 }}><span style={{ width: 5, height: 5, borderRadius: 999, background: "#F87171", boxShadow: "0 0 6px rgba(248,113,113,.7)" }}/>Stock bajo</div>}
                  {promoOn && <div style={{ position: "absolute", bottom: 10, left: 10, padding: "3px 9px", borderRadius: 999, background: "rgba(232,121,249,.18)", border: ".5px solid rgba(232,121,249,.3)", fontSize: 10.5, color: "#F5D5FE", fontWeight: 500 }}>{p.promo_label || "Promo"}</div>}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4, position: "relative", zIndex: 1 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8 }}>
                    <span style={{ fontSize: 16, fontWeight: 600, color: "#F5F0FF", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.name}</span>
                  </div>
                  <span style={{ fontSize: 11.5, color: "rgba(245,240,255,.55)" }}>{p.line === "lamps" ? "Lámpara" : "Accesorio"}{p.subtitle ? ` · ${p.subtitle}` : ""}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 10, borderTop: ".5px solid rgba(255,255,255,.06)", position: "relative", zIndex: 1 }}>
                  <div>
                    <div style={{ fontSize: 10.5, color: "rgba(245,240,255,.45)", textTransform: "uppercase", letterSpacing: ".06em" }}>Precio</div>
                    <div style={{ fontSize: 15, color: promoOn ? "#E879F9" : "#F5F0FF", fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>{fmtARS(promoOn ? p.promo_price : p.price)}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 10.5, color: "rgba(245,240,255,.45)", textTransform: "uppercase", letterSpacing: ".06em" }}>Stock</div>
                    <div style={{ fontSize: 15, color: lowStock ? "#FCA5A5" : "#F5F0FF", fontWeight: 600, fontVariantNumeric: "tabular-nums" }}>{stock != null ? `${stock} u` : "A pedido"}</div>
                  </div>
                </div>
                <div style={{ position: "relative", zIndex: 1 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "rgba(245,240,255,.55)", marginBottom: 5 }}><span>Vendidas</span><span style={{ fontVariantNumeric: "tabular-nums", color: "#F5F0FF", fontWeight: 500 }}>{sold} u</span></div>
                  <div style={{ height: 4, borderRadius: 999, background: "rgba(255,255,255,.06)", overflow: "hidden" }}><div style={{ height: "100%", width: `${(sold / maxSales) * 100}%`, background: "linear-gradient(90deg, #E879F9, #A855F7)", borderRadius: 999, boxShadow: "0 0 6px rgba(168,85,247,.5)" }}/></div>
                </div>
                <div style={{ display: "flex", gap: 6, position: "relative", zIndex: 1 }}>
                  <button onClick={() => onEdit(p.id)} style={{ flex: 1, height: 30, padding: "0 12px", background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.1)", borderRadius: 999, color: "#F5F0FF", cursor: "pointer", fontSize: 11.5, fontFamily: "inherit" }}>Editar</button>
                  <button onClick={() => onToggleActive(p)} title={p.active ? "Ocultar del sitio" : "Mostrar en el sitio"} style={{ height: 30, padding: "0 12px", background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.1)", borderRadius: 999, color: "#F5F0FF", cursor: "pointer", fontSize: 11.5, fontFamily: "inherit" }}>{p.active ? "Ocultar" : "Activar"}</button>
                  <button onClick={() => onDuplicate(p)} title="Duplicar producto" style={{ height: 30, width: 34, background: "rgba(255,255,255,.04)", border: ".5px solid rgba(255,255,255,.1)", borderRadius: 999, color: "#F5F0FF", cursor: "pointer", display: "inline-flex", alignItems: "center", justifyContent: "center" }}><AdmIcons.copy width="13" height="13"/></button>
                  <button onClick={() => onDelete(p)} title="Borrar" style={{ height: 30, width: 34, background: "rgba(248,113,113,.08)", border: ".5px solid rgba(248,113,113,.22)", borderRadius: 999, color: "#FCA5A5", cursor: "pointer", fontSize: 11.5, fontFamily: "inherit", display: "inline-flex", alignItems: "center", justifyContent: "center" }}><AdmIcons.close width="13" height="13"/></button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

/* =====================================================================
   AdminView — entry point: auth gate + carga de datos + shell
   ===================================================================== */
function AdminView({ user, isAdmin, authLoading, refreshClaims, onRequestLogin }) {
  const [bootstrap, setBootstrap]   = _aUseState("idle"); // idle | running | denied | error
  const [bootstrapErr, setBootErr]  = _aUseState("");

  _aUseEffect(() => {
    if (authLoading || !user || isAdmin || bootstrap !== "idle") return;
    setBootstrap("running");
    (async () => {
      try {
        await window.PlasmaAPI.admin.bootstrap();
        const ok = await refreshClaims();
        if (!ok) { setBootstrap("error"); setBootErr("El claim se otorgó pero el token no se refrescó. Probá recargar."); }
      } catch (e) {
        const code = e?.code || "";
        if (code === "functions/permission-denied") setBootstrap("denied");
        else { setBootstrap("error"); setBootErr(e?.message || "No se pudo verificar el acceso admin"); }
      }
    })();
  }, [authLoading, user, isAdmin, bootstrap, refreshClaims]);

  if (authLoading) return <GateScreen><p>Cargando…</p></GateScreen>;
  if (!user) {
    return (
      <GateScreen>
        <h1 style={GATE_H1}>Panel admin</h1>
        <p style={GATE_P}>Necesitás iniciar sesión con una cuenta admin para acceder.</p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
          {onRequestLogin && <GateButton onClick={onRequestLogin}>Iniciar sesión</GateButton>}
          <GateButtonGhost onClick={() => navigate("#/")}>Volver al inicio</GateButtonGhost>
        </div>
      </GateScreen>
    );
  }
  if (!isAdmin) {
    if (bootstrap === "running" || bootstrap === "idle") return <GateScreen><h1 style={GATE_H1}>Panel admin</h1><p style={GATE_P}>Verificando acceso…</p></GateScreen>;
    if (bootstrap === "denied") {
      return (
        <GateScreen>
          <h1 style={GATE_H1}>Acceso denegado</h1>
          <p style={GATE_P}>La cuenta <strong>{user.email}</strong> no tiene permisos para entrar al panel.</p>
          <GateButton onClick={() => navigate("#/")}>Volver al inicio</GateButton>
        </GateScreen>
      );
    }
    return (
      <GateScreen>
        <h1 style={GATE_H1}>Panel admin</h1>
        <p style={{ ...GATE_P, color: "#FCA5A5" }}>{bootstrapErr}</p>
        <GateButton onClick={() => navigate("#/")}>Volver al inicio</GateButton>
      </GateScreen>
    );
  }

  return <AdminDashboard user={user}/>;
}

const GATE_H1 = { fontSize: 26, fontWeight: 700, color: "#F5F0FF", margin: "0 0 10px", letterSpacing: "-.02em" };
const GATE_P = { fontSize: 14, color: "rgba(245,240,255,.7)", margin: "0 0 18px", lineHeight: 1.5 };
function GateScreen({ children }) {
  return <div className="plasma-admin" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 32, textAlign: "center" }}><div style={{ maxWidth: 420 }}>{children}</div></div>;
}
function GateButton({ children, onClick }) {
  return <button onClick={onClick} className="grad-btn" style={{ height: 40, padding: "0 20px", border: 0, borderRadius: 999, color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>{children}</button>;
}
function GateButtonGhost({ children, onClick }) {
  return <button onClick={onClick} style={{ height: 40, padding: "0 20px", border: ".5px solid rgba(255,255,255,.14)", background: "rgba(255,255,255,.05)", borderRadius: 999, color: "#F5F0FF", fontSize: 14, fontWeight: 500, cursor: "pointer", fontFamily: "inherit" }}>{children}</button>;
}

/* ===================== AdminDashboard (shell con datos reales) ====== */
function AdminDashboard({ user }) {
  const [rawOrders, setRawOrders] = _aUseState([]);
  const [products, setProducts]   = _aUseState([]);
  const [loading, setLoading]     = _aUseState(true);
  const [productsLoading, setProductsLoading] = _aUseState(true);
  const [error, setError]         = _aUseState("");
  const [view, setView]           = _aUseState("pedidos");
  const [tab, setTab]             = _aUseState("todos");
  const [query, setQuery]         = _aUseState("");
  const [selectedId, setSelectedId] = _aUseState(null);
  const [toast, setToast]         = _aUseState("");
  const [busy, setBusy]           = _aUseState(false);
  const [selected, setSelected]   = _aUseState(() => new Set()); // ids tildados para acciones en lote
  const [editingProduct, setEditingProduct] = _aUseState(null); // null | "new" | id
  const [editingInitial, setEditingInitial] = _aUseState(null); // datos precargados (duplicar)

  const showToast = _aUseCallback((msg) => { setToast(msg); setTimeout(() => setToast(""), 2200); }, []);

  const loadOrders = _aUseCallback(async () => {
    try {
      const res = await window.PlasmaAPI.admin.listOrders({ limit: 100 });
      setRawOrders(res.orders || []);
    } catch (e) {
      setError(e?.message || "No se pudieron cargar los pedidos");
    } finally { setLoading(false); }
  }, []);

  const loadProducts = _aUseCallback(async () => {
    setProductsLoading(true);
    try {
      const res = await window.PlasmaAPI.admin.listProducts();
      setProducts(res.products || []);
    } catch { /* productos opcional */ } finally { setProductsLoading(false); }
  }, []);

  _aUseEffect(() => { loadOrders(); loadProducts(); }, [loadOrders, loadProducts]);

  _aUseEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setSelectedId(null); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const orders = _aUseMemo(() => rawOrders.map(admNormalizeOrder), [rawOrders]);

  const visibleOrders = _aUseMemo(() => {
    let out = orders;
    if (tab !== "todos") out = out.filter((o) => o.status === tab);
    if (query) {
      const q = query.toLowerCase();
      out = out.filter((o) =>
        o.id.toLowerCase().includes(q) ||
        o.customer.name.toLowerCase().includes(q) ||
        o.customer.email.toLowerCase().includes(q) ||
        (o.shipping.city || "").toLowerCase().includes(q) ||
        (o.shipping.tracking || "").toLowerCase().includes(q));
    }
    return [...out].sort((a, b) => {
      if (a.status === "cancelled" && b.status !== "cancelled") return 1;
      if (b.status === "cancelled" && a.status !== "cancelled") return -1;
      const sa = ADM_STATUS[a.status]?.order ?? 0, sb = ADM_STATUS[b.status]?.order ?? 0;
      if (sa !== sb) return sa - sb;
      return (b.date || 0) - (a.date || 0);
    });
  }, [orders, tab, query]);

  const selectedOrder = selectedId ? orders.find((o) => o.id === selectedId) : null;
  const pendingCount = orders.filter((o) => ["pending", "paid", "in_production"].includes(o.status)).length;

  // Patch local optimista del pedido crudo (para no re-fetchear todo).
  const patchRaw = (id, patch) => setRawOrders((prev) => prev.map((o) => (o.id === id ? { ...o, ...patch } : o)));

  const advance = async (id) => {
    const o = orders.find((x) => x.id === id);
    const next = o && ADM_NEXT_STATUS[o.status];
    if (!next) return;
    setBusy(true);
    try {
      await window.PlasmaAPI.admin.updateOrderStatus(id, next);
      patchRaw(id, { status: next });
      showToast(`#${id.slice(0, 6).toUpperCase()} → ${ADM_STATUS[next].label}`);
    } catch (e) { showToast(e?.message || "No se pudo actualizar"); } finally { setBusy(false); }
  };

  const cancel = async (id) => {
    if (!window.confirm("¿Cancelar este pedido?")) return;
    setBusy(true);
    try {
      await window.PlasmaAPI.admin.updateOrderStatus(id, "cancelled");
      patchRaw(id, { status: "cancelled" });
      showToast(`#${id.slice(0, 6).toUpperCase()} cancelado`);
    } catch (e) { showToast(e?.message || "No se pudo cancelar"); } finally { setBusy(false); }
  };

  const saveTracking = async (id, tracking) => {
    setBusy(true);
    try {
      await window.PlasmaAPI.admin.setTracking(id, tracking);
      patchRaw(id, (function () {
        const cur = rawOrders.find((o) => o.id === id) || {};
        return { shipping: { ...(cur.shipping || {}), tracking } };
      })());
      showToast("Tracking actualizado");
    } catch (e) { showToast(e?.message || "No se pudo guardar el tracking"); } finally { setBusy(false); }
  };

  // ── Selección múltiple (acciones en lote sobre la tabla de pedidos) ──
  const toggleSelect = (id) => setSelected((prev) => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const toggleSelectAll = (ids, checked) => setSelected((prev) => { const n = new Set(prev); ids.forEach((id) => (checked ? n.add(id) : n.delete(id))); return n; });
  const clearSelection = () => setSelected(new Set());

  const cancelSelected = async () => {
    const ids = [...selected].filter((id) => { const o = orders.find((x) => x.id === id); return o && o.status !== "cancelled"; });
    if (!ids.length) { clearSelection(); return; }
    if (!window.confirm(`¿Cancelar ${ids.length} pedido${ids.length > 1 ? "s" : ""}? Esta acción no se puede deshacer.`)) return;
    setBusy(true);
    try {
      for (const id of ids) { await window.PlasmaAPI.admin.updateOrderStatus(id, "cancelled"); patchRaw(id, { status: "cancelled" }); }
      showToast(`${ids.length} pedido${ids.length > 1 ? "s" : ""} cancelado${ids.length > 1 ? "s" : ""}`);
      clearSelection();
    } catch (e) { showToast(e?.message || "No se pudieron cancelar"); } finally { setBusy(false); }
  };

  const goto = (id) => { setView(id); setEditingProduct(null); clearSelection(); window.scrollTo({ top: 0, behavior: "instant" }); };

  // ── Producto handlers (catálogo real) ──
  const handleToggleActive = async (p) => {
    try { await window.PlasmaAPI.admin.upsertProduct({ ...p, active: !p.active }); await loadProducts(); }
    catch (e) { showToast("No se pudo cambiar el estado: " + (e.message || e)); }
  };
  const handleTogglePromo = async (p) => {
    try {
      const next = { ...p, promo_active: !p.promo_active };
      if (next.promo_active && (!next.promo_price || next.promo_price >= next.price)) { showToast("Definí un precio de promo menor al normal en Editar."); return; }
      await window.PlasmaAPI.admin.upsertProduct(next); await loadProducts();
    } catch (e) { showToast("No se pudo cambiar la promo: " + (e.message || e)); }
  };
  const handleDelete = async (p) => {
    const hard = window.confirm(`¿Borrar ${p.name}?\n\nOK = borrar definitivamente.\nCancelar = sólo desactivar (lo oculta del sitio, mantiene historial).`);
    try { await window.PlasmaAPI.admin.deleteProduct(p.id, hard); await loadProducts(); }
    catch (e) { showToast("No se pudo borrar: " + (e.message || e)); }
  };

  const userName = (user?.email || "admin").split("@")[0].replace(/[._-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  const userInitials = userName.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase() || "PL";

  return (
    <div className="plasma-admin" style={{ display: "flex", position: "relative" }}>
      <AdmSidebar active={view} onNavigate={goto} pendingCount={pendingCount}
        userName={userName} userInitials={userInitials} onLogout={() => navigate("#/")}/>

      <main style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <AdmTopBar query={query} setQuery={setQuery} pendingCount={pendingCount}
          sectionLabel={ADM_SECTION_LABELS[view]} greeting={view === "pedidos"} userName={userName}
          onPrimary={() => { setView("productos"); setEditingInitial(null); setEditingProduct("new"); }}/>

        {error && view === "pedidos" && <div style={{ margin: "20px 32px 0", padding: "14px 18px", borderRadius: 14, background: "rgba(248,113,113,.1)", border: ".5px solid rgba(248,113,113,.25)", color: "#FCA5A5", fontSize: 13 }}>{error}</div>}
        {loading && view !== "productos" && view !== "ajustes" && <div style={{ padding: "40px 32px", color: "rgba(245,240,255,.55)" }}>Cargando pedidos…</div>}

        {!loading && view === "pedidos" && (
          <>
            <AdmMetricsRow orders={orders}/>
            <AdmTabs value={tab} setValue={setTab} orders={orders}
              selectedCount={selected.size} onCancelSelected={cancelSelected} onClearSelected={clearSelection} busy={busy}/>
            <div style={{ padding: "18px 0 40px", flex: 1 }}>
              <AdmOrdersTable orders={visibleOrders} onSelect={(o) => setSelectedId(o.id)} selectedId={selectedId}
                selected={selected} onToggleSelect={toggleSelect} onToggleAll={toggleSelectAll}/>
            </div>
          </>
        )}

        {!loading && view === "inicio" && <AdmInicioView orders={orders} onOpenOrder={setSelectedId} onAdvance={advance} onGoto={goto}/>}
        {!loading && view === "envios" && <AdmEnviosView orders={orders} onOpenOrder={setSelectedId} onSaveTracking={saveTracking} busy={busy}/>}
        {!loading && view === "clientes" && <AdmClientesView orders={orders} onOpenOrder={setSelectedId}/>}
        {!loading && view === "reportes" && <AdmReportesView orders={orders}/>}

        {view === "productos" && (
          editingProduct ? (
            <div style={{ padding: "24px 32px 40px" }}>
              <ProductEditor
                initial={editingProduct === "new" ? (editingInitial || EMPTY_PRODUCT) : products.find((p) => p.id === editingProduct)}
                isNew={editingProduct === "new"}
                onCancel={() => { setEditingProduct(null); setEditingInitial(null); }}
                onSaved={async () => { setEditingProduct(null); setEditingInitial(null); await loadProducts(); }}/>
            </div>
          ) : (
            <AdmProductosView products={products} orders={orders} loading={productsLoading}
              onNew={() => { setEditingInitial(null); setEditingProduct("new"); }} onEdit={(id) => setEditingProduct(id)}
              onToggleActive={handleToggleActive} onTogglePromo={handleTogglePromo} onDelete={handleDelete}
              onDuplicate={(p) => {
                // Duplicar copia todo MENOS las fotos (para no mezclar imágenes
                // entre productos): limpiamos image/images del producto y las
                // imágenes de cada variante.
                const variants = (p.variants || []).map((g) => ({
                  ...g,
                  options: (g.options || []).map((o) => { const { images, ...rest } = o; return rest; }),
                }));
                setEditingInitial({ ...p, id: "", name: ((p.name || "") + " (copia)").slice(0, 80), image: "", images: [], variants });
                setEditingProduct("new");
              }}/>
          )
        )}

        {view === "ajustes" && (
          <div style={{ padding: "8px 0 40px" }}>
            <AdmViewHeader kicker="Configuración" title="Ajustes" subtitle="Datos de transferencia bancaria que ve el cliente en el detalle del pedido."/>
            <div style={{ padding: "20px 32px 0" }}><div className="glass" style={{ borderRadius: 18, padding: "20px 22px" }}><SettingsPanel/></div></div>
          </div>
        )}
      </main>

      {selectedOrder && <AdmOrderDetail order={selectedOrder} busy={busy} onClose={() => setSelectedId(null)} onAdvance={advance} onCancel={cancel} onSaveTracking={saveTracking} onToast={showToast}/>}
      <AdmToast msg={toast}/>
    </div>
  );
}

/* ===================== ProductEditor (catálogo real) ===================== */
function ProductEditor({ initial, isNew, onCancel, onSaved }) {
  const [form, setForm] = _aUseState(() => normalize(initial));
  const [saving, setSaving] = _aUseState(false);
  const [error, setError]   = _aUseState("");
  const [urlInput, setUrlInput] = _aUseState("");
  const upload = useProductUpload();

  function set(k, v) { setForm((f) => ({ ...f, [k]: v })); }
  function setDim(k, v) { setForm((f) => ({ ...f, dims_cm: { ...f.dims_cm, [k]: v } })); }
  function setImages(arr) { set("images", arr); }

  async function handleImage(e) {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setError("");
    try {
      const uploaded = [];
      for (const file of files) { const { url } = await upload.upload(form.id || "tmp", file); uploaded.push(url); }
      setImages([...(form.images || []), ...uploaded]);
      e.target.value = "";
    } catch (err) { setError(err.message || "Error subiendo imagen"); }
  }

  async function handleSave() {
    setSaving(true); setError("");
    try {
      const payload = buildPayload(form, isNew);
      await window.PlasmaAPI.admin.upsertProduct(payload);
      await onSaved();
    } catch (e) {
      console.error("[admin.upsert]", e);
      const details = e.details?.fieldErrors;
      const tail = details ? " — " + Object.entries(details).map(([k, v]) => `${k}: ${v.join(", ")}`).join("; ") : "";
      setError((e.message || "Error guardando") + tail);
    } finally { setSaving(false); }
  }

  return (
    <div className="admin-editor">
      <div className="admin-editor__head">
        <h2>{isNew ? "Nuevo producto" : `Editar ${form.name || form.id}`}</h2>
        <button className="btn btn--ghost btn--small" onClick={onCancel}>← Cancelar</button>
      </div>

      <div className="admin-editor__grid">
        <section className="admin-editor__col">
          <h3>Básico</h3>
          <AdminField label="ID (slug, a-z, 0-9, -)" disabled={!isNew}>
            <input className="form__input" value={form.id} onChange={(e) => set("id", e.target.value.toLowerCase().replace(/[^a-z0-9-]+/g, "-"))} placeholder="abyssal-lamp" />
          </AdminField>
          <AdminField label="Línea">
            <select className="form__input" value={form.line} onChange={(e) => set("line", e.target.value)}>
              <option value="lamps">Lámparas</option>
              <option value="accs">Accesorios</option>
            </select>
          </AdminField>
          <AdminField label="Nombre">
            <input className="form__input" value={form.name} onChange={(e) => set("name", e.target.value)} />
          </AdminField>
          <AdminField label="Artista (opcional)">
            <input className="form__input" value={form.artist || ""} onChange={(e) => set("artist", e.target.value)} />
          </AdminField>
          <AdminField label="Subtítulo (1 línea)">
            <input className="form__input" value={form.subtitle} onChange={(e) => set("subtitle", e.target.value)} />
          </AdminField>
          <AdminField label="Descripción">
            <textarea className="form__input" rows="3" value={form.desc} onChange={(e) => set("desc", e.target.value)} />
          </AdminField>
          <AdminField label="Badge (opcional)">
            <input className="form__input" value={form.badge || ""} onChange={(e) => set("badge", e.target.value)} placeholder="Nuevo / Bestseller / Edición limitada" />
          </AdminField>
        </section>

        <section className="admin-editor__col">
          <h3>Precio y promo</h3>
          <AdminField label="Precio (ARS)">
            <input className="form__input" type="number" min="0" value={form.price} onChange={(e) => set("price", Number(e.target.value) || 0)} />
          </AdminField>
          <AdminField label="">
            <label className="admin-toggle">
              <input type="checkbox" checked={!!form.promo_active} onChange={(e) => set("promo_active", e.target.checked)} />
              <span>Promo activa</span>
            </label>
          </AdminField>
          <AdminField label="Precio de promo (ARS)">
            <input className="form__input" type="number" min="0" disabled={!form.promo_active} value={form.promo_price || 0} onChange={(e) => set("promo_price", Number(e.target.value) || 0)} />
          </AdminField>
          <AdminField label="Etiqueta de promo">
            <input className="form__input" disabled={!form.promo_active} value={form.promo_label || ""} onChange={(e) => set("promo_label", e.target.value)} placeholder='ej: "20% OFF"' />
          </AdminField>

          <h3 style={{ marginTop: 24 }}>Estado</h3>
          <AdminField label="">
            <label className="admin-toggle">
              <input type="checkbox" checked={!!form.active} onChange={(e) => set("active", e.target.checked)} />
              <span>Visible en el sitio</span>
            </label>
          </AdminField>

          <h3 style={{ marginTop: 24 }}>Logística</h3>
          <AdminField label="Peso (gramos)">
            <input className="form__input" type="number" min="0" value={form.weight_g} onChange={(e) => set("weight_g", Number(e.target.value) || 0)} />
          </AdminField>
          <div className="form__row">
            <AdminField label="Largo (cm)" className="form__field">
              <input className="form__input" type="number" min="0" step="0.1" value={form.dims_cm.l} onChange={(e) => setDim("l", Number(e.target.value) || 0)} />
            </AdminField>
            <AdminField label="Ancho (cm)" className="form__field">
              <input className="form__input" type="number" min="0" step="0.1" value={form.dims_cm.w} onChange={(e) => setDim("w", Number(e.target.value) || 0)} />
            </AdminField>
            <AdminField label="Alto (cm)" className="form__field">
              <input className="form__input" type="number" min="0" step="0.1" value={form.dims_cm.h} onChange={(e) => setDim("h", Number(e.target.value) || 0)} />
            </AdminField>
          </div>
          <AdminField label="Modo de stock">
            <select className="form__input" value={form.stock_mode} onChange={(e) => set("stock_mode", e.target.value)}>
              <option value="on_demand">A pedido</option>
              <option value="stock">En stock</option>
            </select>
          </AdminField>
          <AdminField label="Días de lead">
            <input className="form__input" type="number" min="0" value={form.lead_days} onChange={(e) => set("lead_days", Number(e.target.value) || 0)} />
          </AdminField>
        </section>

        <section className="admin-editor__col">
          <h3>Galería de imágenes</h3>
          <p style={{ fontSize: 12, color: "var(--fg-3)", margin: "0 0 8px" }}>La primera es la portada. En el sitio rotan automáticamente.</p>
          <div className="admin-cover">
            {form.images?.length ? <img src={form.images[0]} alt="" /> : <div className="admin-cover__placeholder">Sin imágenes</div>}
          </div>

          {form.images?.length > 0 && (
            <div className="admin-gallery">
              {form.images.map((url, i) => (
                <div key={url + i} className={"admin-gallery__item" + (i === 0 ? " admin-gallery__item--cover" : "")}>
                  <img src={url} alt="" />
                  <div className="admin-gallery__actions">
                    {i !== 0 && <button type="button" className="admin-gallery__btn" title="Usar como portada" onClick={() => setImages(moveToFront(form.images, i))}>★</button>}
                    {i > 0 && <button type="button" className="admin-gallery__btn" title="Mover izquierda" onClick={() => setImages(swap(form.images, i, i - 1))}>←</button>}
                    {i < form.images.length - 1 && <button type="button" className="admin-gallery__btn" title="Mover derecha" onClick={() => setImages(swap(form.images, i, i + 1))}>→</button>}
                    <button type="button" className="admin-gallery__btn admin-gallery__btn--danger" title="Quitar" onClick={() => setImages(form.images.filter((_, j) => j !== i))}>×</button>
                  </div>
                  {i === 0 && <span className="admin-gallery__cover-tag">PORTADA</span>}
                </div>
              ))}
            </div>
          )}

          <AdminField label="Subir nueva imagen">
            <input type="file" accept="image/*" multiple onChange={handleImage} disabled={upload.uploading} />
            {upload.uploading && <p style={{ fontSize: 12 }}>Subiendo…</p>}
          </AdminField>
          <AdminField label="O pegá una URL">
            <div style={{ display: "flex", gap: 6 }}>
              <input className="form__input" placeholder="https://…" value={urlInput || ""} onChange={(e) => setUrlInput(e.target.value)} />
              <button type="button" className="btn btn--ghost btn--small" onClick={() => { const u = (urlInput || "").trim(); if (!u) return; setImages([...(form.images || []), u]); setUrlInput(""); }}>+</button>
            </div>
          </AdminField>

          <h3 style={{ marginTop: 24 }}>Variantes</h3>
          <p style={{ fontSize: 12, color: "var(--fg-3)", margin: "0 0 8px" }}>Grupos de opciones que el cliente elige antes de agregar al carrito.</p>
          <VariantsEditor value={form.variants || []} onChange={(v) => set("variants", v)} uploadFn={upload.upload} productId={form.id || "tmp"} uploading={upload.uploading} />

          <h3 style={{ marginTop: 24 }}>Stock</h3>
          <p style={{ fontSize: 12, color: "var(--fg-3)", margin: "0 0 8px" }}>Activá "Llevar stock" para que se decremente automáticamente con cada venta.</p>
          <StockEditor stockMode={form.stock_mode} stock={form.stock} variants={form.variants} onChangeMode={(m) => set("stock_mode", m)} onChange={(s) => set("stock", s)} />
        </section>
      </div>

      {error && <p className="form__error" style={{ marginTop: 12 }}>{error}</p>}

      <div className="admin-editor__actions">
        <button className="btn btn--ghost" onClick={onCancel} disabled={saving}>Cancelar</button>
        <button className="btn btn--primary" onClick={handleSave} disabled={saving}>{saving ? "Guardando…" : (isNew ? "Crear producto" : "Guardar cambios")}</button>
      </div>
    </div>
  );
}

function normalize(p) {
  const base = { ...EMPTY_PRODUCT, ...p };
  base.dims_cm = { ...EMPTY_PRODUCT.dims_cm, ...(p?.dims_cm || {}) };
  base.swatches = Array.isArray(p?.swatches) ? p.swatches : [];
  if (Array.isArray(p?.images) && p.images.length) base.images = p.images.slice();
  else if (p?.image) base.images = [p.image];
  else base.images = [];
  if (Array.isArray(p?.variants) && p.variants.length) {
    base.variants = p.variants.map((g) => ({ id: g.id, label: g.label, kind: g.kind, options: (g.options || []).map((o) => ({ ...o })) }));
  } else if (base.swatches.length) {
    base.variants = [{ id: "color", label: "Color", kind: "color", options: base.swatches.map((hex, i) => ({ id: `c${i + 1}`, label: hex.toUpperCase(), hex })) }];
  } else base.variants = [];
  return base;
}

function swap(arr, i, j) { const out = arr.slice(); [out[i], out[j]] = [out[j], out[i]]; return out; }
function moveToFront(arr, i) { if (i === 0) return arr.slice(); const out = arr.slice(); const [item] = out.splice(i, 1); out.unshift(item); return out; }

function buildPayload(f, isNew) {
  const p = {
    line: f.line,
    name: (f.name || "").trim(),
    subtitle: (f.subtitle || "").trim(),
    price: Number(f.price) || 0,
    desc: (f.desc || "").trim(),
    weight_g: Number(f.weight_g) || 0,
    dims_cm: { l: Number(f.dims_cm.l) || 0, w: Number(f.dims_cm.w) || 0, h: Number(f.dims_cm.h) || 0 },
    stock_mode: f.stock_mode,
    stock: f.stock_mode === "stock" && f.stock && typeof f.stock === "object" ? f.stock : undefined,
    lead_days: Number(f.lead_days) || 0,
    active: !!f.active,
  };
  if (isNew && f.id) p.id = f.id.trim();
  if (!isNew) p.id = f.id;
  if (f.artist?.trim())   p.artist = f.artist.trim();
  if (f.badge?.trim())    p.badge = f.badge.trim();
  const colorGroup = Array.isArray(f.variants) ? f.variants.find((g) => g && g.kind === "color") : null;
  p.swatches = colorGroup ? (colorGroup.options || []).map((o) => o.hex).filter(Boolean) : [];
  if (Array.isArray(f.images) && f.images.length) {
    p.images = f.images.filter((u) => typeof u === "string" && u.trim()).map((u) => u.trim());
    if (p.images.length) p.image = p.images[0];
  }
  if (Array.isArray(f.variants) && f.variants.length) {
    const cleaned = [];
    for (const g of f.variants) {
      if (!g || !g.label?.trim() || !Array.isArray(g.options)) continue;
      const groupId = (g.id || slugify(g.label)).trim();
      if (!groupId) continue;
      const opts = [];
      for (const o of g.options) {
        if (!o || !o.label?.trim()) continue;
        const optId = (o.id || slugify(o.label)).trim();
        if (!optId) continue;
        const optOut = { id: optId, label: o.label.trim() };
        if (g.kind === "color" && o.hex?.trim()) optOut.hex = o.hex.trim();
        if (Array.isArray(o.images) && o.images.length) optOut.images = o.images.slice();
        if (Number.isFinite(o.priceDelta) && o.priceDelta !== 0) optOut.priceDelta = Math.round(o.priceDelta);
        opts.push(optOut);
      }
      if (opts.length) cleaned.push({ id: groupId, label: g.label.trim(), kind: g.kind === "color" ? "color" : "option", options: opts });
    }
    if (cleaned.length) p.variants = cleaned;
  }
  if (f.promo_active)     p.promo_active = true;
  if (f.promo_price)      p.promo_price = Number(f.promo_price) || 0;
  if (f.promo_label?.trim()) p.promo_label = f.promo_label.trim();
  return p;
}

function AdminField({ label, children }) {
  return (
    <div className="form__field">
      {label && <label className="form__label">{label}</label>}
      {children}
    </div>
  );
}

/* ===================== SettingsPanel ===================== */
function SettingsPanel() {
  const [data, setData] = _aUseState({
    bank: "Mercado Pago", holder: "Nia Sanchez Huck", cuit: "20-42587652-0",
    cbu: "0000003100055059457628", alias: "plasma.design", email: "info@plasma-design.com", notes: "",
  });
  const [loading, setLoading] = _aUseState(true);
  const [saving, setSaving]   = _aUseState(false);
  const [error, setError]     = _aUseState("");
  const [ok, setOk]           = _aUseState(false);

  _aUseEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { db, doc, getDoc } = window.PlasmaFB;
        const snap = await getDoc(doc(db, "settings", "bank_transfer"));
        if (!alive) return;
        if (snap.exists()) {
          const d = snap.data();
          setData({ bank: d.bank || "", holder: d.holder || "", cuit: d.cuit || "", cbu: d.cbu || "", alias: d.alias || "", email: d.email || "", notes: d.notes || "" });
        }
      } catch (e) { if (alive) setError(e.message || "No se pudo cargar settings"); }
      finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, []);

  function set(k, v) { setData((d) => ({ ...d, [k]: v })); setOk(false); }

  async function handleSave() {
    setSaving(true); setError(""); setOk(false);
    try { await window.PlasmaAPI.admin.upsertBankTransfer(data); setOk(true); }
    catch (e) { setError(e.message || "No se pudo guardar"); }
    finally { setSaving(false); }
  }

  if (loading) return <p style={{ color: "rgba(245,240,255,.6)" }}>Cargando settings…</p>;

  return (
    <div className="admin-settings">
      <p style={{ color: "var(--fg-3)", fontSize: 13, margin: "0 0 20px" }}>Lo que cargues acá se muestra en la página de detalle del pedido cuando el cliente eligió "Transferencia bancaria".</p>
      <div className="admin-editor__grid" style={{ gridTemplateColumns: "1fr 1fr" }}>
        <AdminField label="Banco"><input className="form__input" value={data.bank} onChange={(e) => set("bank", e.target.value)} placeholder="ej: Galicia" /></AdminField>
        <AdminField label="Titular"><input className="form__input" value={data.holder} onChange={(e) => set("holder", e.target.value)} placeholder="Nombre y apellido" /></AdminField>
        <AdminField label="CUIT / CUIL"><input className="form__input" value={data.cuit} onChange={(e) => set("cuit", e.target.value)} placeholder="20-12345678-9" /></AdminField>
        <AdminField label="CBU / CVU"><input className="form__input" value={data.cbu} onChange={(e) => set("cbu", e.target.value)} placeholder="22 dígitos" /></AdminField>
        <AdminField label="Alias"><input className="form__input" value={data.alias} onChange={(e) => set("alias", e.target.value)} placeholder="ej: plasma.design" /></AdminField>
        <AdminField label="Email para enviar comprobante"><input className="form__input" type="email" value={data.email} onChange={(e) => set("email", e.target.value)} placeholder="info@plasma-design.com" /></AdminField>
      </div>
      <AdminField label="Notas para el cliente (opcional)">
        <textarea className="form__input" rows="2" value={data.notes} onChange={(e) => set("notes", e.target.value)} placeholder="ej: Verificamos transferencias en horario hábil." />
      </AdminField>

      {error && <p className="form__error" style={{ marginTop: 12 }}>{error}</p>}
      {ok && <p style={{ color: "#4ade80", marginTop: 12 }}>✓ Guardado</p>}

      <div className="admin-editor__actions">
        <button className="btn btn--primary" onClick={handleSave} disabled={saving}>{saving ? "Guardando…" : "Guardar cambios"}</button>
      </div>
    </div>
  );
}

/* ===================== VariantsEditor ===================== */
function VariantsEditor({ value, onChange, uploadFn, productId, uploading }) {
  const groups = Array.isArray(value) ? value : [];
  function update(nextGroups) { onChange(nextGroups); }
  function addGroup(kind) { update([...groups, { id: kind + (groups.length + 1), label: kind === "color" ? "Color" : "Opción", kind, options: [] }]); }
  function updateGroup(idx, patch) { update(groups.map((g, i) => (i === idx ? { ...g, ...patch } : g))); }
  function removeGroup(idx) { update(groups.filter((_, i) => i !== idx)); }
  function addOption(gIdx) { const g = groups[gIdx]; updateGroup(gIdx, { options: [...g.options, { id: "o" + (g.options.length + 1), label: "", ...(g.kind === "color" ? { hex: "#cccccc" } : {}) }] }); }
  function updateOption(gIdx, oIdx, patch) { const g = groups[gIdx]; updateGroup(gIdx, { options: g.options.map((o, i) => (i === oIdx ? { ...o, ...patch } : o)) }); }
  function removeOption(gIdx, oIdx) { const g = groups[gIdx]; updateGroup(gIdx, { options: g.options.filter((_, i) => i !== oIdx) }); }
  async function handleOptionUpload(gIdx, oIdx, files) {
    const fileArr = Array.from(files || []);
    if (!fileArr.length) return;
    try {
      const uploaded = [];
      for (const file of fileArr) { const { url } = await uploadFn(productId, file); uploaded.push(url); }
      const g = groups[gIdx]; const opt = g.options[oIdx];
      updateOption(gIdx, oIdx, { images: [...(opt.images || []), ...uploaded] });
    } catch (err) { alert("Error subiendo imagen: " + (err.message || err)); }
  }
  return (
    <div className="vedit">
      {groups.length === 0 && <p style={{ fontSize: 13, color: "var(--fg-3)" }}>Todavía no hay grupos de variantes.</p>}
      {groups.map((g, gIdx) => (
        <div key={gIdx} className="vedit__group">
          <div className="vedit__group-head">
            <input className="form__input vedit__group-label" value={g.label} onChange={(e) => updateGroup(gIdx, { label: e.target.value })} placeholder={g.kind === "color" ? "Color" : "Bombilla / Tamaño / etc."} />
            <span className="vedit__group-kind">{g.kind === "color" ? "● color" : "○ opción"}</span>
            <button type="button" className="btn btn--ghost btn--small btn--danger" onClick={() => removeGroup(gIdx)}>Quitar grupo</button>
          </div>
          {g.options.length > 0 && (
            <div className={"vedit__opts-head" + (g.kind === "color" ? " vedit__opts-head--color" : "")}>
              {g.kind === "color" && <span aria-hidden="true" />}<span>Nombre</span><span>Precio (+/-)</span><span aria-hidden="true" /><span aria-hidden="true" /><span aria-hidden="true" />
            </div>
          )}
          <ul className="vedit__opts">
            {g.options.map((o, oIdx) => (
              <li key={oIdx} className={"vedit__opt" + (g.kind === "color" ? " vedit__opt--color" : "")}>
                {g.kind === "color" ? <input type="color" className="vedit__opt-color" value={o.hex || "#cccccc"} onChange={(e) => updateOption(gIdx, oIdx, { hex: e.target.value })} aria-label="Color" /> : null}
                <input className="form__input vedit__opt-label" value={o.label} onChange={(e) => updateOption(gIdx, oIdx, { label: e.target.value })} placeholder={g.kind === "color" ? "Blanco" : "RGB IR"} />
                <input className="form__input vedit__opt-delta" type="number" value={o.priceDelta || 0} onChange={(e) => updateOption(gIdx, oIdx, { priceDelta: Number(e.target.value) || 0 })} placeholder="$ +/-" title="Ajuste de precio sobre el base. 0 = sin cambio." aria-label="Ajuste de precio" />
                <label className="btn btn--ghost btn--small vedit__opt-upload" title="Subir imágenes para esta variante">📷
                  <input type="file" accept="image/*" multiple style={{ display: "none" }} disabled={uploading} onChange={(e) => { handleOptionUpload(gIdx, oIdx, e.target.files); e.target.value = ""; }} />
                </label>
                {(o.images?.length || 0) > 0 && (
                  <button type="button" className="vedit__opt-imgs" title="Quitar las imágenes de esta variante"
                    onClick={() => updateOption(gIdx, oIdx, { images: [] })}
                    style={{ cursor: "pointer", background: "rgba(248,113,113,.08)", border: ".5px solid rgba(248,113,113,.22)", borderRadius: 6, color: "#FCA5A5", padding: "2px 6px", font: "inherit", fontSize: 11 }}>
                    {o.images.length} img ✕
                  </button>
                )}
                <button type="button" className="btn btn--ghost btn--small btn--danger" onClick={() => removeOption(gIdx, oIdx)}>×</button>
              </li>
            ))}
          </ul>
          <button type="button" className="btn btn--ghost btn--small" onClick={() => addOption(gIdx)}>+ Agregar opción</button>
        </div>
      ))}
      <div className="vedit__add">
        <button type="button" className="btn btn--ghost btn--small" onClick={() => addGroup("color")}>+ Grupo de colores</button>
        <button type="button" className="btn btn--ghost btn--small" onClick={() => addGroup("option")}>+ Grupo de opciones</button>
      </div>
    </div>
  );
}

/* ===================== StockEditor ===================== */
function StockEditor({ stockMode, stock, variants, onChangeMode, onChange }) {
  const isStock = stockMode === "stock";
  const combos = _aUseMemo(() => {
    const groups = Array.isArray(variants) ? variants.filter((g) => g.options?.length) : [];
    if (groups.length === 0) return [{ key: "default", label: "Producto" }];
    let result = [{ parts: [], labels: [] }];
    for (const g of groups) {
      const next = [];
      for (const prev of result) for (const opt of g.options) next.push({ parts: [...prev.parts, [g.id, opt.id]], labels: [...prev.labels, opt.label] });
      result = next;
    }
    return result.map(({ parts, labels }) => {
      const sorted = parts.slice().sort((a, b) => a[0].localeCompare(b[0]));
      return { key: sorted.map(([g, o]) => g + "=" + o).join("|"), label: labels.join(" · ") };
    });
  }, [variants]);

  function setAt(key, value) {
    const next = { ...(stock || {}) };
    if (value === "" || value == null) delete next[key];
    else { const n = parseInt(value, 10); if (Number.isFinite(n) && n >= 0) next[key] = n; }
    onChange(next);
  }

  return (
    <div className="stock-edit">
      <AdminField label="">
        <label className="admin-toggle">
          <input type="checkbox" checked={isStock} onChange={(e) => onChangeMode(e.target.checked ? "stock" : "on_demand")} />
          <span>Llevar stock (se decrementa con cada venta)</span>
        </label>
      </AdminField>
      {isStock && (
        <ul className="stock-edit__list">
          {combos.map((c) => (
            <li key={c.key || "_none_"} className="stock-edit__row">
              <span className="stock-edit__label">{c.label}</span>
              <input className="form__input stock-edit__qty" type="number" min="0" step="1" value={stock && stock[c.key] != null ? stock[c.key] : ""} placeholder="0" onChange={(e) => setAt(c.key, e.target.value)} />
              <span className="stock-edit__hint">{stock && stock[c.key] === 0 ? "Sin stock" : stock && stock[c.key] > 0 ? "disponible" : "vacío = 0"}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

;
/* ==== app.jsx ==== */
/* global React, ReactDOM,
   LampNebula, LampHex, LampHelix, LampWave, LampMesh, LampPulse,
   AccVase, AccBowl, AccCoasters, AccPot,
   TweaksPanel, TweakSection, TweakRadio, TweakColor, TweakToggle, useTweaks,
   useAuth, useProducts, useCart, useHashRoute, useShippingQuote, navigate,
   LoginModal, CheckoutView, OrderView, AdminView, ProfileView, MyOrdersView,
   fmt, I */

/* Error boundary global — evita que un crash en cualquier rama (ej. producto
   con campos faltantes en Firestore) blanquee el sitio entero. */
class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("[ErrorBoundary]", error, info); }
  render() {
    if (this.state.error) {
      return (
        <div className="shell" style={{ padding: 40, minHeight: "60vh" }}>
          <h1>Algo se rompió</h1>
          <p style={{ color: "var(--fg-3)", marginTop: 8 }}>
            {this.state.error?.message || "Error inesperado"}
          </p>
          <button className="btn btn--primary" style={{ marginTop: 16 }} onClick={() => location.reload()}>Recargar</button>
        </div>
      );
    }
    return this.props.children;
  }
}

/* Si es true se renderea el nombre del artista debajo del nombre del producto.
   Apagado por ahora — los datos siguen guardándose en product.artist y se pueden
   mostrar flipping este flag en true. */
const SHOW_ARTIST_BYLINE = false;

/* Devuelve { effectivePrice, hasPromo, originalPrice } para un producto. */
function effectivePricing(p) {
  const hasPromo = !!(p.promo_active && p.promo_price && p.promo_price > 0 && p.promo_price < p.price);
  return {
    effectivePrice: hasPromo ? p.promo_price : p.price,
    originalPrice: p.price,
    hasPromo,
    promoLabel: hasPromo ? (p.promo_label || "Oferta") : null,
  };
}

// =====================================================
// Plasma Design — main React app
// =====================================================
// fmt e iconos vienen de common.jsx (cargado antes).

// useState/useEffect/useMemo ya están declarados en hooks.jsx — sólo agrego useRef
const { useRef } = React;

/* ===================== UserMenu =====================
   Dropdown flotante que reemplaza el viejo botón "click → logout".
   Click en el trigger abre/cierra. Click afuera cierra. Esc también.
   Al abrirse fuerza refresh del ID token (refreshClaims) para que aparezca
   "Panel admin" si fuiste promovido en otra sesión y tu token está cacheado.
*/
function UserMenu({ user, isAdmin, onLogout, refreshClaims }) {
  const [open, setOpen] = useState(false);
  // Estado local de admin para esta UserMenu — fallback al prop, pero se
  // actualiza directo desde el token cuando abrimos el menú. Esto cubre
  // el caso donde el state global de useAuth no llegó a actualizarse aún.
  const [localAdmin, setLocalAdmin] = useState(false);
  const containerRef = useRef(null);

  const showAdmin = isAdmin || localAdmin;

  useEffect(() => {
    if (!open) return undefined;
    // Al abrir: leo el ID token directo del SDK (forzando refresh) y seteo
    // mi estado local. También bumpeo el global vía refreshClaims (no espero).
    if (refreshClaims) refreshClaims().catch(() => {});
    (async () => {
      try {
        const tok = await user.getIdTokenResult(true);
        if (tok?.claims?.admin === true) setLocalAdmin(true);
      } catch { /* no-op */ }
    })();

    function onDocClick(ev) {
      if (!containerRef.current?.contains(ev.target)) setOpen(false);
    }
    function onKey(ev) { if (ev.key === "Escape") setOpen(false); }
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onKey);
    };
  }, [open, refreshClaims, user]);

  const label = (user.displayName || user.email || "Cuenta").split(" ")[0];

  function go(hash) {
    setOpen(false);
    navigate(hash);
  }

  return (
    <div className="user-menu" ref={containerRef}>
      <button
        type="button"
        className="header-user"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        title={user.email}
      >
        {label}
        <span className="user-menu__chev" aria-hidden="true">▾</span>
      </button>
      {open && (
        <div className="user-menu__pop" role="menu">
          <div className="user-menu__hello">
            <div className="user-menu__name">{user.displayName || label}</div>
            <div className="user-menu__email">{user.email}</div>
          </div>
          <div className="user-menu__sep" />
          {showAdmin && (
            <button type="button" role="menuitem" className="user-menu__item" onClick={() => go("#/admin")}>
              Panel admin
            </button>
          )}
          <button type="button" role="menuitem" className="user-menu__item" onClick={() => go("#/perfil")}>
            Mi perfil
          </button>
          <button type="button" role="menuitem" className="user-menu__item" onClick={() => go("#/mis-pedidos")}>
            Mis pedidos
          </button>
          <div className="user-menu__sep" />
          <button type="button" role="menuitem" className="user-menu__item user-menu__item--danger" onClick={() => { setOpen(false); onLogout(); }}>
            Cerrar sesión
          </button>
        </div>
      )}
    </div>
  );
}

/* ===================== Header ===================== */
function Header({ cartCount, onCartClick, user, isAdmin, refreshClaims, onLoginClick, onLogout }) {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a href="#/" className="logo" aria-label="Plasma Design — inicio">
          <span className="logo__mark">plasma</span>
          <span className="logo__sub">design</span>
        </a>
        <nav className="site-nav" aria-label="Principal">
          <a href="#lamps">Lámparas</a>
          <a href="#accessories">Accesorios</a>
          <a href="#contact">Contacto</a>
        </nav>
        <div className="header-actions">
          <button className="icon-btn" aria-label="Buscar">{I.search}</button>
          <button className="icon-btn mobile-menu-btn" aria-label="Menú">{I.menu}</button>
          {user ? (
            <UserMenu user={user} isAdmin={isAdmin} onLogout={onLogout} refreshClaims={refreshClaims} />
          ) : (
            <button className="header-user" onClick={onLoginClick}>Ingresar</button>
          )}
          <button className="icon-btn" aria-label={`Carrito, ${cartCount} ítems`} onClick={onCartClick}>
            {I.bag}
            {cartCount > 0 && <span className="icon-btn__badge" key={cartCount}>{cartCount}</span>}
          </button>
        </div>
      </div>
    </header>
  );
}

/* ===================== Hero =====================
   El "visual" rota como una publicación: ciclamos por todos los productos
   activos que tengan al menos una imagen. Si no hay nada en Firestore,
   cae a la foto hardcodeada de Abyssal para no quedar vacío. */
const HERO_ROTATE_MS = 7000;
const HERO_FADE_MS   = 900;

function Hero({ onShopClick, products = [] }) {
  // Selecciono "publicaciones" = productos activos con al menos una imagen.
  const publications = useMemo(() => {
    const out = [];
    for (const p of products) {
      const imgs = Array.isArray(p.images) && p.images.length ? p.images : (p.image ? [p.image] : []);
      if (!imgs.length) continue;
      // Una publicación = un producto × su primera imagen (la portada).
      out.push({ id: p.id, name: p.name, artist: p.artist || null, image: imgs[0] });
    }
    return out;
  }, [products]);

  const fallback = { id: "_fallback", name: "Abyssal", artist: "MODERN MACHINE", image: "img/abyssal-2.jpg" };
  const items = publications.length ? publications : [fallback];

  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  // Si el array cambia de tamaño, vuelvo el índice a 0 para evitar fuera-de-rango.
  useEffect(() => { setIdx(0); }, [items.length]);

  useEffect(() => {
    if (items.length < 2 || paused) return undefined;
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % items.length);
    }, HERO_ROTATE_MS);
    return () => clearInterval(id);
  }, [items.length, paused]);

  function goPrev(e) { e?.stopPropagation(); setIdx((i) => (i - 1 + items.length) % items.length); }
  function goNext(e) { e?.stopPropagation(); setIdx((i) => (i + 1) % items.length); }

  const current = items[idx] || items[0];

  return (
    <section className="hero shell">
      <div className="hero__grid">
        <div className="hero__copy">
          <h1 className="hero__title">
            Luz impresa<br />
            en <em>tres dimensiones</em>.
          </h1>
          <p className="hero__lead">
            Estudio de impresión 3D. Diseños modernos creados por artistas,
            fabricados en Buenos Aires.
          </p>
          <div className="hero__cta-row">
            <button className="btn btn--primary" onClick={onShopClick}>
              Explorar la colección {I.arrowRight}
            </button>
          </div>
        </div>
        <div
          className="hero__visual"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          <div className="hero__visual-frame" />
          {items.map((it, i) => (
            <img
              key={it.id + i}
              src={it.image}
              alt={it.name}
              className={"hero__visual-photo hero__visual-photo--fade" + (i === idx ? " hero__visual-photo--active" : "")}
              style={{ transitionDuration: `${HERO_FADE_MS}ms` }}
              loading={i === 0 ? "eager" : "lazy"}
            />
          ))}
          {items.length > 1 && (
            <>
              <button type="button" className="hero__nav hero__nav--prev" aria-label="Publicación anterior" onClick={goPrev}>‹</button>
              <button type="button" className="hero__nav hero__nav--next" aria-label="Publicación siguiente" onClick={goNext}>›</button>
              <div className="hero__dots" aria-hidden="true">
                {items.map((_, i) => (
                  <span key={i} className={"hero__dot" + (i === idx ? " hero__dot--active" : "")} />
                ))}
              </div>
            </>
          )}
          <div className="hero__visual-tag">
            {current.name}
            {SHOW_ARTIST_BYLINE && current.artist && (
              <> · <span className="hero__visual-tag-by">by {current.artist}</span></>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ===================== Product card ===================== */
/* Intervalo y delay del cross-fade de la galería. */
const GALLERY_ROTATE_MS = 4500;
const GALLERY_FADE_MS   = 700;

/* Inicializa selectedVariants con la primera opción de cada grupo. */
function defaultVariantSelection(product) {
  const sel = {};
  for (const g of (product.variants || [])) {
    if (g.options?.[0]) sel[g.id] = g.options[0].id;
  }
  return sel;
}

/* Serializa selectedVariants a la key usada para stock y líneas de carrito.
   Misma convención que el backend lib/variantKey.ts. */
function variantKey(v) {
  if (!v || typeof v !== "object") return "";
  const keys = Object.keys(v).sort();
  return keys.map((k) => k + "=" + v[k]).join("|");
}

/* Devuelve stock disponible para la combinación elegida.
   `null` = unlimited (producto sin stock_mode=stock o sin map). */
function stockFor(product, selectedVariants) {
  if (!product || product.stock_mode !== "stock") return null;
  if (!product.stock || typeof product.stock !== "object") return null;
  // Sin variantes → "default" (Firestore no permite "" como clave de mapa).
  const key = variantKey(selectedVariants) || "default";
  const v = product.stock[key];
  return typeof v === "number" ? v : 0;
}

/* Computa total con priceDelta de variantes seleccionadas. */
function priceWithVariants(product, selectedVariants) {
  const promo = effectivePricing(product);
  let delta = 0;
  for (const g of (product.variants || [])) {
    const optId = selectedVariants?.[g.id];
    if (!optId) continue;
    const opt = g.options.find((o) => o.id === optId);
    if (opt?.priceDelta) delta += opt.priceDelta;
  }
  return {
    base: promo.effectivePrice,
    originalBase: promo.originalPrice,
    hasPromo: promo.hasPromo,
    promoLabel: promo.promoLabel,
    total: Math.max(0, promo.effectivePrice + delta),
    delta,
  };
}

function ProductCard({ product, onAdd, galleryOffset = 0, onOpenQuickView }) {
  const [added, setAdded] = useState(false);
  const ref = useRef(null);

  const [selectedVariants, setSelectedVariants] = useState(() => defaultVariantSelection(product));
  // `colorTouched` = el usuario eligió un color a propósito (clic en swatch).
  // Mientras sea false, el carrusel muestra SOLO la galería principal del
  // producto; las fotos de las variantes aparecen recién cuando se clickea.
  const [colorTouched, setColorTouched] = useState(false);

  // Si el producto cambia (lista nueva del catálogo), resetear selección.
  useEffect(() => {
    setSelectedVariants(defaultVariantSelection(product));
    setColorTouched(false);
  }, [product.id]);

  function handleMove(e) {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - r.left}px`);
    el.style.setProperty("--my", `${e.clientY - r.top}px`);
  }

  // Siempre abrimos el quick-view para que el cliente confirme variantes y
  // pueda cotizar envío antes de sumar al carrito.
  function handleAdd(e) {
    e.stopPropagation();
    if (onOpenQuickView) {
      onOpenQuickView(product, selectedVariants);
      return;
    }
    onAdd(product, selectedVariants);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  }

  const Visual = product.visual;
  const pricing = priceWithVariants(product, selectedVariants);
  const stock = stockFor(product, selectedVariants);
  const outOfStock = stock !== null && stock <= 0;

  // Galería del carrusel:
  //  · Por defecto → SOLO las imágenes principales del producto (lista normal).
  //  · Cuando el cliente clickea un color → las imágenes propias de esa variante
  //    (si tiene); si la variante no tiene fotos, caemos a las del producto.
  // Así las fotos de variantes no se mezclan ni se repiten en el carrusel.
  const gallery = useMemo(() => {
    const productImgs = Array.isArray(product.images) && product.images.length
      ? product.images
      : (product.image ? [product.image] : []);
    if (colorTouched) {
      const variantImgs = [];
      for (const g of (product.variants || [])) {
        const optId = selectedVariants?.[g.id];
        const opt = g.options.find((o) => o.id === optId);
        if (opt?.images?.length) variantImgs.push(...opt.images);
      }
      if (variantImgs.length) return [...new Set(variantImgs.filter(Boolean))];
    }
    return [...new Set(productImgs.filter(Boolean))];
  }, [product.images, product.image, product.variants, selectedVariants, colorTouched]);

  // Grupo de colores (si hay) → swatches clickeables en la card.
  const colorGroup = (product.variants || []).find((g) => g.kind === "color");

  function pickColor(optId, e) {
    e?.stopPropagation();
    if (!colorGroup) return;
    setColorTouched(true);  // a partir de ahora el carrusel muestra la variante
    setSelectedVariants((s) => ({ ...s, [colorGroup.id]: optId }));
    setImgIdx(0);  // resetear gallery cuando cambiamos de color
  }

  // Rotación de imágenes: si hay más de una, ciclamos con intervalo + cross-fade.
  // galleryOffset escalona el arranque entre cards (solo la primera vez) para
  // que no parpadeen todas al mismo tiempo.
  const [imgIdx, setImgIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const [restartKey, setRestartKey] = useState(0);  // bump → reinicia el timer
  const firstRunRef = useRef(true);
  useEffect(() => {
    if (gallery.length < 2 || paused) return undefined;
    const delay = firstRunRef.current ? galleryOffset : 0;
    firstRunRef.current = false;
    let intervalId = null;
    const startTimer = setTimeout(() => {
      intervalId = setInterval(() => {
        setImgIdx((i) => (i + 1) % gallery.length);
      }, GALLERY_ROTATE_MS);
    }, delay);
    return () => {
      clearTimeout(startTimer);
      if (intervalId) clearInterval(intervalId);
    };
  }, [gallery.length, paused, galleryOffset, restartKey]);

  function goPrev(e) {
    e?.stopPropagation();
    if (gallery.length < 2) return;
    setImgIdx((i) => (i - 1 + gallery.length) % gallery.length);
    setRestartKey((k) => k + 1);  // reinicia el timer para que el próximo cambio auto sea en GALLERY_ROTATE_MS, no inmediato
  }
  function goNext(e) {
    e?.stopPropagation();
    if (gallery.length < 2) return;
    setImgIdx((i) => (i + 1) % gallery.length);
    setRestartKey((k) => k + 1);
  }

  return (
    <article
      ref={ref}
      className="product-card"
      onMouseMove={handleMove}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className={"product-card__media" + (gallery.length ? " product-card__media--photo" : "")}>
        {product.badge && <span className="product-card__media-tag">{product.badge}</span>}
        {pricing.hasPromo && (
          <span className="product-card__media-tag product-card__media-tag--promo">{pricing.promoLabel}</span>
        )}
        {gallery.length > 0 ? (
          <>
            {gallery.map((src, i) => (
              <img
                key={src + i}
                src={src}
                alt={product.name}
                className={"product-card__photo product-card__photo--fade" + (i === imgIdx ? " product-card__photo--active" : "")}
                style={{ transitionDuration: `${GALLERY_FADE_MS}ms` }}
                loading={i === 0 ? "eager" : "lazy"}
                decoding="async"
              />
            ))}
            {gallery.length > 1 && (
              <>
                <button
                  type="button"
                  className="product-card__nav product-card__nav--prev"
                  aria-label="Imagen anterior"
                  onClick={goPrev}
                >‹</button>
                <button
                  type="button"
                  className="product-card__nav product-card__nav--next"
                  aria-label="Imagen siguiente"
                  onClick={goNext}
                >›</button>
                <div className="product-card__dots" aria-hidden="true">
                  {gallery.map((_, i) => (
                    <span key={i} className={"product-card__dot" + (i === imgIdx ? " product-card__dot--active" : "")} />
                  ))}
                </div>
              </>
            )}
          </>
        ) : (
          Visual ? <Visual /> : null
        )}
      </div>
      <div className="product-card__body">
        <div className="product-card__head">
          <h3 className="product-card__name">
            {product.name}
            {SHOW_ARTIST_BYLINE && product.artist && (
              <span className="product-card__byline">by {product.artist}</span>
            )}
          </h3>
          <span className="product-card__price">
            {pricing.hasPromo ? (
              <>
                <span className="product-card__price-old">{fmt(pricing.originalBase)}</span>
                {fmt(pricing.total)}
              </>
            ) : fmt(pricing.total)}
          </span>
        </div>
        <p className="product-card__desc">{product.subtitle} · {product.desc}</p>
        <div className="product-card__foot">
          <div className="product-card__swatches" aria-label="Elegí color">
            {colorGroup && colorGroup.options.map((opt) => {
              const selected = selectedVariants[colorGroup.id] === opt.id;
              return (
                <button
                  key={opt.id}
                  type="button"
                  className={"product-card__swatch product-card__swatch--btn" + (selected ? " product-card__swatch--selected" : "")}
                  style={{ background: opt.hex || "#888" }}
                  onClick={(e) => pickColor(opt.id, e)}
                  aria-label={opt.label}
                  aria-pressed={selected}
                  title={opt.label}
                />
              );
            })}
          </div>
          {outOfStock ? (
            <div className="product-card__oos">
              <span className="product-card__oos-tag">Sin stock</span>
              <button
                className="product-card__add product-card__add--produce"
                onClick={handleAdd}
                title="A pedido — demora ~4-5 días más, además del envío"
              >
                {I.plus} A pedido
              </button>
            </div>
          ) : (
            <button
              className={"product-card__add" + (added ? " product-card__add--added" : "")}
              onClick={handleAdd}
            >
              {added ? <>{I.check} Agregado</> : <>{I.plus} Agregar</>}
            </button>
          )}
        </div>
      </div>
    </article>
  );
}

/* ===================== Product section ===================== */
function ProductSection({ id, eyebrow, title, sub, products, onAdd, onOpenQuickView, density = "all", onDensityChange }) {
  return (
    <section id={id} className="section shell">
      <div className="section__head">
        <div className="section__title-block">
          <div className="section__eyebrow">{eyebrow}</div>
          <h2 className="section__title">{title}</h2>
          <p className="section__sub">{sub}</p>
        </div>
        {onDensityChange && (
          <div className="section__filter" role="tablist">
            {[
              { id: "all", label: "Todas" },
              { id: "new", label: "Nuevas" },
              { id: "best", label: "Más vendidas" },
            ].map((f) => (
              <button key={f.id}
                      aria-pressed={density === f.id}
                      onClick={() => onDensityChange(f.id)}>
                {f.label}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="product-grid">
        {products.map((p, i) => (
          <ProductCard
            key={p.id}
            product={p}
            onAdd={onAdd}
            onOpenQuickView={onOpenQuickView}
            galleryOffset={(i * 900) % GALLERY_ROTATE_MS}
          />
        ))}
      </div>
    </section>
  );
}

/* ===================== Catalog skeleton ===================== */
/* Placeholder mientras carga el catálogo por PRIMERA vez (sin cache). Imita la
   estructura de una sección + grilla para que no haya un salto brusco. */
function CatalogSkeleton({ count = 6 }) {
  return (
    <section className="section shell" aria-hidden="true">
      <div className="section__head">
        <div className="section__title-block">
          <div className="skeleton skeleton--eyebrow" />
          <div className="skeleton skeleton--title" />
          <div className="skeleton skeleton--sub" />
        </div>
      </div>
      <div className="product-grid">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="product-card product-card--skeleton">
            <div className="skeleton skeleton--media" />
            <div className="product-card__body">
              <div className="skeleton skeleton--line" style={{ width: "70%" }} />
              <div className="skeleton skeleton--line" style={{ width: "40%" }} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

/* ===================== Promo strip ===================== */
function PromoStrip() {
  return (
    <div className="shell">
      <div className="promo-strip">
        <div className="promo-strip__icon">{I.truck}</div>
        <div>
          <p className="promo-strip__title">Envíos a todo el país en 5–7 días</p>
        </div>
        <a href="#contact" className="btn btn--ghost btn--small">Ver detalles {I.arrowRight}</a>
      </div>
    </div>
  );
}

/* ===================== Cart drawer ===================== */
/** Devuelve "Blanco · RGB IR" desde las selecciones de variantes. */
function describeVariants(product, selections) {
  if (!product?.variants || !selections) return "";
  const parts = [];
  for (const g of product.variants) {
    const optId = selections[g.id];
    if (!optId) continue;
    const opt = g.options.find((o) => o.id === optId);
    if (opt?.label) parts.push(opt.label);
  }
  return parts.join(" · ");
}

function CartDrawer({ open, onClose, items, onQty, onCheckout }) {
  const subtotal = items.reduce((s, it) => {
    if (!it.product) return s;
    const pricing = priceWithVariants(it.product, it.variants);
    return s + pricing.total * it.qty;
  }, 0);

  return (
    <>
      <div className="cart-backdrop" data-open={open} onClick={onClose} />
      <aside className="cart-drawer" data-open={open} aria-label="Carrito">
        <div className="cart-drawer__head">
          <h3 className="cart-drawer__title">
            Carrito
            <small>{items.length} {items.length === 1 ? "ítem" : "ítems"}</small>
          </h3>
          <button className="icon-btn" onClick={onClose} aria-label="Cerrar carrito">{I.close}</button>
        </div>
        <div className="cart-drawer__body">
          {items.length === 0 ? (
            <div className="cart-drawer__empty">
              <div className="cart-drawer__empty-icon">{I.bag}</div>
              <p style={{ fontSize: 15, color: "var(--fg-2)", margin: 0 }}>Tu carrito está vacío</p>
              <p style={{ fontSize: 13, margin: 0 }}>Explorá la colección y sumá tu primera pieza.</p>
            </div>
          ) : (
            items.map((it, idx) => {
              if (!it.product) return null; // producto no encontrado, ignorar
              const Visual = it.product.visual;
              const pr = priceWithVariants(it.product, it.variants);
              const variantText = describeVariants(it.product, it.variants);
              // Imagen específica de la variante si la hay
              let thumbSrc = null;
              for (const g of (it.product.variants || [])) {
                const opt = g.options.find((o) => o.id === it.variants?.[g.id]);
                if (opt?.images?.length) { thumbSrc = opt.images[0]; break; }
              }
              if (!thumbSrc) thumbSrc = it.product.image;
              return (
                <div key={it.product.id + "-" + idx} className="cart-item">
                  <div className="cart-item__thumb">
                    {thumbSrc
                      ? <img src={thumbSrc} alt={it.product.name} />
                      : Visual ? <Visual /> : null}
                  </div>
                  <div>
                    <p className="cart-item__name">{it.product.name}</p>
                    {variantText && <p className="cart-item__variants">{variantText}</p>}
                    <p className="cart-item__price">
                      {pr.hasPromo && <span className="product-card__price-old" style={{ marginRight: 6 }}>{fmt(pr.originalBase + pr.delta)}</span>}
                      {fmt(pr.total)} c/u
                    </p>
                  </div>
                  <div className="cart-item__qty">
                    <button onClick={() => onQty(it.product.id, -1, it.variants)} aria-label="Quitar uno">−</button>
                    <span>{it.qty}</span>
                    <button onClick={() => onQty(it.product.id, +1, it.variants)} aria-label="Sumar uno">+</button>
                  </div>
                </div>
              );
            })
          )}
        </div>
        {items.length > 0 && (
          <div className="cart-drawer__foot">
            <div className="cart-totals">
              <div className="cart-totals__row"><span>Subtotal</span><span>{fmt(subtotal)}</span></div>
              <div className="cart-totals__row cart-totals__row--total"><span>Total</span><span>{fmt(subtotal)}</span></div>
              <p className="cart-totals__note">Envío se calcula en el checkout según tu CP.</p>
            </div>
            <button className="btn btn--primary cart-drawer__cta" onClick={onCheckout}>
              Finalizar compra {I.arrowRight}
            </button>
          </div>
        )}
      </aside>
    </>
  );
}

/* ===================== Footer ===================== */
function Footer() {
  return (
    <footer id="contact" className="footer">
      <div className="shell">
        <div className="footer__grid">
          <div className="footer__brand">
            <a href="#" className="logo">
              <span className="logo__mark">plasma</span>
              <span className="logo__sub">design</span>
            </a>
            <p className="footer__brand-blurb">
              Estudio de impresión 3D. Fabricamos lámparas y objetos
              decorativos en Buenos Aires.
            </p>
            <div className="footer__socials">
              <a href="#" className="footer__social" aria-label="Instagram">{I.instagram}</a>
              <a href="#" className="footer__social" aria-label="TikTok">{I.tiktok}</a>
              <a href="#" className="footer__social" aria-label="WhatsApp">{I.whatsapp}</a>
              <a href="#" className="footer__social" aria-label="Email">{I.mail}</a>
            </div>
          </div>
          <div className="footer__col">
            <p className="footer__col-title">Tienda</p>
            <ul>
              <li><a href="#lamps">Lámparas LED</a></li>
              <li><a href="#accessories">Accesorios</a></li>
            </ul>
          </div>
        </div>
        <div className="footer__bottom">
          <span>© 2026 Plasma Design — Buenos Aires, AR</span>
          <div className="footer__bottom-links">
            <a href="#">Términos</a>
            <a href="#">Privacidad</a>
            <a href="#">Envíos y cambios</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

/* ===================== Tweaks ===================== */
function PlasmaTweaks() {
  const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
    "accent": "magenta",
    "ambient": true,
    "noise": true,
    "headerStyle": "pill"
  }/*EDITMODE-END*/;

  const [t, setTweak] = useTweaks(TWEAK_DEFAULTS);

  useEffect(() => {
    const root = document.documentElement;
    // Accent palette
    const accents = {
      magenta: { brand: "linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%)", glowA: "rgba(139, 92, 246, 0.25)", glowB: "rgba(217, 70, 239, 0.6)" },
      violet:  { brand: "linear-gradient(135deg, #6d28d9 0%, #a78bfa 100%)", glowA: "rgba(109, 40, 217, 0.3)",  glowB: "rgba(167, 139, 250, 0.55)" },
      indigo:  { brand: "linear-gradient(135deg, #4338ca 0%, #818cf8 100%)", glowA: "rgba(67, 56, 202, 0.3)",   glowB: "rgba(129, 140, 248, 0.55)" },
      cyan:    { brand: "linear-gradient(135deg, #1e3a8a 0%, #22d3ee 100%)", glowA: "rgba(34, 211, 238, 0.25)", glowB: "rgba(34, 211, 238, 0.5)" },
    };
    const a = accents[t.accent] || accents.magenta;
    root.style.setProperty("--gradient-brand", a.brand);
    root.style.setProperty("--glow-violet", `0 0 24px ${a.glowA}`);

    document.body.classList.toggle("no-ambient", !t.ambient);
    document.body.classList.toggle("no-noise", !t.noise);
    document.body.dataset.headerStyle = t.headerStyle;
  }, [t]);

  return (
    <TweaksPanel title="Tweaks">
      <TweakSection title="Acento de marca">
        <TweakRadio
          label="Paleta"
          options={[
            { value: "magenta", label: "Magenta" },
            { value: "violet",  label: "Violeta" },
          ]}
          value={t.accent === "indigo" || t.accent === "cyan" ? "magenta" : t.accent}
          onChange={(v) => setTweak("accent", v)}
        />
        <TweakColor
          label="Más paletas"
          options={[
            ["#8b5cf6", "#d946ef"],
            ["#6d28d9", "#a78bfa"],
            ["#4338ca", "#818cf8"],
            ["#1e3a8a", "#22d3ee"],
          ]}
          value={
            t.accent === "magenta" ? ["#8b5cf6", "#d946ef"] :
            t.accent === "violet"  ? ["#6d28d9", "#a78bfa"] :
            t.accent === "indigo"  ? ["#4338ca", "#818cf8"] :
                                     ["#1e3a8a", "#22d3ee"]
          }
          onChange={(v) => {
            const key =
              v[0] === "#8b5cf6" ? "magenta" :
              v[0] === "#6d28d9" ? "violet"  :
              v[0] === "#4338ca" ? "indigo"  : "cyan";
            setTweak("accent", key);
          }}
        />
      </TweakSection>
      <TweakSection title="Atmósfera">
        <TweakToggle
          label="Orbes ambientales"
          value={t.ambient}
          onChange={(v) => setTweak("ambient", v)}
        />
        <TweakToggle
          label="Grano sutil"
          value={t.noise}
          onChange={(v) => setTweak("noise", v)}
        />
      </TweakSection>
    </TweaksPanel>
  );
}

/* ===================== QuickView modal =====================
   Aparece cuando se agrega al carrito un producto con grupos de opciones
   (no-color). Permite elegir TODAS las variantes (color + extras) y muestra
   el precio final calculado. */
function QuickView({ view, onClose, onConfirm }) {
  const [variants, setVariants] = useState(view?.initial || {});
  const [cp, setCp] = useState("");
  const [shipErr, setShipErr] = useState(null);
  const ship = useShippingQuote();

  useEffect(() => {
    setVariants(view?.initial || {});
    setCp("");
    setShipErr(null);
    ship.setQuotes([]);
  }, [view?.product?.id]);

  if (!view) return null;
  const { product } = view;
  const groups = product.variants || [];

  const pricing = priceWithVariants(product, variants);
  const cpValid = /^\d{4}$/.test(cp.trim());

  async function handleQuote() {
    setShipErr(null);
    if (!cpValid) {
      setShipErr("Ingresá un CP de 4 dígitos");
      return;
    }
    try {
      await ship.fetchQuote({
        cp: cp.trim(),
        items: [{ productId: product.id, qty: 1 }],
      });
    } catch (err) {
      setShipErr(err?.message || "No se pudo cotizar el envío");
    }
  }

  // Imagen: primero busca imágenes del color variant elegido; fallback a las del producto.
  let imageList = [];
  for (const g of groups) {
    const opt = g.options.find((o) => o.id === variants[g.id]);
    if (opt?.images?.length) { imageList = opt.images; break; }
  }
  if (!imageList.length) imageList = Array.isArray(product.images) && product.images.length ? product.images : (product.image ? [product.image] : []);
  const heroImage = imageList[0];

  function pick(groupId, optId) {
    setVariants((v) => ({ ...v, [groupId]: optId }));
  }

  return (
    <>
      <div className="qv-backdrop" onClick={onClose} />
      <aside className="qv" role="dialog" aria-label={`Agregar ${product.name} al carrito`}>
        <button className="qv__close icon-btn" onClick={onClose} aria-label="Cerrar">{I.close}</button>

        <div className="qv__media">
          {heroImage ? (
            <img src={heroImage} alt={product.name} />
          ) : (
            product.visual ? React.createElement(product.visual) : null
          )}
        </div>

        <div className="qv__body">
          <h2 className="qv__title">{product.name}</h2>
          <p className="qv__sub">{product.subtitle}</p>

          {groups.map((g) => (
            <div key={g.id} className="qv__group">
              <p className="qv__group-label">{g.label}</p>
              {g.kind === "color" ? (
                <div className="qv__color-row">
                  {g.options.map((opt) => {
                    const selected = variants[g.id] === opt.id;
                    return (
                      <button
                        key={opt.id}
                        type="button"
                        className={"qv__color" + (selected ? " qv__color--selected" : "")}
                        style={{ background: opt.hex || "#888" }}
                        onClick={() => pick(g.id, opt.id)}
                        title={opt.label}
                        aria-pressed={selected}
                      />
                    );
                  })}
                </div>
              ) : (
                <ul className="qv__options">
                  {g.options.map((opt) => {
                    const selected = variants[g.id] === opt.id;
                    return (
                      <li key={opt.id}>
                        <label className={"qv__opt" + (selected ? " qv__opt--selected" : "")}>
                          <input
                            type="radio"
                            name={"qv-" + g.id}
                            checked={selected}
                            onChange={() => pick(g.id, opt.id)}
                          />
                          <span className="qv__opt-label">{opt.label}</span>
                          {opt.priceDelta ? (
                            <span className="qv__opt-delta">
                              {opt.priceDelta > 0 ? "+" : ""}{fmt(opt.priceDelta)}
                            </span>
                          ) : null}
                        </label>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          ))}

          <div className="qv__total">
            <span>Total</span>
            <strong>
              {pricing.hasPromo && <span className="product-card__price-old" style={{ marginRight: 8 }}>{fmt(pricing.originalBase + pricing.delta)}</span>}
              {fmt(pricing.total)}
            </strong>
          </div>

          {(() => {
            const stock = stockFor(product, variants);
            const oos = stock !== null && stock <= 0;
            return (
              <>
                {oos && (
                  <div className="qv__produce-note">
                    <strong>Sin stock — se produce a pedido.</strong>
                    <span>Puede demorar 4-5 días hábiles más, además del tiempo de envío.</span>
                  </div>
                )}
                <button
                  className="btn btn--primary btn--block qv__cta"
                  onClick={() => onConfirm(product, variants, oos)}
                >
                  {oos ? <>Agregar a pedido {I.arrowRight}</> : <>Agregar al carrito {I.arrowRight}</>}
                </button>
              </>
            );
          })()}

          <div className="qv__ship">
            <p className="qv__group-label">Calcular envío</p>
            <div className="qv__ship-row">
              <input
                className="qv__ship-input"
                type="text"
                inputMode="numeric"
                maxLength={4}
                placeholder="Código postal"
                value={cp}
                onChange={(e) => { setCp(e.target.value.replace(/\D/g, "")); setShipErr(null); }}
                onKeyDown={(e) => { if (e.key === "Enter") handleQuote(); }}
              />
              <button
                type="button"
                className="btn btn--ghost qv__ship-btn"
                onClick={handleQuote}
                disabled={ship.loading || !cpValid}
              >
                {ship.loading ? "Cotizando…" : "Calcular"}
              </button>
            </div>
            {shipErr && <p className="qv__ship-err">{shipErr}</p>}
            {ship.quotes.length > 0 && (
              <ul className="qv__quotes">
                {ship.quotes.map((q, i) => (
                  <li key={i} className="qv__quote">
                    <div className="qv__quote-info">
                      <p className="qv__quote-name">
                        {q.carrier === "correo_argentino" ? "Correo Argentino" : "Mercado Envíos"}
                        {" · "}
                        {q.service === "domicilio" ? "Domicilio" : "Sucursal"}
                      </p>
                      <p className="qv__quote-eta">{q.eta_days.min}–{q.eta_days.max} días hábiles</p>
                    </div>
                    <span className="qv__quote-price">{fmt(q.cost)}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </aside>
    </>
  );
}

/* ===================== Root App ===================== */
function App() {
  const auth = useAuth();
  const { products, loading: productsLoading } = useProducts();
  const cart = useCart(auth.user);
  const route = useHashRoute();

  const [cartOpen, setCartOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const [lampsFilter, setLampsFilter] = useState("all");
  // Quick-view: { product, initial: selectedVariants } | null
  const [quickView, setQuickView] = useState(null);

  // Hidrato items del carrito con datos del producto.
  const cartItemsHydrated = useMemo(
    () => cart.items.map((it) => {
      const product = products.find((p) => p.id === it.productId);
      return { ...it, product };
    }),
    [cart.items, products],
  );

  const cartCount = cart.items.reduce((s, it) => s + it.qty, 0);

  const lamps = useMemo(() => {
    const all = products.filter((p) => p.line === "lamps");
    if (lampsFilter === "new") return all.filter((p) => p.badge === "Nuevo" || p.badge === "Edición limitada");
    if (lampsFilter === "best") return all.filter((p) => p.badge === "Bestseller");
    return all;
  }, [products, lampsFilter]);

  const accs = useMemo(() => products.filter((p) => p.line === "accs"), [products]);

  const onAdd = (product, variants, produce) => cart.add(product.id, variants || null, !!produce);
  const onOpenQuickView = (product, initial) => setQuickView({ product, initial });
  const onQty = (productId, delta, variants) => cart.changeQty(productId, delta, variants);
  const onCheckout = () => { setCartOpen(false); navigate("#/checkout"); };

  // Lock scroll cuando hay overlay abierto
  useEffect(() => {
    const locked = cartOpen || loginOpen;
    document.body.style.overflow = locked ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [cartOpen, loginOpen]);

  // ===== Routing =====
  if (route.name === "checkout") {
    return (
      <div className="page page--checkout">
        <Header
          cartCount={cartCount}
          onCartClick={() => setCartOpen(true)}
          user={auth.user}
          isAdmin={auth.isAdmin}
          refreshClaims={auth.refreshClaims}
          onLoginClick={() => setLoginOpen(true)}
          onLogout={() => auth.signOut()}
        />
        <CheckoutView products={products} cart={cart} user={auth.user} />
        <Footer />
        <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
      </div>
    );
  }

  if (route.name === "order") {
    return (
      <div className="page page--order">
        <Header
          cartCount={cartCount}
          onCartClick={() => setCartOpen(true)}
          user={auth.user}
          isAdmin={auth.isAdmin}
          refreshClaims={auth.refreshClaims}
          onLoginClick={() => setLoginOpen(true)}
          onLogout={() => auth.signOut()}
        />
        <OrderView orderId={route.orderId} />
        <Footer />
        <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
      </div>
    );
  }

  if (route.name === "admin") {
    // Dashboard a pantalla completa: sin Header/Footer de la tienda. El propio
    // panel (AdminView → AdminDashboard) trae su sidebar y topbar.
    return (
      <div className="page page--admin">
        <AdminView
          user={auth.user}
          isAdmin={auth.isAdmin}
          authLoading={auth.loading}
          refreshClaims={auth.refreshClaims}
          onRequestLogin={() => setLoginOpen(true)}
        />
        <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
      </div>
    );
  }

  if (route.name === "profile" || route.name === "myOrders") {
    const ViewCmp = route.name === "profile" ? ProfileView : MyOrdersView;
    return (
      <div className={"page page--" + route.name}>
        <Header
          cartCount={cartCount}
          onCartClick={() => setCartOpen(true)}
          user={auth.user}
          isAdmin={auth.isAdmin}
          refreshClaims={auth.refreshClaims}
          onLoginClick={() => setLoginOpen(true)}
          onLogout={() => auth.signOut()}
        />
        <ViewCmp user={auth.user} />
        <Footer />
        <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
      </div>
    );
  }

  // === Home ===
  return (
    <div className="page">
      <div className="ambient-orbs"><span /><span /><span /></div>
      <Header
        cartCount={cartCount}
        onCartClick={() => setCartOpen(true)}
        user={auth.user}
        onLoginClick={() => setLoginOpen(true)}
        onLogout={() => auth.signOut()}
      />
      <Hero
        products={products}
        onShopClick={() => {
          const el = document.getElementById("lamps");
          if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
        }}
      />
      {productsLoading ? (
        <CatalogSkeleton />
      ) : (
        <>
          <ProductSection
            id="lamps"
            eyebrow="Línea principal"
            title="Lámparas LED"
            sub="Piezas impresas con plástico bio-degradable translúcido y módulos LED regulables de bajo consumo."
            products={lamps}
            onAdd={onAdd}
            onOpenQuickView={onOpenQuickView}
            density={lampsFilter}
            onDensityChange={setLampsFilter}
          />
          <PromoStrip />
          <ProductSection
            id="accessories"
            eyebrow="Línea secundaria"
            title="Accesorios de diseño"
            sub="Floreros, bowls, maceteros y objetos para la casa. Mismas geometrías."
            products={accs}
            onAdd={onAdd}
            onOpenQuickView={onOpenQuickView}
          />
        </>
      )}
      <Footer />
      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        items={cartItemsHydrated}
        onQty={onQty}
        onCheckout={onCheckout}
      />
      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
      <QuickView
        view={quickView}
        onClose={() => setQuickView(null)}
        onConfirm={(product, variants, produce) => {
          onAdd(product, variants, produce);
          setQuickView(null);
        }}
      />
      <PlasmaTweaks />
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <ErrorBoundary><App /></ErrorBoundary>
);
